<nz-spin [nzSpinning]="isSubmittingImportJob" [nzTip]="'PROPERTY_IMPORT.CREATING_JOB' | translate">
  <div style="padding: 20px;">
    <div class="property-list-header">
      <div>
        <h2 class="property-list-title">
          {{ 'PROPERTY_LIST.TITLE' | translate }}
          <ng-container *ngIf="propertiesPagination.total !== allProperties.length; else totalOnly">
            ({{ 'PROPERTY_LIST.SHOWING_OF' | translate:{ showing: propertiesPagination.total, total: allProperties.length } }})
          </ng-container>
          <ng-template #totalOnly>
            ({{ allProperties.length }})
          </ng-template>
        </h2>

        <div class="property-license" *ngIf="licensedMaxProperties !== null">
          <div class="property-license__row">
            <span class="property-license__label">{{ 'PROPERTY_LIST.LICENSE_USAGE_LABEL' | translate }}</span>

            <span class="property-license__value">
          {{ 'PROPERTY_LIST.LICENSE_USAGE_TEXT' | translate:{ used: usedPropertiesCount, max: licensedMaxProperties } }}
        </span>

            <span class="property-license__dot">•</span>

            <nz-badge
              [nzCount]="remainingPropertiesCount ?? 0"
              [nzOverflowCount]="9999"
              [nzShowZero]="true"
            ></nz-badge>

            <span class="property-license__remaining">
          {{ 'PROPERTY_LIST.LICENSE_REMAINING_TEXT' | translate }}
        </span>
          </div>

          <nz-progress
            nzSize="small"
            [nzPercent]="licenseUsagePercent"
            [nzShowInfo]="false"
          ></nz-progress>

          <div class="property-license__actions" *ngIf="canManagePropertyLicense">
            <button nz-button nzType="default" type="button" (click)="openIncreasePropertyLimitModal()">
              {{ 'PROPERTY_LIST.INCREASE_LIMIT.BUTTON' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Buttons for Adding and Importing Properties with Spacing -->
    <div class="table-actions" style="margin-bottom: 20px;" data-tour="properties-primary-actions">
      <!-- Add Property Button -->
      <button
        *ngIf="appMode === 'hospitality' || (appMode === 'emergency' && hasAnyHeadersConfigured)"
        nz-button
        nzType="primary"
        nz-tooltip
        nzTooltipTitle="{{ 'PROPERTY_LIST.ADD' | translate }}"
        (click)="toggleAddModal()"
        style="margin-right: 10px;"
      >
        <span nz-icon nzType="plus"></span> {{ 'PROPERTY_LIST.ADD' | translate }}
      </button>

      <!-- Download Excel Template Button -->
      <button
        nz-button
        nzType="primary"
        nz-tooltip
        nzTooltipTitle="{{ 'PROPERTY_LIST.CONFIGURE_LANDING_PAGE' | translate }}"
        *ngIf="appMode === 'emergency'"
        (click)="openWizard()"
        style="margin-right: 10px;"
      >
        <span nz-icon nzType="setting"></span> {{ 'PROPERTY_LIST.CONFIGURE_LANDING_PAGE' | translate }}
      </button>
      <ng-container
        *ngIf="appMode === 'emergency' && savedHeaders && savedHeaders.caretakerHeaders && savedHeaders.caretakerHeaders.length > 0"
      >
        <!-- Download Excel Template Button -->
        <button
          nz-button
          nzType="primary"
          nz-tooltip
          nzTooltipTitle="{{ 'PROPERTY_LIST.DOWNLOAD_TEMPLATE' | translate }}"
          (click)="openDownloadTemplateModal()"
        >
          <span nz-icon nzType="download"></span> {{ 'PROPERTY_LIST.DOWNLOAD_TEMPLATE' | translate }}
        </button>

        <!-- Import Properties Button -->
        <button
          nz-button nzType="primary"
          nz-tooltip
          nzTooltipTitle="{{ 'PROPERTY_LIST.IMPORT' | translate }}"
          (click)="openImportConfirmModal()"
          [nzLoading]="isImportBusy"
          [disabled]="isImportBusy"
          style="margin-left: 10px;"
        >
          <span nz-icon nzType="upload"></span> {{ 'PROPERTY_LIST.IMPORT' | translate }}
        </button>
      </ng-container>

      <!-- Button to Generate All QR Codes in a Single PDF -->
      <button
        *ngIf="properties && properties.length > 0"
        nz-button
        nzType="primary"
        nz-tooltip
        nzTooltipTitle="{{ 'PROPERTY_LIST.GENERATE_ALL_QR' | translate }}"
        (click)="openAllQrDownloadChoiceModal()"
        style="margin-left: 10px;"
      >
        <span nz-icon nzType="qrcode"></span> {{ 'PROPERTY_LIST.GENERATE_ALL_QR' | translate }}
      </button>

      <nz-modal
        [(nzVisible)]="allQrDownloadChoiceVisible"
        [nzTitle]="'PROPERTY_LIST.QR_DOWNLOAD_CHOICE.TITLE' | translate"
        [nzFooter]="null"
        [nzClosable]="!allQrDownloadLoading && !allQrZipLoading"
        [nzMaskClosable]="!allQrDownloadLoading && !allQrZipLoading"
        (nzOnCancel)="closeAllQrDownloadChoiceModal()"
        nzWidth="480"
      >
        <ng-container *nzModalContent>
          <p class="qr-download-choice-description">
            {{ 'PROPERTY_LIST.QR_DOWNLOAD_CHOICE.DESCRIPTION' | translate }}
          </p>

          <div class="qr-selection-container" *ngIf="allProperties.length">
            <input
              class="qr-selection-search"
              nz-input
              type="text"
              [placeholder]="'PROPERTY_LIST.QR_DOWNLOAD_CHOICE.SEARCH_PROPERTIES' | translate"
              [ngModel]="qrSelectionSearchText"
              (ngModelChange)="onQrSelectionSearchChange($event)"
            />

            <div class="qr-selection-toolbar">
              <div class="qr-selection-toolbar__group">
                <span class="qr-selection-toolbar__label">{{ 'PROPERTY_LIST.QR_DOWNLOAD_CHOICE.GROUP_BY' | translate }}</span>
                <nz-radio-group [ngModel]="qrSelectionGroupBy" (ngModelChange)="onQrSelectionGroupByChange($event)" nzSize="small">
                  <label nz-radio-button nzValue="none" nz-tooltip [nzTooltipTitle]="'PROPERTY_LIST.QR_DOWNLOAD_CHOICE.GROUP_NONE_TOOLTIP' | translate">{{ 'PROPERTY_LIST.QR_DOWNLOAD_CHOICE.GROUP_NONE' | translate }}</label>
                  <label nz-radio-button nzValue="city" nz-tooltip [nzTooltipTitle]="'PROPERTY_LIST.QR_DOWNLOAD_CHOICE.GROUP_CITY_TOOLTIP' | translate">{{ 'PROPERTY_LIST.QR_DOWNLOAD_CHOICE.GROUP_CITY' | translate }}</label>
                  <label nz-radio-button nzValue="zipcode" nz-tooltip [nzTooltipTitle]="'PROPERTY_LIST.QR_DOWNLOAD_CHOICE.GROUP_ZIP_TOOLTIP' | translate">{{ 'PROPERTY_LIST.QR_DOWNLOAD_CHOICE.GROUP_ZIP' | translate }}</label>
                  <label *ngIf="showQrProfileGrouping" nz-radio-button nzValue="profile" nz-tooltip [nzTooltipTitle]="'PROPERTY_LIST.QR_DOWNLOAD_CHOICE.GROUP_PROFILE_TOOLTIP' | translate">{{ 'PROPERTY_LIST.QR_DOWNLOAD_CHOICE.GROUP_PROFILE' | translate }}</label>
                </nz-radio-group>
              </div>
              <div class="qr-selection-toolbar__group qr-selection-toolbar__group--template" *ngIf="showQrPosterTemplateSelector">
                <span class="qr-selection-toolbar__label">
                  {{ 'PROPERTY_LIST.QR_DOWNLOAD_CHOICE.TEMPLATE' | translate }}
                  <span
                    nz-icon
                    nzType="info-circle"
                    class="qr-selection-toolbar__info-icon"
                    nz-tooltip
                    [nzTooltipTitle]="'PROPERTY_LIST.QR_DOWNLOAD_CHOICE.TEMPLATE_TOOLTIP' | translate"
                  ></span>
                </span>
                <nz-select [(ngModel)]="selectedQrPosterTemplateId" nzSize="small">
                  <nz-option
                    [nzLabel]="'PROPERTY_LIST.QR_DOWNLOAD_CHOICE.TEMPLATE_CURRENT_DEFAULT' | translate"
                    [nzValue]="automaticQrPosterTemplateValue"
                  ></nz-option>
                  <nz-option
                    *ngFor="let template of savedQrPosterTemplates"
                    [nzLabel]="template.name"
                    [nzValue]="template.id"
                  ></nz-option>
                </nz-select>
              </div>
            </div>

            <div class="qr-selection-summary">
              <ng-container *ngIf="hasQrSelectionSearch; else noSearchSummary">
                {{ 'PROPERTY_LIST.QR_DOWNLOAD_CHOICE.SELECTED_FILTERED_COUNT' | translate:{ matching: qrSelectionViewModel.selectedFilteredCount, matchingTotal: qrSelectionViewModel.filteredCount, total: qrSelectionViewModel.selectedTotalCount, totalAll: qrSelectionViewModel.totalCount } }}
              </ng-container>
              <ng-template #noSearchSummary>
                {{ 'PROPERTY_LIST.QR_DOWNLOAD_CHOICE.SELECTED_COUNT' | translate:{ selected: qrSelectionViewModel.selectedTotalCount, total: qrSelectionViewModel.totalCount } }}
              </ng-template>
            </div>

            <div class="qr-selection-actions">
              <ng-container *ngIf="hasQrSelectionSearch; else noSearchButtons">
                <button nz-button nzSize="small" (click)="selectQrVisible()" [disabled]="qrSelectionBusy">
                  {{ 'PROPERTY_LIST.QR_DOWNLOAD_CHOICE.SELECT_MATCHING' | translate:{ count: qrSelectionViewModel.filteredCount } }}
                </button>
                <button nz-button nzSize="small" (click)="clearQrVisible()" [disabled]="qrSelectionBusy">
                  {{ 'PROPERTY_LIST.QR_DOWNLOAD_CHOICE.CLEAR_MATCHING' | translate:{ count: qrSelectionViewModel.filteredCount } }}
                </button>
                <button nz-button nzSize="small" (click)="selectAllQrProperties()" [disabled]="qrSelectionBusy">
                  {{ 'PROPERTY_LIST.QR_DOWNLOAD_CHOICE.SELECT_ALL_COUNT' | translate:{ count: qrSelectionViewModel.totalCount } }}
                </button>
                <button nz-button nzSize="small" (click)="clearAllQrSelection()" [disabled]="qrSelectionBusy">
                  {{ 'PROPERTY_LIST.QR_DOWNLOAD_CHOICE.CLEAR_ALL_COUNT' | translate:{ count: qrSelectionViewModel.totalCount } }}
                </button>
              </ng-container>
              <ng-template #noSearchButtons>
                <button nz-button nzSize="small" (click)="selectAllQrProperties()" [disabled]="qrSelectionBusy">
                  {{ 'PROPERTY_LIST.QR_DOWNLOAD_CHOICE.SELECT_ALL_PROPERTIES' | translate }}
                </button>
                <button nz-button nzSize="small" (click)="clearAllQrSelection()" [disabled]="qrSelectionBusy">
                  {{ 'PROPERTY_LIST.QR_DOWNLOAD_CHOICE.CLEAR_ALL' | translate }}
                </button>
              </ng-template>
            </div>

            <nz-spin *ngIf="qrSelectionBusy || qrSelectionViewModel.filteredCount > 0" [nzSpinning]="qrSelectionBusy">
              <div
                class="qr-selection-list"
                *ngIf="qrSelectionViewModel.groups.length"
                [class.qr-selection-list--busy]="qrSelectionBusy"
              >
                <ng-container *ngFor="let group of qrSelectionViewModel.groups; trackBy: trackByQrSelectionGroup">
                  <div class="qr-selection-group" *ngIf="qrSelectionGroupBy !== 'none'">
                    <span class="qr-selection-group__toggle" (click)="toggleQrGroupExpand(group.key)">
                      <i nz-icon [nzType]="qrExpandedGroupKeys.has(group.key) ? 'down' : 'right'"></i>
                    </span>
                    <label
                      nz-checkbox
                      [nzChecked]="group.allSelected"
                      [nzIndeterminate]="group.someSelected"
                      (nzCheckedChange)="toggleQrGroup(group)"
                    >
                      <span class="qr-selection-group__label">{{ group.label }}</span>
                      <span class="qr-selection-group__count">{{ group.selectedCount }} / {{ group.totalCount }}</span>
                    </label>
                  </div>
                  <ng-container *ngIf="qrSelectionGroupBy === 'none' || qrExpandedGroupKeys.has(group.key)">
                    <label
                      class="qr-selection-property"
                      *ngFor="let p of group.properties; trackBy: trackByQrSelectionProperty"
                      nz-checkbox
                      [nzChecked]="qrSelectionPropertyIds.has(p._id)"
                      (nzCheckedChange)="toggleQrProperty(p._id)"
                       [title]="p.displayLabel"
                     >
                       <span class="qr-selection-property__text">{{ p.displayLabel }}</span>
                    </label>
                  </ng-container>
                </ng-container>
              </div>
            </nz-spin>
          </div>

          <div class="qr-download-choice-actions">
            <button
              nz-button
              nzType="primary"
              [nzLoading]="allQrDownloadLoading"
              [disabled]="allQrZipLoading || allQrDownloadLoading || !qrSelectionViewModel.selectedTotalCount || qrSelectionBusy"
              (click)="downloadAllQrCodesAsSinglePdf()"
            >
              {{ 'PROPERTY_LIST.QR_DOWNLOAD_CHOICE.DOWNLOAD_SELECTED_ONE_PDF' | translate }}
            </button>

            <button
              nz-button
              nzType="default"
              [nzLoading]="allQrZipLoading"
              [disabled]="allQrDownloadLoading || allQrZipLoading || !qrSelectionViewModel.selectedTotalCount || qrSelectionBusy"
              (click)="downloadAllQrCodesAsZip()"
            >
              {{ 'PROPERTY_LIST.QR_DOWNLOAD_CHOICE.DOWNLOAD_SELECTED_ZIP' | translate }}
            </button>

            <button
              nz-button
              nzType="link"
              [disabled]="allQrDownloadLoading || allQrZipLoading"
              (click)="closeAllQrDownloadChoiceModal()"
            >
              {{ 'PROPERTY_LIST.QR_DOWNLOAD_CHOICE.CANCEL' | translate }}
            </button>
          </div>
        </ng-container>
      </nz-modal>

      <!-- Hidden file input to handle Excel file upload -->
      <input type="file" #fileInput style="display: none;" (change)="importProperties($event)" accept=".xlsx, .xls" />

    </div>

    <nz-modal
      [(nzVisible)]="increasePropertyLimitModalVisible"
      [nzTitle]="'PROPERTY_LIST.INCREASE_LIMIT.TITLE' | translate"
      [nzOkText]="'PROPERTY_LIST.INCREASE_LIMIT.CONFIRM' | translate"
      [nzCancelText]="'PROPERTY_LIST.CANCEL' | translate"
      [nzOkLoading]="increasePropertyLimitSubmitting"
      [nzOkDisabled]="!increasePropertyLimitForm || increasePropertyLimitForm.invalid || !!propertyLimitIncreaseValidationMessage"
      (nzOnCancel)="closeIncreasePropertyLimitModal()"
      (nzOnOk)="submitIncreasePropertyLimit()"
    >
      <ng-container *nzModalContent>
        <form nz-form nzLayout="vertical" [formGroup]="increasePropertyLimitForm">
          <div class="property-limit-modal__summary">
            <div class="property-limit-modal__card">
              <span>{{ 'PROPERTY_LIST.INCREASE_LIMIT.CURRENT_MAX' | translate }}</span>
              <strong>{{ licensedMaxProperties }}</strong>
            </div>
            <div class="property-limit-modal__card">
              <span>{{ 'PROPERTY_LIST.INCREASE_LIMIT.USED' | translate }}</span>
              <strong>{{ usedPropertiesCount }}</strong>
            </div>
            <div class="property-limit-modal__card">
              <span>{{ 'PROPERTY_LIST.INCREASE_LIMIT.REMAINING' | translate }}</span>
              <strong>{{ remainingPropertiesCount ?? 0 }}</strong>
            </div>
            <div class="property-limit-modal__card property-limit-modal__card--price" *ngIf="propertyUnitPriceNetYear">
              <span class="property-limit-modal__card-label">
                <span>{{ 'PROPERTY_LIST.INCREASE_LIMIT.UNIT_PRICE' | translate }}</span>
                <small>{{ 'PROPERTY_LIST.INCREASE_LIMIT.EUR_PER_YEAR' | translate }}</small>
              </span>
              <strong>{{ formatMoney(propertyUnitPriceNetYear) }}</strong>
            </div>
          </div>

          <nz-form-item>
            <nz-form-label>{{ 'PROPERTY_LIST.INCREASE_LIMIT.NEW_TOTAL_LABEL' | translate }}</nz-form-label>
            <nz-form-control [nzErrorTip]="propertyLimitIncreaseValidationMessage || undefined">
              <nz-input-number
                formControlName="newMaxProperties"
                [nzMin]="1"
                [nzStep]="1"
                [nzPrecision]="0"
                class="property-limit-modal__input"
              ></nz-input-number>
            </nz-form-control>
          </nz-form-item>

          <label nz-checkbox formControlName="confirmedImmediateInvoice" class="property-limit-modal__checkbox">
            {{ 'PROPERTY_LIST.INCREASE_LIMIT.CONFIRM_IMMEDIATE_INVOICE' | translate }}
          </label>
          <div class="property-limit-modal__checkbox-error" *ngIf="propertyLimitIncreaseConfirmationErrorMessage">
            {{ propertyLimitIncreaseConfirmationErrorMessage }}
          </div>

          <p class="property-limit-modal__note">
            {{ 'PROPERTY_LIST.INCREASE_LIMIT.REDUCTION_NOTE' | translate }}
          </p>
        </form>
      </ng-container>
    </nz-modal>

    <app-property-import-progress
      [job]="currentImportJob"
      [dismissible]="canDismissCurrentImportJob"
      [autoDismissCountdownSeconds]="currentImportJob?.status === 'completed' ? importSuccessDismissCountdownSeconds : null"
      (dismiss)="dismissCurrentImportJob()"
    ></app-property-import-progress>
    <nz-alert
      *ngIf="historicalImportResultUnavailable"
      nzType="warning"
      nzShowIcon
      [nzMessage]="'PROPERTY_IMPORT.HISTORICAL_RESULT_UNAVAILABLE' | translate"
    ></nz-alert>

    <!-- Search Bar -->
    <div
      *ngIf="allProperties.length"
      class="property-search-bar"
    >
      <nz-input-group
        class="property-global-search"
        [nzPrefix]="globalSearchPrefix"
        [nzSuffix]="globalSearchSuffix"
      >
        <input
          nz-input
          [placeholder]="'SEARCH.GLOBAL_PLACEHOLDER' | translate"
          [(ngModel)]="searchTerms.globalTerm"
          (ngModelChange)="onSearchDebounced()"
          (keydown.escape)="clearGlobalSearch()"
        />
      </nz-input-group>

      <ng-template #globalSearchPrefix>
        <span nz-icon nzType="search"></span>
      </ng-template>

      <ng-template #globalSearchSuffix>
        <button
          *ngIf="searchTerms.globalTerm"
          nz-button
          nzType="text"
          nzSize="small"
          type="button"
          class="property-global-search__clear"
          [attr.aria-label]="'COMMON.CLEAR' | translate"
          (click)="clearGlobalSearch()"
        >
          <span nz-icon nzType="close-circle" nzTheme="fill"></span>
        </button>
      </ng-template>

      <button
        *ngIf="hasActiveNonGlobalPropertySearchFilters()"
        nz-button
        nzType="default"
        type="button"
        (click)="clearAllPropertySearchFilters()"
      >
        <span nz-icon nzType="clear"></span>
        {{ 'COMMON.CLEAR_FILTERS' | translate }}
      </button>
    </div>

    <!-- Adjusted Table -->
    <ng-container *ngIf="appMode === 'emergency'">
      <nz-table
        *ngIf="properties.length || isLoading || isPropertiesTableLoading; else noEmergencyProperties"
        [nzData]="properties"
      [nzLoading]="isLoading || isPropertiesTableLoading"
      [nzShowPagination]="false"
      nzBordered
      nzTableLayout="fixed"
      [nzScroll]="{ x: totalWidth + 'px' }"
      class="property-list-table"
    >
      <thead>
      <!-- First Header Row for Grouping -->
      <tr>
        <!-- Address Details Group Header -->
        <th colspan="3" class="wrap-header">{{ 'PROPERTY_LIST.ADDRESS_DETAILS' | translate }}</th>

        <!-- Haus Column (Haussoft) -->
        <th *ngIf="showHausColumn" class="wrap-header" rowspan="2" nzWidth="100px">
          {{ 'PROPERTY_LIST.HAUS_CODE' | translate }}
        </th>

        <!-- Property Managers Group Header with dynamic colspan -->
        <ng-container *ngIf="dynamicHeaders?.propertyManagerHeaders?.length">
          <th [attr.colspan]="dynamicHeaders?.propertyManagerHeaders?.length" class="wrap-header">
            {{ 'PROPERTY_LIST.PROPERTY_MANAGER' | translate }}
          </th>
        </ng-container>

        <!-- Technical Assets Managers Group Header with dynamic colspan -->
        <ng-container *ngIf="dynamicHeaders?.technicalAssetsManagerHeaders?.length">
          <th [attr.colspan]="dynamicHeaders?.technicalAssetsManagerHeaders?.length" class="wrap-header">
            {{ 'PROPERTY_LIST.TECHNICAL_ASSETS_MANAGER' | translate }}
          </th>
        </ng-container>

        <ng-container *ngIf="dynamicHeaders?.sevManagerHeaders?.length">
          <th [attr.colspan]="dynamicHeaders?.sevManagerHeaders?.length" class="wrap-header">
            {{ 'PROPERTY_LIST.CONDOMINIUM_MANAGER' | translate }}
          </th>
        </ng-container>

        <ng-container *ngIf="dynamicHeaders?.accountantHeaders?.length">
          <th [attr.colspan]="dynamicHeaders?.accountantHeaders?.length" class="wrap-header">
            {{ 'PROPERTY_LIST.ACCOUNTANT' | translate }}
          </th>
        </ng-container>

        <!-- Caretaker Group Header -->
        <th colspan="4" class="wrap-header">{{ 'PROPERTY_LIST.CARETAKER' | translate }}</th>

        <!-- Technical Services Group Headers -->
        <ng-container *ngFor="let service of dynamicHeaders?.technicalServiceHeaders">
          <th colspan="2" class="wrap-header">{{ ('TECHNICAL_SERVICES.' + (service | replaceSlashWithUnderscore)) | translate }}</th>
        </ng-container>

        <!-- Actions Column -->
        <th nzRight rowspan="2" class="wrap-header" nzWidth="190px">{{ 'PROPERTY_LIST.ACTIONS' | translate }}</th>
      </tr>

      <!-- Second Header Row for Sub-Headings and Search Inputs -->
      <tr>
        <!-- Street -->
        <th class="wrap-header" nzWidth="320px" nzColumnKey="street" [nzSortOrder]="propertiesSort.value"
            (nzSortOrderChange)="onPropertiesSortChange('street', $event)"
        >
          {{ 'PROPERTY_LIST.STREET' | translate }}
          <br />
          <input
            nz-input
            placeholder="{{ 'SEARCH.STREET' | translate }}"
            [(ngModel)]="searchTerms.street"
            (ngModelChange)="onSearchDebounced()"
            style="width: 60%;"
          />
        </th>

        <!-- Zipcode -->
        <th class="wrap-header" nzWidth="320px" nzColumnKey="zipcode" [nzSortOrder]="propertiesSort.value"
            (nzSortOrderChange)="onPropertiesSortChange('zipcode', $event)">
          {{ 'PROPERTY_LIST.ZIPCODE' | translate }}
          <br />
          <input
            nz-input
            placeholder="{{ 'SEARCH.ZIPCODE' | translate }}"
            [(ngModel)]="searchTerms.zipcode"
            (ngModelChange)="onSearchDebounced()"
            style="width: 73%;"
          />
        </th>

        <!-- City -->
        <th class="wrap-header" nzWidth="320px" nzColumnKey="city" [nzSortOrder]="propertiesSort.value"
            (nzSortOrderChange)="onPropertiesSortChange('city', $event)">
          {{ 'PROPERTY_LIST.CITY' | translate }}
          <br />
          <input
            nz-input
            placeholder="{{ 'SEARCH.CITY' | translate }}"
            [(ngModel)]="searchTerms.city"
            (ngModelChange)="onSearchDebounced()"
            style="width: 54%;"
          />
        </th>

        <!-- Property Managers Sub-Headers -->
        <ng-container *ngFor="let pmHeader of resolvedDynamicHeaders.propertyManagerHeaders">
          <th class="wrap-header" nzWidth="180px">
            {{ pmHeader | translate }}
          </th>
        </ng-container>

        <!-- Technical Assets Managers Sub-Headers -->
        <ng-container *ngIf="dynamicHeaders?.technicalAssetsManagerHeaders?.length">
          <ng-container *ngFor="let tamHeader of dynamicHeaders?.technicalAssetsManagerHeaders">
            <th class="wrap-header" nzWidth="180px">
              {{ tamHeader | translate }}
            </th>
          </ng-container>
        </ng-container>

        <ng-container *ngIf="dynamicHeaders?.sevManagerHeaders?.length">
          <ng-container *ngFor="let sevHeader of dynamicHeaders?.sevManagerHeaders">
            <th class="wrap-header" nzWidth="180px">
              {{ sevHeader | translate }}
            </th>
          </ng-container>
        </ng-container>

        <ng-container *ngIf="dynamicHeaders?.accountantHeaders?.length">
          <ng-container *ngFor="let accountantHeader of dynamicHeaders?.accountantHeaders">
            <th class="wrap-header" nzWidth="180px">
              {{ accountantHeader | translate }}
            </th>
          </ng-container>
        </ng-container>

        <!-- Caretaker Sub-Headers -->
        <th class="wrap-header" nzWidth="180px" nzColumnKey="caretakerName" [nzSortOrder]="propertiesSort.value"
            (nzSortOrderChange)="onPropertiesSortChange('caretakerName', $event)">{{ 'PROPERTY_LIST.NAME' | translate }}</th>
        <th class="wrap-header" nzWidth="180px">{{ 'COMPANY_PAGE.PHONE' | translate }}</th>
        <th class="wrap-header" nzWidth="180px">{{ 'LOGIN.EMAIL' | translate }}</th>
        <th class="wrap-header" nzWidth="180px">{{ 'PROPERTY_LIST.ADDRESS' | translate }}</th>

        <!-- Technical Services Sub-Headers -->
        <ng-container *ngFor="let serviceHeader of dynamicHeaders?.technicalServiceHeaders">
          <th class="wrap-header" nzWidth="180px">{{ 'PROPERTY_LIST.NAME' | translate }}</th>
          <th class="wrap-header" nzWidth="180px">{{ 'COMPANY_PAGE.PHONE' | translate }}</th>
        </ng-container>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let property of properties; trackBy: trackByPropertyId">
        <!-- Split Address Details -->
        <td class="wrap-cell" nz-tooltip [nzTooltipTitle]="splitAddress(property.address).street">
          {{ splitAddress(property.address).street }}
        </td>
        <td class="wrap-cell" nz-tooltip [nzTooltipTitle]="splitAddress(property.address).zipcode">
          {{ splitAddress(property.address).zipcode }}
        </td>
        <td class="wrap-cell" nz-tooltip [nzTooltipTitle]="splitAddress(property.address).city">
          {{ splitAddress(property.address).city }}
        </td>

        <td *ngIf="showHausColumn" class="wrap-cell" nz-tooltip [nzTooltipTitle]="getHaussoftHausCode(property) || ''">
          {{ getHaussoftHausCode(property) || '' }}
        </td>

        <!-- Property Managers Information with placeholders -->
        <ng-container *ngFor="let pmHeader of resolvedDynamicHeaders.propertyManagerHeaders">
          <td class="wrap-cell"
              [ngStyle]="{ color: isNA(getPropertyManagerField(property, pmHeader)) ? 'grey' : 'inherit' }"
              nz-tooltip
              [nzTooltipTitle]="managerKeyMapping[pmHeader] === 'phone'
      ? (formatGermanPhoneNumber(getPropertyManagerField(property, pmHeader) ?? undefined) || 'N/A')
      : (getPropertyManagerField(property, pmHeader) || 'N/A')"
          >
            <!-- Check if pmHeader corresponds to the phone field, and format it if so -->
            <ng-container *ngIf="managerKeyMapping[pmHeader] === 'phone'; else pmDisplayField">
              {{ formatGermanPhoneNumber(getPropertyManagerField(property, pmHeader) ?? undefined) || 'N/A' }}
            </ng-container>
            <ng-template #pmDisplayField>
              {{ getPropertyManagerField(property, pmHeader) || 'N/A' }}
            </ng-template>
          </td>
        </ng-container>


        <!-- Technical Assets Managers Information with placeholders -->
        <ng-container *ngIf="resolvedDynamicHeaders.technicalAssetsManagerHeaders?.length">
          <ng-container *ngFor="let pmHeader of resolvedDynamicHeaders.technicalAssetsManagerHeaders">
            <td class="wrap-cell"
                [ngStyle]="{ color: isNA(getTechnicalAssetsManagerField(property, pmHeader)) ? 'grey' : 'inherit' }"
                nz-tooltip
                [nzTooltipTitle]="technicalAssetsManagerKeyMapping[pmHeader] === 'phone'
      ? (formatGermanPhoneNumber(getTechnicalAssetsManagerField(property, pmHeader) ?? undefined) || 'N/A')
      : (getTechnicalAssetsManagerField(property, pmHeader) || 'N/A')"
            >
              <!-- Check if pmHeader corresponds to the phone field, and format it if so -->
              <ng-container *ngIf="technicalAssetsManagerKeyMapping[pmHeader] === 'phone'; else tamDisplayField">
                {{ formatGermanPhoneNumber(getTechnicalAssetsManagerField(property, pmHeader) ?? undefined) || 'N/A' }}
              </ng-container>
              <ng-template #tamDisplayField>
                {{ getTechnicalAssetsManagerField(property, pmHeader) || 'N/A' }}
              </ng-template>
            </td>
          </ng-container>
        </ng-container>

        <ng-container *ngIf="resolvedDynamicHeaders.sevManagerHeaders?.length">
          <ng-container *ngFor="let pmHeader of resolvedDynamicHeaders.sevManagerHeaders">
            <td class="wrap-cell"
                [ngStyle]="{ color: isNA(getSevManagerField(property, pmHeader)) ? 'grey' : 'inherit' }"
                nz-tooltip
                [nzTooltipTitle]="sevManagerKeyMapping[pmHeader] === 'phone'
      ? (formatGermanPhoneNumber(getSevManagerField(property, pmHeader) ?? undefined) || 'N/A')
      : (getSevManagerField(property, pmHeader) || 'N/A')"
            >
              <ng-container *ngIf="sevManagerKeyMapping[pmHeader] === 'phone'; else sevDisplayField">
                {{ formatGermanPhoneNumber(getSevManagerField(property, pmHeader) ?? undefined) || 'N/A' }}
              </ng-container>
              <ng-template #sevDisplayField>
                {{ getSevManagerField(property, pmHeader) || 'N/A' }}
              </ng-template>
            </td>
          </ng-container>
        </ng-container>

        <ng-container *ngIf="resolvedDynamicHeaders.accountantHeaders?.length">
          <ng-container *ngFor="let accountantHeader of resolvedDynamicHeaders.accountantHeaders">
            <td class="wrap-cell"
                [ngStyle]="{ color: isNA(getAccountantField(property, accountantHeader)) ? 'grey' : 'inherit' }"
                nz-tooltip
                [nzTooltipTitle]="accountantKeyMapping[accountantHeader] === 'phone'
      ? (formatGermanPhoneNumber(getAccountantField(property, accountantHeader) ?? undefined) || 'N/A')
      : (getAccountantField(property, accountantHeader) || 'N/A')"
            >
              <ng-container *ngIf="accountantKeyMapping[accountantHeader] === 'phone'; else accountantDisplayField">
                {{ formatGermanPhoneNumber(getAccountantField(property, accountantHeader) ?? undefined) || 'N/A' }}
              </ng-container>
              <ng-template #accountantDisplayField>
                {{ getAccountantField(property, accountantHeader) || 'N/A' }}
              </ng-template>
            </td>
          </ng-container>
        </ng-container>


        <!-- Caretaker Information -->
        <td class="wrap-cell"
            [ngStyle]="{ color: isNA(property.caretaker?.name) ? 'grey' : 'inherit' }"
            nz-tooltip
            [nzTooltipTitle]="property.caretaker?.name || 'N/A'">
          {{ property.caretaker?.name || 'N/A' }}
        </td>

        <td class="wrap-cell"
            [ngStyle]="{ color: isNA(property.caretaker?.phone) ? 'grey' : 'inherit' }"
            nz-tooltip
            [nzTooltipTitle]="formatGermanPhoneNumber(property.caretaker?.phone) || 'N/A'">
          {{ formatGermanPhoneNumber(property.caretaker?.phone) || 'N/A' }}
        </td>

        <td class="wrap-cell"
            [ngStyle]="{ color: isNA(property.caretaker?.email) ? 'grey' : 'inherit' }"
            nz-tooltip
            [nzTooltipTitle]="property.caretaker?.email || 'N/A'">
          {{ property.caretaker?.email || 'N/A' }}
        </td>

        <td class="wrap-cell"
            [ngStyle]="{ color: isNA(property.caretaker?.address) ? 'grey' : 'inherit' }"
            nz-tooltip
            [nzTooltipTitle]="property.caretaker?.address || 'N/A'">
          {{ property.caretaker?.address || 'N/A' }}
        </td>

        <!-- Technical Services Information -->
        <ng-container *ngFor="let serviceKey of getUniqueServiceNames()">
          <td class="wrap-cell"
              [ngStyle]="{ color: isNA(getServicePrimaryNameDisplay(property, serviceKey)) ? 'grey' : 'inherit' }"
              nz-tooltip
              nzTooltipOverlayClassName="service-tooltip-multiline"
              [nzTooltipTitle]="getServiceTooltipText(property, serviceKey)">
            {{ getServicePrimaryNameDisplay(property, serviceKey) || 'N/A' }}
          </td>

          <td class="wrap-cell"
              [ngStyle]="{ color: isNA(getServicePrimaryPhone(property, serviceKey)) ? 'grey' : 'inherit' }"
              nz-tooltip
              [nzTooltipTitle]="formatGermanPhoneNumber(getServicePrimaryPhone(property, serviceKey)) || 'N/A'">
            {{ formatGermanPhoneNumber(getServicePrimaryPhone(property, serviceKey)) || 'N/A' }}
          </td>
        </ng-container>

        <!-- Action Buttons -->
        <td nzRight class="action-buttons">
          <div class="action-buttons__inner" data-tour="property-row-actions">
            <button
              nz-button
              nzType="link"
              nz-tooltip
              nzTooltipTitle="{{ 'PROPERTY_LIST.UPDATE' | translate }}"
              (click)="toggleEditModal(property)"
            >
              <span nz-icon nzType="edit"></span>
            </button>

            <button
              nz-button
              nzType="link"
              nz-tooltip
              nzTooltipTitle="{{ 'PROPERTY_LIST.UPLOAD_FILES' | translate }}"
              (click)="openDocumentModal(property)"
            >
              <nz-badge
                class="action-badge"
                [nzCount]="getDocumentsCount(property)"
                [nzShowZero]="false"
                [nzOverflowCount]="99"
              >
                <span nz-icon nzType="folder-open" nzTheme="outline" class="action-icon"></span>
              </nz-badge>
            </button>

            <button
              nz-button
              nzType="link"
              nz-tooltip
              [nzTooltipTitle]="'PROPERTY_INSTRUCTIONS.ACTION_TOOLTIP' | translate"
              (click)="openEmergencyInstructionsModal(property)"
            >
              <nz-badge
                class="action-badge"
                [nzCount]="getEmergencyInstructionsCount(property)"
                [nzShowZero]="false"
                [nzOverflowCount]="99"
              >
                <span nz-icon nzType="file-text" nzTheme="outline" class="action-icon"></span>
              </nz-badge>
            </button>

            <button
              nz-button
              nzType="link"
              nz-tooltip
              nzTooltipTitle="{{ 'PROPERTY_LIST.PRINT_QR' | translate }}"
              (click)="togglePrintQRCodeModal(property)"
            >
              <span nz-icon nzType="qrcode"></span>
            </button>

            <button
              nz-button
              nzType="link"
              nz-tooltip
              nzTooltipTitle="{{ 'PROPERTY_LIST.DELETE' | translate }}"
              nzDanger
              (click)="deleteProperty(property)"
            >
              <span nz-icon nzType="delete"></span>
            </button>
          </div>
        </td>
      </tr>
      </tbody>
    </nz-table>
      <ng-template #noEmergencyProperties>
        <p class="empty-state" *ngIf="hasLoadedProperties">{{ 'PROPERTY_LIST.NO_PROPERTIES_YET' | translate }}</p>
      </ng-template>
    </ng-container>

    <div *ngIf="appMode === 'hospitality'">
      <ng-container *ngIf="properties.length; else noHospitalityProperties">
        <div class="hospitality-grid">
          <cdk-virtual-scroll-viewport class="hosp-viewport" itemSize="176">
            <div
              class="prop-card"
              *cdkVirtualFor="let property of properties; trackBy: trackByPropertyId"
            >
              <div class="prop-card__head">
                <div class="prop-card__title">
                  {{ splitAddress(property.address).street }},
                  {{ splitAddress(property.address).city }}
                </div>
                <div class="prop-card__sub">
                  {{ splitAddress(property.address).zipcode }}
                </div>
              </div>

              <div class="prop-card__summary">
                <div class="pill" *ngIf="property.hospitalityDetails?.wifi?.networkName">
                  {{ 'HOSPITALITY_FIELDS.WIFI_NETWORK' | translate }}:
                  {{ property.hospitalityDetails?.wifi?.networkName }}
                </div>
                <ng-container *ngIf="getPrimaryCheckInPreview(property.hospitalityDetails) as primaryCheckIn">
                  <div
                    class="pill"
                    *ngIf="primaryCheckIn.schedule?.from || primaryCheckIn.schedule?.until; else checkInSummary"
                  >
                    {{ 'HOSPITALITY_FIELDS.CHECK_IN_TITLE' | translate }}:
                    {{ formatHospitalityPreviewTime(primaryCheckIn.schedule?.from) || primaryCheckIn.schedule?.from || '—' }} –
                    {{ formatHospitalityPreviewTime(primaryCheckIn.schedule?.until) || primaryCheckIn.schedule?.until || '—' }}
                  </div>
                  <ng-template #checkInSummary>
                    <div
                      class="pill"
                      *ngIf="
                      primaryCheckIn.instructions
                      || primaryCheckIn.keyPickupLocation
                      || primaryCheckIn.contact
                    "
                    >
                      {{ 'HOSPITALITY_FIELDS.CHECK_IN_TITLE' | translate }}:
                      {{
                        primaryCheckIn.instructions
                        || primaryCheckIn.keyPickupLocation
                        || primaryCheckIn.contact
                      }}
                    </div>
                  </ng-template>
                </ng-container>
                <ng-container *ngIf="getPrimaryCheckOutPreview(property.hospitalityDetails) as primaryCheckOut">
                  <div
                    class="pill"
                    *ngIf="
                    primaryCheckOut.checkOutTime
                    || primaryCheckOut.instructions
                    || primaryCheckOut.dropOffLocation
                    || primaryCheckOut.contact
                  "
                  >
                    {{ 'HOSPITALITY_FIELDS.CHECK_OUT_TITLE' | translate }}:
                    <ng-container *ngIf="primaryCheckOut.checkOutTime; else checkOutSummary">
                      {{
                        formatHospitalityPreviewTime(primaryCheckOut.checkOutTime)
                        || primaryCheckOut.checkOutTime
                      }}
                    </ng-container>
                    <ng-template #checkOutSummary>
                      {{
                        primaryCheckOut.instructions
                        || primaryCheckOut.dropOffLocation
                        || primaryCheckOut.contact
                        || '—'
                      }}
                    </ng-template>
                  </div>
                </ng-container>
                <div class="pill" *ngIf="property.hospitalityDetails?.hostContact?.phone">
                  {{ 'HOSPITALITY_FIELDS.HOST_CONTACT_PHONE' | translate }}:
                  {{ formatGermanPhoneNumber(property.hospitalityDetails?.hostContact?.phone) }}
                </div>
              </div>

              <div class="prop-card__actions">
                <button nz-button nzType="link" nz-tooltip nzTooltipTitle="{{ 'PROPERTY_LIST.UPDATE' | translate }}"
                        (click)="toggleEditModal(property)">
                  <span nz-icon nzType="edit"></span>
                </button>
                <button
                  nz-button
                  nzType="link"
                  nz-tooltip
                  nzTooltipTitle="{{ 'PROPERTY_LIST.UPLOAD_FILES' | translate }}"
                  (click)="openDocumentModal(property)"
                >
                  <nz-badge
                    class="action-badge"
                    [nzCount]="getDocumentsCount(property)"
                    [nzShowZero]="false"
                    [nzOverflowCount]="99"
                  >
                    <span nz-icon nzType="folder-open" nzTheme="outline" class="action-icon"></span>
                  </nz-badge>
                </button>
                <button nz-button nzType="link" nz-tooltip nzTooltipTitle="{{ 'PROPERTY_LIST.PRINT_QR' | translate }}"
                        (click)="togglePrintQRCodeModal(property)">
                  <span nz-icon nzType="qrcode"></span>
                </button>
                <button nz-button nzType="link" nz-tooltip nzTooltipTitle="{{ 'PROPERTY_LIST.DELETE' | translate }}"
                        nzDanger (click)="deleteProperty(property)">
                  <span nz-icon nzType="delete"></span>
                </button>
                <button nz-button nzType="default" class="ml-auto"
                        (click)="openDetailsDrawer(property)">
                  {{ 'PROPERTY_LIST.DETAILS' | translate }}
                </button>
              </div>
            </div>
          </cdk-virtual-scroll-viewport>
        </div>
      </ng-container>

      <ng-template #noHospitalityProperties>
        <p class="empty-state">{{ 'PROPERTY_LIST.NO_HOSPITALITY_PROPERTIES' | translate }}</p>
      </ng-template>

      <!-- Drawer with full hospitality details (moved out of the list for speed) -->
      <nz-drawer
        [nzVisible]="detailsDrawerVisible"
        (nzOnClose)="closeDetailsDrawer()"
        [nzWidth]="720"
        [nzTitle]="detailsDrawerTitle">
        <ng-container *nzDrawerContent>
          <div class="hospitality-sections" *ngIf="detailsProperty; else emptyHospitality">
            <!-- REUSE the exact internal content you already had inside each accordion panel -->
            <!-- BEGIN pasted block (unchanged, just swap 'property' -> 'detailsProperty') -->
            <div class="hospitality-card" *ngIf="detailsProperty?.hospitalityDetails?.wifi as wifi">
              <div class="hospitality-card__header">
                <span nz-icon nzType="wifi" class="hospitality-card__icon" aria-hidden="true"></span>
                <h4 class="hospitality-card__title">{{ 'HOSPITALITY_FIELDS.WIFI_TITLE' | translate }}</h4>
              </div>
              <div class="hospitality-card__body">
                <p *ngIf="wifi.networkName">{{ 'HOSPITALITY_FIELDS.WIFI_NETWORK' | translate }}: {{ wifi.networkName }}</p>
                <p *ngIf="wifi.password">{{ 'HOSPITALITY_FIELDS.WIFI_PASSWORD' | translate }}: {{ wifi.password }}</p>
                <p *ngIf="wifi.instructions">{{ 'HOSPITALITY_FIELDS.WIFI_INSTRUCTIONS' | translate }}: {{ wifi.instructions }}</p>
                <p *ngIf="wifi.supportContact">{{ 'HOSPITALITY_FIELDS.WIFI_SUPPORT' | translate }}: {{ wifi.supportContact }}</p>
              </div>
            </div>

            <div class="hospitality-card" *ngIf="detailsProperty?.hospitalityDetails?.hostContact as host">
              <div class="hospitality-card__header">
                <span nz-icon nzType="solution" class="hospitality-card__icon" aria-hidden="true"></span>
                <h4 class="hospitality-card__title">{{ 'HOSPITALITY_FIELDS.HOST_CONTACT_TITLE' | translate }}</h4>
              </div>
              <div class="hospitality-card__body">
                <p *ngIf="host.name">{{ 'HOSPITALITY_FIELDS.HOST_CONTACT_NAME' | translate }}: {{ host.name }}</p>
                <p *ngIf="host.phone">{{ 'HOSPITALITY_FIELDS.HOST_CONTACT_PHONE' | translate }}: {{ host.phone }}</p>
                <p *ngIf="host.email">{{ 'HOSPITALITY_FIELDS.HOST_CONTACT_EMAIL' | translate }}: {{ host.email }}</p>
                <p *ngIf="host.whatsapp">{{ 'HOSPITALITY_FIELDS.HOST_CONTACT_WHATSAPP' | translate }}: {{ host.whatsapp }}</p>
                <p *ngIf="host.supportHours">{{ 'HOSPITALITY_FIELDS.HOST_CONTACT_SUPPORT_HOURS' | translate }}: {{ host.supportHours }}</p>
              </div>
            </div>

            <ng-container *ngIf="detailsDrawerContext as context">
              <div class="hospitality-card" *ngIf="context.checkInOwned.length || context.checkInCompany.length">
                <div class="hospitality-card__header">
                  <span nz-icon nzType="login" class="hospitality-card__icon" aria-hidden="true"></span>
                  <h4 class="hospitality-card__title">{{ 'HOSPITALITY_FIELDS.CHECK_IN_TITLE' | translate }}</h4>
                </div>
                <div class="hospitality-card__body">
                  <ng-container *ngIf="context.checkInOwned.length">
                    <div class="hospitality-group-label hospitality-group-label--property">
                      <i nz-icon nzType="home" aria-hidden="true"></i>
                      <span>{{ 'HOSPITALITY_FIELDS.PROPERTY_SPECIFIC_LABEL' | translate }}</span>
                    </div>
                    <div class="hospitality-subcard" *ngFor="let entry of context.checkInOwned; let idx = index">
                      <h5 *ngIf="context.checkInOwned.length > 1">
                        {{ 'HOSPITALITY_FIELDS.CHECK_IN_ENTRY_HEADING' | translate:{ index: idx + 1 } }}
                      </h5>
                      <h5 *ngIf="entry.title">{{ entry.title }}</h5>
                      <p *ngIf="entry.instructions">{{ 'HOSPITALITY_FIELDS.CHECK_IN_ENTRY_INSTRUCTIONS' | translate }}: {{ entry.instructions }}</p>
                      <p *ngIf="entry.schedule?.from">
                        {{ 'HOSPITALITY_FIELDS.CHECK_IN_FROM' | translate }}:
                        {{ formatHospitalityPreviewTime(entry.schedule?.from) || entry.schedule?.from }}
                      </p>
                      <p *ngIf="entry.schedule?.until">
                        {{ 'HOSPITALITY_FIELDS.CHECK_IN_UNTIL' | translate }}:
                        {{ formatHospitalityPreviewTime(entry.schedule?.until) || entry.schedule?.until }}
                      </p>
                      <p *ngIf="entry.keyPickupLocation">{{ 'HOSPITALITY_FIELDS.CHECK_IN_LOCATION' | translate }}: {{ entry.keyPickupLocation }}</p>
                      <p *ngIf="entry.contact">{{ 'HOSPITALITY_FIELDS.CHECK_IN_CONTACT' | translate }}: {{ entry.contact }}</p>
                      <div *ngIf="entry.links?.length" class="hospitality-links-preview">
                        <strong>{{ 'HOSPITALITY_FIELDS.CHECK_IN_LINKS' | translate }}</strong>
                        <app-hospitality-link-preview variant="list" [links]="entry.links || []"></app-hospitality-link-preview>
                      </div>
                      <div *ngIf="entry.digitalKeys?.length">
                        <strong>{{ 'HOSPITALITY_FIELDS.CHECK_IN_DIGITAL_KEYS' | translate }}</strong>
                        <ul>
                          <li *ngFor="let key of entry.digitalKeys" class="digital-key-preview">
                          <span class="digital-key-tag">
                            {{ ('HOSPITALITY_FIELDS.DIGITAL_KEY_OPTION_' + (key.accessType | uppercase)) | translate }}
                          </span>
                            <ng-container [ngSwitch]="key.accessType">
                              <span *ngSwitchCase="'pin'">{{ key.code }}</span>
                              <a
                                *ngSwitchCase="'app'"
                                [href]="key.link"
                                target="_blank"
                                rel="noopener"
                              >
                                {{ key.link }}
                              </a>
                              <span *ngSwitchCase="'other'">{{ key.notes }}</span>
                            </ng-container>
                            <span *ngIf="key.notes && key.accessType === 'app'" class="muted">
                            — {{ key.notes }}
                          </span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </ng-container>

                  <ng-container *ngIf="context.checkInCompany.length">
                    <div class="hospitality-group-label hospitality-group-label--company">
                      <i nz-icon nzType="solution" aria-hidden="true"></i>
                      <span>{{ 'HOSPITALITY_FIELDS.COMPANY_SELECTIONS_LABEL' | translate }}</span>
                    </div>
                    <div class="hospitality-subcard" *ngFor="let entry of context.checkInCompany; let idx = index">
                      <h5 *ngIf="context.checkInCompany.length > 1">
                        {{ 'HOSPITALITY_FIELDS.CHECK_IN_ENTRY_HEADING' | translate:{ index: idx + 1 } }}
                      </h5>
                      <h5 *ngIf="entry.title">{{ entry.title }}</h5>
                      <p *ngIf="entry.instructions">{{ 'HOSPITALITY_FIELDS.CHECK_IN_ENTRY_INSTRUCTIONS' | translate }}: {{ entry.instructions }}</p>
                      <p *ngIf="entry.schedule?.from">
                        {{ 'HOSPITALITY_FIELDS.CHECK_IN_FROM' | translate }}:
                        {{ formatHospitalityPreviewTime(entry.schedule?.from) || entry.schedule?.from }}
                      </p>
                      <p *ngIf="entry.schedule?.until">
                        {{ 'HOSPITALITY_FIELDS.CHECK_IN_UNTIL' | translate }}:
                        {{ formatHospitalityPreviewTime(entry.schedule?.until) || entry.schedule?.until }}
                      </p>
                      <p *ngIf="entry.keyPickupLocation">{{ 'HOSPITALITY_FIELDS.CHECK_IN_LOCATION' | translate }}: {{ entry.keyPickupLocation }}</p>
                      <p *ngIf="entry.contact">{{ 'HOSPITALITY_FIELDS.CHECK_IN_CONTACT' | translate }}: {{ entry.contact }}</p>
                      <div *ngIf="entry.links?.length" class="hospitality-links-preview">
                        <strong>{{ 'HOSPITALITY_FIELDS.CHECK_IN_LINKS' | translate }}</strong>
                        <app-hospitality-link-preview variant="list" [links]="entry.links || []"></app-hospitality-link-preview>
                      </div>
                      <div *ngIf="entry.digitalKeys?.length">
                        <strong>{{ 'HOSPITALITY_FIELDS.CHECK_IN_DIGITAL_KEYS' | translate }}</strong>
                        <ul>
                          <li *ngFor="let key of entry.digitalKeys" class="digital-key-preview">
                          <span class="digital-key-tag">
                            {{ ('HOSPITALITY_FIELDS.DIGITAL_KEY_OPTION_' + (key.accessType | uppercase)) | translate }}
                          </span>
                            <ng-container [ngSwitch]="key.accessType">
                              <span *ngSwitchCase="'pin'">{{ key.code }}</span>
                              <a
                                *ngSwitchCase="'app'"
                                [href]="key.link"
                                target="_blank"
                                rel="noopener"
                              >
                                {{ key.link }}
                              </a>
                              <span *ngSwitchCase="'other'">{{ key.notes }}</span>
                            </ng-container>
                            <span *ngIf="key.notes && key.accessType === 'app'" class="muted">
                            — {{ key.notes }}
                          </span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>

              <div class="hospitality-card" *ngIf="context.checkOutOwned.length || context.checkOutCompany.length">
                <div class="hospitality-card__header">
                  <span nz-icon nzType="logout" class="hospitality-card__icon" aria-hidden="true"></span>
                  <h4 class="hospitality-card__title">{{ 'HOSPITALITY_FIELDS.CHECK_OUT_TITLE' | translate }}</h4>
                </div>
                <div class="hospitality-card__body">
                  <ng-container *ngIf="context.checkOutOwned.length">
                    <div class="hospitality-group-label hospitality-group-label--property">
                      <i nz-icon nzType="home" aria-hidden="true"></i>
                      <span>{{ 'HOSPITALITY_FIELDS.PROPERTY_SPECIFIC_LABEL' | translate }}</span>
                    </div>
                    <div class="hospitality-subsection" *ngFor="let entry of context.checkOutOwned">
                      <h5 *ngIf="entry.title">{{ entry.title }}</h5>
                      <p *ngIf="entry.instructions">{{ entry.instructions }}</p>
                      <p *ngIf="entry.checkOutTime">
                        {{ 'HOSPITALITY_FIELDS.CHECK_OUT_UNTIL' | translate }}:
                        {{ formatHospitalityPreviewTime(entry.checkOutTime) || entry.checkOutTime }}
                      </p>
                      <p *ngIf="entry.dropOffLocation">
                        {{ 'HOSPITALITY_FIELDS.CHECK_OUT_LOCATION' | translate }}: {{ entry.dropOffLocation }}
                      </p>
                      <p *ngIf="entry.contact">{{ 'HOSPITALITY_FIELDS.CHECK_OUT_CONTACT' | translate }}: {{ entry.contact }}</p>
                      <div *ngIf="entry.links?.length" class="hospitality-links-preview">
                        <strong>{{ 'HOSPITALITY_FIELDS.CHECK_OUT_LINKS' | translate }}</strong>
                        <app-hospitality-link-preview variant="list" [links]="entry.links || []"></app-hospitality-link-preview>
                      </div>
                      <div *ngIf="entry.checklist && (entry.checklist.title || entry.checklist.items?.length)">
                        <strong>{{ 'HOSPITALITY_FIELDS.CHECK_OUT_TASKS' | translate }}</strong>
                        <p *ngIf="entry.checklist?.title">{{ entry.checklist.title }}</p>
                        <ul *ngIf="entry.checklist?.items?.length">
                          <li *ngFor="let item of entry.checklist.items">{{ item }}</li>
                        </ul>
                      </div>
                    </div>
                  </ng-container>

                  <ng-container *ngIf="context.checkOutCompany.length">
                    <div class="hospitality-group-label hospitality-group-label--company">
                      <i nz-icon nzType="solution" aria-hidden="true"></i>
                      <span>{{ 'HOSPITALITY_FIELDS.COMPANY_SELECTIONS_LABEL' | translate }}</span>
                    </div>
                    <div class="hospitality-subsection" *ngFor="let entry of context.checkOutCompany">
                      <h5 *ngIf="entry.title">{{ entry.title }}</h5>
                      <p class="hospitality-source" *ngIf="entry.sourceLabel && entry.sourceLabel !== entry.title">{{ entry.sourceLabel }}</p>
                      <p *ngIf="entry.instructions">{{ entry.instructions }}</p>
                      <p *ngIf="entry.checkOutTime">
                        {{ 'HOSPITALITY_FIELDS.CHECK_OUT_UNTIL' | translate }}:
                        {{ formatHospitalityPreviewTime(entry.checkOutTime) || entry.checkOutTime }}
                      </p>
                      <p *ngIf="entry.dropOffLocation">
                        {{ 'HOSPITALITY_FIELDS.CHECK_OUT_LOCATION' | translate }}: {{ entry.dropOffLocation }}
                      </p>
                      <p *ngIf="entry.contact">{{ 'HOSPITALITY_FIELDS.CHECK_OUT_CONTACT' | translate }}: {{ entry.contact }}</p>
                      <div *ngIf="entry.links?.length" class="hospitality-links-preview">
                        <strong>{{ 'HOSPITALITY_FIELDS.CHECK_OUT_LINKS' | translate }}</strong>
                        <app-hospitality-link-preview variant="list" [links]="entry.links || []"></app-hospitality-link-preview>
                      </div>
                      <div *ngIf="entry.checklist && (entry.checklist.title || entry.checklist.items?.length)">
                        <strong>{{ 'HOSPITALITY_FIELDS.CHECK_OUT_TASKS' | translate }}</strong>
                        <p *ngIf="entry.checklist?.title">{{ entry.checklist.title }}</p>
                        <ul *ngIf="entry.checklist?.items?.length">
                          <li *ngFor="let item of entry.checklist.items">{{ item }}</li>
                        </ul>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>

              <div class="hospitality-card" *ngIf="context.houseRulesOwned.length || context.houseRulesCompany.length">
                <div class="hospitality-card__header">
                  <span nz-icon nzType="book" class="hospitality-card__icon" aria-hidden="true"></span>
                  <h4 class="hospitality-card__title">{{ 'HOSPITALITY_FIELDS.HOUSE_RULES_TITLE' | translate }}</h4>
                </div>
                <div class="hospitality-card__body">
                  <ng-container *ngIf="context.houseRulesOwned.length">
                    <div class="hospitality-group-label hospitality-group-label--property">
                      <i nz-icon nzType="home" aria-hidden="true"></i>
                      <span>{{ 'HOSPITALITY_FIELDS.PROPERTY_SPECIFIC_LABEL' | translate }}</span>
                    </div>
                    <ul class="hospitality-list">
                      <li class="hospitality-list__item" *ngFor="let rule of context.houseRulesOwned">
                        <span class="hospitality-list__text">{{ rule.rule }}</span>
                        <div *ngIf="rule.links?.length" class="hospitality-list__links">
                          <strong>{{ 'HOSPITALITY_FIELDS.HOUSE_RULE_LINKS' | translate }}</strong>
                          <app-hospitality-link-preview variant="list" [links]="rule.links || []"></app-hospitality-link-preview>
                        </div>
                      </li>
                    </ul>
                  </ng-container>

                  <ng-container *ngIf="context.houseRulesCompany.length">
                    <div class="hospitality-group-label hospitality-group-label--company">
                      <i nz-icon nzType="solution" aria-hidden="true"></i>
                      <span>{{ 'HOSPITALITY_FIELDS.COMPANY_SELECTIONS_LABEL' | translate }}</span>
                    </div>
                    <ul class="hospitality-list">
                      <li class="hospitality-list__item" *ngFor="let rule of context.houseRulesCompany">
                        <span class="hospitality-list__text">{{ rule.rule }}</span>
                        <div *ngIf="rule.links?.length" class="hospitality-list__links">
                          <strong>{{ 'HOSPITALITY_FIELDS.HOUSE_RULE_LINKS' | translate }}</strong>
                          <app-hospitality-link-preview variant="list" [links]="rule.links || []"></app-hospitality-link-preview>
                        </div>
                      </li>
                    </ul>
                  </ng-container>
                </div>
              </div>

              <div class="hospitality-card" *ngIf="context.applianceGuidesOwned.length || context.applianceGuidesCompany.length">
                <div class="hospitality-card__header">
                  <span nz-icon nzType="tool" class="hospitality-card__icon" aria-hidden="true"></span>
                  <h4 class="hospitality-card__title">{{ 'HOSPITALITY_FIELDS.APPLIANCE_GUIDES_TITLE' | translate }}</h4>
                </div>
                <div class="hospitality-card__body">
                  <ng-container *ngIf="context.applianceGuidesOwned.length">
                    <div class="hospitality-group-label hospitality-group-label--property">
                      <i nz-icon nzType="home" aria-hidden="true"></i>
                      <span>{{ 'HOSPITALITY_FIELDS.PROPERTY_SPECIFIC_LABEL' | translate }}</span>
                    </div>
                    <div *ngFor="let guide of context.applianceGuidesOwned; trackBy: trackByApplianceGuide" class="hospitality-subsection">
                      <h5 *ngIf="guide.appliance">{{ guide.appliance }}</h5>
                      <p *ngIf="guide.summary">{{ guide.summary }}</p>
                      <ul *ngIf="guide.steps?.length">
                        <li *ngFor="let step of guide.steps; trackBy: trackByString">{{ step }}</li>
                      </ul>
                      <div *ngIf="guide.resources?.length" class="hospitality-links-preview">
                        <strong>{{ 'HOSPITALITY_FIELDS.APPLIANCE_GUIDES_RESOURCES' | translate }}</strong>
                        <app-hospitality-link-preview
                          variant="list"
                          [links]="guide.resources"
                        ></app-hospitality-link-preview>
                      </div>
                    </div>
                  </ng-container>

                  <ng-container *ngIf="context.applianceGuidesCompany.length">
                    <div class="hospitality-group-label hospitality-group-label--company">
                      <i nz-icon nzType="solution" aria-hidden="true"></i>
                      <span>{{ 'HOSPITALITY_FIELDS.COMPANY_SELECTIONS_LABEL' | translate }}</span>
                    </div>
                    <div *ngFor="let guide of context.applianceGuidesCompany; trackBy: trackByApplianceGuide" class="hospitality-subsection">
                      <h5 *ngIf="guide.appliance">{{ guide.appliance }}</h5>
                      <p *ngIf="guide.summary">{{ guide.summary }}</p>
                      <ul *ngIf="guide.steps?.length">
                        <li *ngFor="let step of guide.steps; trackBy: trackByString">{{ step }}</li>
                      </ul>
                      <div *ngIf="guide.resources?.length" class="hospitality-links-preview">
                        <strong>{{ 'HOSPITALITY_FIELDS.APPLIANCE_GUIDES_RESOURCES' | translate }}</strong>
                        <app-hospitality-link-preview
                          variant="list"
                          [links]="guide.resources"
                        ></app-hospitality-link-preview>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>

              <div class="hospitality-card" *ngIf="detailsProperty?.hospitalityDetails?.localTips as localTips">
                <div class="hospitality-card__header">
                  <span nz-icon nzType="environment" class="hospitality-card__icon" aria-hidden="true"></span>
                  <h4 class="hospitality-card__title">{{ 'HOSPITALITY_FIELDS.LOCAL_TIPS_TITLE' | translate }}</h4>
                </div>
                <div class="hospitality-card__body">
                  <p *ngIf="localTips.intro">{{ localTips.intro }}</p>
                  <p *ngIf="localTips.mapOpenUrl || localTips.mapUrl">
                    <a
                      [href]="localTips.mapOpenUrl || localTips.mapUrl"
                      target="_blank"
                      rel="noopener"
                    >
                      {{ 'HOSPITALITY_FIELDS.LOCAL_TIPS_MAP' | translate }}
                    </a>
                  </p>
                  <div *ngIf="localTips.highlights?.length" class="hospitality-links-preview">
                    <strong>{{ 'HOSPITALITY_FIELDS.LOCAL_TIPS_LINKS' | translate }}</strong>
                    <app-hospitality-link-preview variant="list" [links]="localTips.highlights || []"></app-hospitality-link-preview>
                  </div>
                </div>
              </div>

              <div class="hospitality-card" *ngIf="context.additionalInfoOwned.length || context.additionalInfoCompany.length">
                <div class="hospitality-card__header">
                  <span nz-icon nzType="file-text" class="hospitality-card__icon" aria-hidden="true"></span>
                  <h4 class="hospitality-card__title">{{ 'HOSPITALITY_FIELDS.INFO_SECTIONS_TITLE' | translate }}</h4>
                </div>
                <div class="hospitality-card__body">
                  <ng-container *ngIf="context.additionalInfoOwned.length">
                    <div class="hospitality-group-label hospitality-group-label--property">
                      <i nz-icon nzType="home" aria-hidden="true"></i>
                      <span>{{ 'HOSPITALITY_FIELDS.PROPERTY_SPECIFIC_LABEL' | translate }}</span>
                    </div>
                    <div class="hospitality-subsection" *ngFor="let section of context.additionalInfoOwned">
                      <h5 *ngIf="section.title">{{ section.title }}</h5>
                      <p *ngIf="section.summary && section.summary !== section.body">{{ section.summary }}</p>
                      <p *ngIf="section.body">{{ section.body }}</p>
                      <div *ngIf="section.links?.length" class="hospitality-links-preview">
                        <strong>{{ 'HOSPITALITY_FIELDS.INFO_SECTIONS_LINKS' | translate }}</strong>
                        <app-hospitality-link-preview variant="list" [links]="section.links || []"></app-hospitality-link-preview>
                      </div>
                    </div>
                  </ng-container>

                  <ng-container *ngIf="context.additionalInfoCompany.length">
                    <div class="hospitality-group-label hospitality-group-label--company">
                      <i nz-icon nzType="solution" aria-hidden="true"></i>
                      <span>{{ 'HOSPITALITY_FIELDS.COMPANY_SELECTIONS_LABEL' | translate }}</span>
                    </div>
                    <div class="hospitality-subsection" *ngFor="let section of context.additionalInfoCompany">
                      <h5 *ngIf="section.title">{{ section.title }}</h5>
                      <p *ngIf="section.summary && section.summary !== section.body">{{ section.summary }}</p>
                      <p *ngIf="section.body">{{ section.body }}</p>
                      <div *ngIf="section.links?.length" class="hospitality-links-preview">
                        <strong>{{ 'HOSPITALITY_FIELDS.INFO_SECTIONS_LINKS' | translate }}</strong>
                        <app-hospitality-link-preview variant="list" [links]="section.links || []"></app-hospitality-link-preview>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>
            </ng-container>
            <!-- END pasted block -->
          </div>
          <ng-template #emptyHospitality>
            <p class="empty-state">{{ 'PROPERTY_LIST.NO_HOSPITALITY_DETAILS' | translate }}</p>
          </ng-template>
        </ng-container>
      </nz-drawer>
    </div>

    <nz-pagination
      [nzPageIndex]="propertiesPagination.pageIndex"
      [nzPageSize]="propertiesPagination.pageSize"
      [nzTotal]="propertiesPagination.total"
      [nzPageSizeOptions]="[5, 10, 20, 50]"
      [nzShowQuickJumper]="true"
      [nzShowSizeChanger]="true"
      (nzPageIndexChange)="onPropertiesPageIndexChange($event)"
      (nzPageSizeChange)="onPropertiesPageSizeChange($event)"
      style="margin-top: 16px; text-align: right;">
    </nz-pagination>

    <!-- QR Code Modal (PDF-look) -->
    <nz-modal
      [(nzVisible)]="qrCodeModalVisible"
      [nzWidth]="640"
      nzTitle="{{ 'PROPERTY_LIST.PRINT_QR_PREVIEW' | translate }}"
      (nzOnCancel)="closeQrPosterPreview()"
      (nzOnOk)="printQRCode()"
      [nzOkText]="'PROPERTY_LIST.GENERATE_PDF' | translate"
      [nzClassName]="'qr-preview-modal'"
    >
      <ng-container *nzModalContent>
        <div class="qr-preview qr-preview--pdf" data-tour="property-qr-preview-modal" *ngIf="isQrPosterPreviewLoading || isQrPosterPreviewReady">
          <div class="qr-poster-preview-page">
            <div class="qr-preview-loading-overlay" *ngIf="isQrPosterPreviewLoading">
              <nz-spin [nzSpinning]="true"></nz-spin>
            </div>
            <canvas
              #qrPosterPreviewCanvas
              class="qr-poster-preview-canvas"
              [class.qr-poster-preview-canvas--hidden]="!isQrPosterPreviewReady"
              role="img"
              [attr.aria-label]="'PROPERTY_LIST.PRINT_QR_PREVIEW' | translate"
            ></canvas>
          </div>
        </div>
      </ng-container>
    </nz-modal>

    <!-- Edit Property Modal -->
    <nz-modal
      [(nzVisible)]="editModalVisible"
      [nzZIndex]="900"
      nzTitle="{{ 'PROPERTY_LIST.PROPERTY_EDIT_MODAL_TITLE' | translate }}"
      (nzOnCancel)="toggleEditModal()"
      (nzOnOk)="saveEditProperty()"
      nzWidth="900px"
      [nzOkText]="'COMMON.SAVE' | translate"
      [nzMaskClosable]="false"
      [nzKeyboard]="false"
    >
      <ng-container *nzModalContent>
        <!-- STEPS: dynamic -->
        <nz-steps
          [nzCurrent]="currentEditStep"
          nzType="navigation"
          (nzIndexChange)="onEditStepIndexChange($event)"
          style="margin-bottom: 16px;"
        >
          <nz-step *ngFor="let s of editSteps; trackBy: trackByStep" [nzTitle]="($any(s).titleKey || s.key) | translate"></nz-step>
        </nz-steps>

        <div class="property-edit-form">
          <form nz-form nzLayout="vertical" [formGroup]="editPropertyForm" class="edit-form-grid">

            <!-- DEFAULT/OPERATIONS (non-hospitality) flow -->
            <ng-container *ngIf="!isHospitalityMode()">
              <!-- Step 0: BASICS -->
              <ng-container *ngIf="editSteps[currentEditStep]?.key === 'basics'">
                <div nz-row [nzGutter]="16">
                  <div
                    nz-col
                    [nzXs]="24"
                    [nzMd]="multiLandingProfilesEnabled && editPropertyForm.contains('landingProfileId') ? 16 : 24"
                  >
                    <nz-form-item>
                      <nz-form-label>
                        <span>{{ 'PROPERTY_LIST.ADDRESS' | translate }}</span>
                        <span
                          nz-icon
                          nzType="info-circle"
                          nz-popover
                          [nzPopoverTitle]="'COMMON.ADDRESS_FORMAT_HELP_TITLE' | translate"
                          [nzPopoverContent]="addressFormatPopover"
                          nzPopoverPlacement="rightTop"
                          nzPopoverOverlayClassName="address-format-popover"
                          style="margin-left: 6px; cursor: pointer;"
                        ></span>
                      </nz-form-label>
                      <nz-form-control [nzValidateStatus]="editPropertyForm.get('address')!" nzHasFeedback [nzErrorTip]="editAddressErrTpl">
                        <input nz-input formControlName="address" placeholder="{{ 'PROPERTY_LIST.ADDRESS' | translate }}" />
                        <ng-template #editAddressErrTpl let-control>
                          <ng-container *ngIf="control.hasError('required')">
                            {{ 'PROPERTY_LIST.ADDRESS_REQUIRED' | translate }}
                          </ng-container>
                          <ng-container *ngIf="control.hasError('invalidAddress')">
                            {{ 'FORM_ERRORS.ADDRESS_ERROR' | translate }}
                          </ng-container>
                        </ng-template>
                      </nz-form-control>
                    </nz-form-item>
                  </div>

                  <div nz-col [nzXs]="24" [nzMd]="8" *ngIf="multiLandingProfilesEnabled && editPropertyForm.contains('landingProfileId')">
                    <nz-form-item>
                      <nz-form-label>{{ 'PROPERTY_LIST.LANDING_PROFILE' | translate }}</nz-form-label>
                      <nz-form-control>
                        <nz-select formControlName="landingProfileId">
                          <nz-option [nzLabel]="'PROPERTY_LIST.LANDING_PROFILE_USE_COMPANY' | translate" [nzValue]="useCompanyLandingProfileValue"></nz-option>
                          <nz-option
                            *ngFor="let profile of landingProfiles"
                            [nzLabel]="profile.profileName"
                            [nzValue]="profile._id"
                          ></nz-option>
                        </nz-select>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                </div>
              </ng-container>

              <!-- Step 1: CONTACTS -->
              <ng-container *ngIf="editSteps[currentEditStep]?.key === 'contacts'">
                <div class="manager-fields-group">
                  <div class="manager-fields-grid">
                <nz-form-item class="manager-grid-field" *ngIf="savedHeaders?.caretakerHeaders?.includes('CARETAKER_NAME')">
                  <nz-form-label>{{ 'PROPERTY_LIST.CARETAKER' | translate }}</nz-form-label>
                  <nz-form-control>
                    <nz-select
                      #editCaretakerSelect="nzSelect"
                      formControlName="caretaker"
                      nzDropdownClassName="inline-edit-dd"
                      nzShowSearch
                      [nzFilterOption]="filterOptions"
                      nzAllowClear
                      [nzNotFoundContent]="editCaretakerEmptyTpl"
                      [nzDropdownRender]="editCaretakerDropdownTpl"
                    >
                      <nz-option
                        *ngFor="let caretaker of caretakers"
                        [nzLabel]="caretaker.contactPerson ? (caretaker.name + ' (' + caretaker.contactPerson + ')') : caretaker.name"
                        [nzValue]="caretaker._id"
                        nzCustomContent
                      >
                        <div class="select-option-row">
                          <button
                            nz-button
                            nzType="text"
                            nzSize="small"
                            class="select-option-edit select-option-edit-left"
                            nz-tooltip
                            [nzTooltipTitle]="'CONTACTS.EDIT' | translate"
                            (mousedown)="$event.preventDefault(); $event.stopPropagation()"
                            (click)="editDropdownOption($event, 'caretaker', caretaker._id, editCaretakerSelect)"
                          >
                            <span nz-icon nzType="edit"></span>
                          </button>
                        <span class="select-option-label">
                          {{ caretaker.contactPerson ? (caretaker.name + ' (' + caretaker.contactPerson + ')') : caretaker.name }}
                        </span>
                        </div>
                      </nz-option>
                    </nz-select>
                    <ng-template #editCaretakerDropdownTpl let-menu>
                      <ng-container [ngTemplateOutlet]="menu"></ng-container>
                      <div class="inline-add-dropdown-footer">
                        <button nz-button nzType="link" (click)="addInlineCaretaker(editPropertyForm)">
                          <span nz-icon nzType="plus"></span>
                          {{ 'PROPERTY_LIST.ADD_CARETAKER_INLINE' | translate }}
                        </button>
                        <button nz-button nzType="link" (click)="goToContacts()">
                          <span nz-icon nzType="team"></span>
                          {{ 'PROPERTY_LIST.MANAGE_IN_CONTACTS' | translate }}
                        </button>
                      </div>
                    </ng-template>
                    <ng-template #editCaretakerEmptyTpl>
                      <div class="inline-empty-content">
                        <div class="inline-empty-title">{{ 'PROPERTY_LIST.EMPTY_CONTACTS_TITLE' | translate }}</div>
                        <div class="inline-empty-desc">{{ 'PROPERTY_LIST.EMPTY_CONTACTS_DESC' | translate }}</div>
                      </div>
                    </ng-template>
                  </nz-form-control>
                </nz-form-item>

                <nz-form-item
                  class="manager-grid-field caretaker-contact-person-selection"
                  *ngIf="editPropertyForm.contains('caretakerContactPersonIds') && shouldShowCaretakerContactPersonSelection(editPropertyForm)"
                >
                  <nz-form-label>{{ 'PROPERTY_LIST.CARETAKER_CONTACT_PERSONS' | translate }}</nz-form-label>
                  <nz-form-control>
                    <ng-container *ngIf="isCaretakerContactPersonOptionsLoaded(); else editCaretakerContactPersonsUnavailable">
                      <nz-select
                        #editCaretakerCPSelect="nzSelect"
                        formControlName="caretakerContactPersonIds"
                        nzMode="multiple"
                        nzShowSearch
                        nzAllowClear
                        [nzPlaceHolder]="'PROPERTY_LIST.CARETAKER_CONTACT_PERSONS_PLACEHOLDER' | translate"
                      >
                        <nz-option
                          *ngFor="let person of getCaretakerContactPersonsForForm(editPropertyForm)"
                          [nzLabel]="formatCaretakerContactPersonOption(person)"
                          [nzValue]="person._id"
                          nzCustomContent
                        >
                          <div class="select-option-row">
                            <button
                              nz-button
                              nzType="text"
                              nzSize="small"
                              class="select-option-edit select-option-edit-left"
                              nz-tooltip
                              [nzTooltipTitle]="'CONTACTS.EDIT' | translate"
                              (mousedown)="$event.preventDefault(); $event.stopPropagation()"
                              (click)="editCaretakerFromContactPerson($event, editPropertyForm.get('caretaker')?.value, editCaretakerCPSelect)"
                            >
                              <span nz-icon nzType="edit"></span>
                            </button>
                            <span class="select-option-label">
                              {{ formatCaretakerContactPersonOption(person) }}
                            </span>
                          </div>
                        </nz-option>
                      </nz-select>
                    </ng-container>
                    <ng-template #editCaretakerContactPersonsUnavailable>
                      <div class="caretaker-contact-persons-empty">{{ getCaretakerContactPersonOptionsStatusKey() | translate }}</div>
                    </ng-template>
                    <div class="caretaker-contact-persons-hint">{{ 'PROPERTY_LIST.CARETAKER_CONTACT_PERSONS_FALLBACK_HINT' | translate }}</div>
                  </nz-form-control>
                </nz-form-item>

                <nz-form-item class="manager-grid-field" *ngIf="savedHeaders?.propertyManagerHeaders?.includes('PROPERTY_MANAGER_NAME')">
                  <nz-form-label>{{ 'PROPERTY_LIST.PROPERTY_MANAGER' | translate }}</nz-form-label>
                  <nz-form-control>
                    <nz-select
                      #editPmSelect="nzSelect"
                      formControlName="propertyManagers"
                      nzDropdownClassName="inline-edit-dd"
                      nzShowSearch
                      [nzFilterOption]="filterOptions"
                      nzAllowClear
                      [nzNotFoundContent]="editPropertyManagerEmptyTpl"
                      [nzDropdownRender]="editPropertyManagerDropdownTpl"
                    >
                      <nz-option
                        *ngFor="let manager of propertyManagersModel"
                        [nzLabel]="manager.name"
                        [nzValue]="manager._id"
                        nzCustomContent
                      >
                        <div class="select-option-row">
                          <button
                            nz-button
                            nzType="text"
                            nzSize="small"
                            class="select-option-edit select-option-edit-left"
                            nz-tooltip
                            [nzTooltipTitle]="'CONTACTS.EDIT' | translate"
                            (mousedown)="$event.preventDefault(); $event.stopPropagation()"
                            (click)="editDropdownOption($event, 'propertyManager', manager._id, editPmSelect)"
                          >
                            <span nz-icon nzType="edit"></span>
                          </button>
                          <span class="select-option-label">{{ manager.name }}</span>
                        </div>
                      </nz-option>
                    </nz-select>
                    <ng-template #editPropertyManagerDropdownTpl let-menu>
                      <ng-container [ngTemplateOutlet]="menu"></ng-container>
                      <div class="inline-add-dropdown-footer">
                        <button nz-button nzType="link" (click)="addInlinePropertyManager(editPropertyForm)">
                          <span nz-icon nzType="plus"></span>
                          {{ 'PROPERTY_LIST.ADD_PROPERTY_MANAGER_INLINE' | translate }}
                        </button>
                        <button nz-button nzType="link" (click)="goToContacts()">
                          <span nz-icon nzType="team"></span>
                          {{ 'PROPERTY_LIST.MANAGE_IN_CONTACTS' | translate }}
                        </button>
                      </div>
                    </ng-template>
                    <ng-template #editPropertyManagerEmptyTpl>
                      <div class="inline-empty-content">
                        <div class="inline-empty-title">{{ 'PROPERTY_LIST.EMPTY_CONTACTS_TITLE' | translate }}</div>
                        <div class="inline-empty-desc">{{ 'PROPERTY_LIST.EMPTY_CONTACTS_DESC' | translate }}</div>
                      </div>
                    </ng-template>
                  </nz-form-control>
                </nz-form-item>

                <nz-form-item class="manager-grid-field" *ngIf="savedHeaders?.technicalAssetsManagerHeaders?.includes('TECHNICAL_ASSETS_MANAGER_NAME')">
                  <nz-form-label>{{ 'PROPERTY_LIST.TECHNICAL_ASSETS_MANAGER' | translate }}</nz-form-label>
                  <nz-form-control>
                    <nz-select
                      #editTamSelect="nzSelect"
                      formControlName="technicalAssetsManagers"
                      nzDropdownClassName="inline-edit-dd"
                      nzShowSearch
                      [nzFilterOption]="filterOptions"
                      nzAllowClear
                      [nzNotFoundContent]="editTamEmptyTpl"
                      [nzDropdownRender]="editTamDropdownTpl"
                    >
                      <nz-option
                        *ngFor="let manager of technicalAssetsManagers"
                        [nzLabel]="manager.name"
                        [nzValue]="manager._id"
                        nzCustomContent
                      >
                        <div class="select-option-row">
                          <button
                            nz-button
                            nzType="text"
                            nzSize="small"
                            class="select-option-edit select-option-edit-left"
                            nz-tooltip
                            [nzTooltipTitle]="'CONTACTS.EDIT' | translate"
                            (mousedown)="$event.preventDefault(); $event.stopPropagation()"
                            (click)="editDropdownOption($event, 'technicalAssetsManager', manager._id, editTamSelect)"
                          >
                            <span nz-icon nzType="edit"></span>
                          </button>
                          <span class="select-option-label">{{ manager.name }}</span>
                        </div>
                      </nz-option>
                    </nz-select>
                    <ng-template #editTamDropdownTpl let-menu>
                      <ng-container [ngTemplateOutlet]="menu"></ng-container>
                      <div class="inline-add-dropdown-footer">
                        <button nz-button nzType="link" (click)="addInlineTechnicalAssetsManager(editPropertyForm)">
                          <span nz-icon nzType="plus"></span>
                          {{ 'PROPERTY_LIST.ADD_TECHNICAL_ASSETS_MANAGER_INLINE' | translate }}
                        </button>
                        <button nz-button nzType="link" (click)="goToContacts()">
                          <span nz-icon nzType="team"></span>
                          {{ 'PROPERTY_LIST.MANAGE_IN_CONTACTS' | translate }}
                        </button>
                      </div>
                    </ng-template>
                    <ng-template #editTamEmptyTpl>
                      <div class="inline-empty-content">
                        <div class="inline-empty-title">{{ 'PROPERTY_LIST.EMPTY_CONTACTS_TITLE' | translate }}</div>
                        <div class="inline-empty-desc">{{ 'PROPERTY_LIST.EMPTY_CONTACTS_DESC' | translate }}</div>
                      </div>
                    </ng-template>
                  </nz-form-control>
                </nz-form-item>

                <nz-form-item class="manager-grid-field" *ngIf="savedHeaders?.sevManagerHeaders?.includes('CONDOMINIUM_MANAGER_NAME')">
                  <nz-form-label>{{ 'PROPERTY_LIST.CONDOMINIUM_MANAGER' | translate }}</nz-form-label>
                  <nz-form-control>
                    <nz-select
                      #editSevSelect="nzSelect"
                      formControlName="sevManagers"
                      nzDropdownClassName="inline-edit-dd"
                      nzShowSearch
                      [nzFilterOption]="filterOptions"
                      nzAllowClear
                      [nzNotFoundContent]="editSevEmptyTpl"
                      [nzDropdownRender]="editSevDropdownTpl"
                    >
                      <nz-option
                        *ngFor="let manager of sevManagersModel"
                        [nzLabel]="manager.name"
                        [nzValue]="manager._id"
                        nzCustomContent
                      >
                        <div class="select-option-row">
                          <button
                            nz-button
                            nzType="text"
                            nzSize="small"
                            class="select-option-edit select-option-edit-left"
                            nz-tooltip
                            [nzTooltipTitle]="'CONTACTS.EDIT' | translate"
                            (mousedown)="$event.preventDefault(); $event.stopPropagation()"
                            (click)="editDropdownOption($event, 'sevManager', manager._id, editSevSelect)"
                          >
                            <span nz-icon nzType="edit"></span>
                          </button>
                          <span class="select-option-label">{{ manager.name }}</span>
                        </div>
                      </nz-option>
                    </nz-select>
                    <ng-template #editSevDropdownTpl let-menu>
                      <ng-container [ngTemplateOutlet]="menu"></ng-container>
                      <div class="inline-add-dropdown-footer">
                        <button nz-button nzType="link" (click)="addInlineSevManager(editPropertyForm)">
                          <span nz-icon nzType="plus"></span>
                          {{ 'PROPERTY_LIST.ADD_CONDOMINIUM_MANAGER_INLINE' | translate }}
                        </button>
                        <button nz-button nzType="link" (click)="goToContacts()">
                          <span nz-icon nzType="team"></span>
                          {{ 'PROPERTY_LIST.MANAGE_IN_CONTACTS' | translate }}
                        </button>
                      </div>
                    </ng-template>
                    <ng-template #editSevEmptyTpl>
                      <div class="inline-empty-content">
                        <div class="inline-empty-title">{{ 'PROPERTY_LIST.EMPTY_CONTACTS_TITLE' | translate }}</div>
                        <div class="inline-empty-desc">{{ 'PROPERTY_LIST.EMPTY_CONTACTS_DESC' | translate }}</div>
                      </div>
                    </ng-template>
                  </nz-form-control>
                </nz-form-item>

                <nz-form-item class="manager-grid-field" *ngIf="savedHeaders?.accountantHeaders?.includes('ACCOUNTANT_NAME')">
                  <nz-form-label>{{ 'PROPERTY_LIST.ACCOUNTANT' | translate }}</nz-form-label>
                  <nz-form-control>
                    <nz-select
                      #editAccountantSelect="nzSelect"
                      formControlName="accountants"
                      nzDropdownClassName="inline-edit-dd"
                      nzShowSearch
                      [nzFilterOption]="filterOptions"
                      nzAllowClear
                      [nzNotFoundContent]="editAccountantEmptyTpl"
                      [nzDropdownRender]="editAccountantDropdownTpl"
                    >
                      <nz-option
                        *ngFor="let accountant of accountantsModel"
                        [nzLabel]="accountant.name"
                        [nzValue]="accountant._id"
                        nzCustomContent
                      >
                        <div class="select-option-row">
                          <button
                            nz-button
                            nzType="text"
                            nzSize="small"
                            class="select-option-edit select-option-edit-left"
                            nz-tooltip
                            [nzTooltipTitle]="'CONTACTS.EDIT' | translate"
                            (mousedown)="$event.preventDefault(); $event.stopPropagation()"
                            (click)="editDropdownOption($event, 'accountant', accountant._id, editAccountantSelect)"
                          >
                            <span nz-icon nzType="edit"></span>
                          </button>
                          <span class="select-option-label">{{ accountant.name }}</span>
                        </div>
                      </nz-option>
                    </nz-select>
                    <ng-template #editAccountantDropdownTpl let-menu>
                      <ng-container [ngTemplateOutlet]="menu"></ng-container>
                      <div class="inline-add-dropdown-footer">
                        <button nz-button nzType="link" (click)="addInlineAccountant(editPropertyForm)">
                          <span nz-icon nzType="plus"></span>
                          {{ 'PROPERTY_LIST.ADD_ACCOUNTANT_INLINE' | translate }}
                        </button>
                        <button nz-button nzType="link" (click)="goToContacts()">
                          <span nz-icon nzType="team"></span>
                          {{ 'PROPERTY_LIST.MANAGE_IN_CONTACTS' | translate }}
                        </button>
                      </div>
                    </ng-template>
                    <ng-template #editAccountantEmptyTpl>
                      <div class="inline-empty-content">
                        <div class="inline-empty-title">{{ 'PROPERTY_LIST.EMPTY_CONTACTS_TITLE' | translate }}</div>
                        <div class="inline-empty-desc">{{ 'PROPERTY_LIST.EMPTY_CONTACTS_DESC' | translate }}</div>
                      </div>
                    </ng-template>
                  </nz-form-control>
                </nz-form-item>
                  </div>

                <div class="manager-group-error" *ngIf="hasManagerSelectionError(editPropertyForm)">
                  <span nz-icon nzType="exclamation-circle" nzTheme="outline"></span>
                   {{ getManagerRequiredMessage() }}
                </div>
                </div>
              </ng-container>
              <!-- Step 2: SERVICES -->
              <ng-container *ngIf="editSteps[currentEditStep]?.key === 'services'">
                <ng-container *ngIf="technicalServiceTypes?.length">
                  <div class="full-row services-step-panel">
                    <div
                      class="services-step-grid"
                      [class.services-step-grid--single]="visibleEditServiceTypes.length === 1"
                    >
                      <ng-container *ngFor="let serviceType of visibleEditServiceTypes; trackBy: trackByServiceType">
                        <nz-form-item>
                          <nz-form-label>
                            {{ ('TECHNICAL_SERVICES.' + (serviceTypeTranslationKeys[serviceType] || serviceType)) | translate }}
                          </nz-form-label>
                          <nz-form-control>
                            <nz-select
                              #editServiceSelect="nzSelect"
                              [formControlName]="serviceType"
                              nzDropdownClassName="inline-edit-dd"
                              nzMode="multiple"
                              nzShowSearch
                              [nzFilterOption]="filterOptions"
                              nzAllowClear
                              [nzNotFoundContent]="editServiceEmptyTpl"
                              [nzDropdownRender]="editServiceDropdownTpl"
                            >
                              <nz-option
                                *ngFor="let service of getServicesByType(serviceType); trackBy: trackByServiceId"
                                [nzLabel]="service.serviceName"
                                [nzValue]="getServiceOptionValue(service)"
                                nzCustomContent
                              >
                                <div class="select-option-row">
                                  <button
                                    nz-button
                                    nzType="text"
                                    nzSize="small"
                                    class="select-option-edit select-option-edit-left"
                                    nz-tooltip
                                    [nzTooltipTitle]="'CONTACTS.EDIT' | translate"
                                    (mousedown)="$event.preventDefault(); $event.stopPropagation()"
                                    (click)="editDropdownOption($event, 'service', getServiceOptionValue(service), editServiceSelect)"
                                  >
                                    <span nz-icon nzType="edit"></span>
                                  </button>
                                  <span class="select-option-label">{{ service.serviceName }}</span>
                                </div>
                              </nz-option>
                            </nz-select>
                            <ng-template #editServiceDropdownTpl let-menu>
                              <ng-container [ngTemplateOutlet]="menu"></ng-container>
                              <div class="inline-add-dropdown-footer">
                                <button nz-button nzType="link" (click)="addInlineService(editPropertyForm, serviceType)">
                                  <span nz-icon nzType="plus"></span>
                                  {{ 'PROPERTY_LIST.ADD_SERVICE_INLINE' | translate }}
                                </button>
                                <button nz-button nzType="link" (click)="goToContacts()">
                                  <span nz-icon nzType="team"></span>
                                  {{ 'PROPERTY_LIST.MANAGE_IN_CONTACTS' | translate }}
                                </button>
                              </div>
                            </ng-template>
                            <ng-template #editServiceEmptyTpl>
                              <div class="inline-empty-content">
                                <div class="inline-empty-title">{{ 'PROPERTY_LIST.EMPTY_SERVICES_TITLE' | translate }}</div>
                                <div class="inline-empty-desc">{{ 'PROPERTY_LIST.EMPTY_SERVICES_DESC' | translate }}</div>
                              </div>
                            </ng-template>
                          </nz-form-control>
                        </nz-form-item>
                      </ng-container>
                    </div>
                    <div class="services-step-loading" *ngIf="isEditServicesStepRendering">
                      <nz-spin nzSimple></nz-spin>
                    </div>
                  </div>
                  <div class="full-row">
                    <nz-alert
                      nzType="info"
                      nzShowIcon
                      [nzDescription]="servicesMoreTypesTpl"
                      style="margin-top: 12px;"
                    ></nz-alert>
                  </div>
                </ng-container>
              </ng-container>

              <!-- Step 3: HOSPITALITY (hidden entirely in emergency mode) -->
              <ng-container *ngIf="editSteps[currentEditStep]?.key === 'hospitality'">
                <ng-container *ngTemplateOutlet="hospitalityForm; context: { form: editPropertyForm }"></ng-container>
              </ng-container>
            </ng-container>

            <!-- HOSPITALITY MODE: Address only on Basics (full width), sections below; other steps = sections only -->
            <ng-container *ngIf="isHospitalityMode()">

              <!-- Basics step -->
              <ng-container *ngIf="editSteps[currentEditStep]?.key === 'basics'; else hospSectionsOnlyEdit">
                <div class="full-row">
                  <nz-form-item>
                    <nz-form-label>
                      <span>{{ 'PROPERTY_LIST.ADDRESS' | translate }}</span>
                      <span
                        nz-icon
                        nzType="info-circle"
                        nz-popover
                        [nzPopoverTitle]="'COMMON.ADDRESS_FORMAT_HELP_TITLE' | translate"
                        [nzPopoverContent]="addressFormatPopover"
                        nzPopoverPlacement="rightTop"
                        nzPopoverOverlayClassName="address-format-popover"
                        style="margin-left: 6px; cursor: pointer;"
                      ></span>
                    </nz-form-label>
                    <nz-form-control [nzValidateStatus]="editPropertyForm.get('address')!" nzHasFeedback>
                      <input nz-input formControlName="address" placeholder="{{ 'PROPERTY_LIST.ADDRESS' | translate }}" />
                    </nz-form-control>
                  </nz-form-item>
                </div>

                <ng-container
                  *ngTemplateOutlet="hospitalityForm; context: { form: editPropertyForm, activeSection: activeEditHospSections }">
                </ng-container>
              </ng-container>

              <!-- Other steps -->
              <ng-template #hospSectionsOnlyEdit>
                <ng-container
                  *ngTemplateOutlet="hospitalityForm; context: { form: editPropertyForm, activeSection: activeEditHospSections }">
                </ng-container>
              </ng-template>

            </ng-container>

          </form>
        </div>

        <!-- FOOTER: dynamic next/save -->
        <div style="display:flex; justify-content:space-between; margin-top:12px;">
          <button nz-button (click)="prevEditStep()" [disabled]="currentEditStep===0">{{ 'COMMON.BACK' | translate }}</button>
          <div>
            <button
              nz-button
              nzType="default"
              (click)="nextEditStep()"
              [disabled]="isLastEditStep"
            >
              {{ 'COMMON.NEXT' | translate }}
            </button>
          </div>
        </div>
      </ng-container>
    </nz-modal>
  </div>
</nz-spin>

<ng-template #addressFormatPopover>
  <div class="address-format-help">
    <p>{{ 'COMMON.ADDRESS_FORMAT_HELP_INTRO' | translate }}</p>

    <div class="address-format-example">
      <strong>{{ 'COMMON.ADDRESS_FORMAT_NORMAL' | translate }}</strong>
      <code>Musterstraße 12, 12345 Musterort</code>
    </div>

    <div class="address-format-example">
      <strong>{{ 'COMMON.ADDRESS_FORMAT_RANGE' | translate }}</strong>
      <code>Musterstraße 8 - 10, 12345 Musterort</code>
    </div>

    <div class="address-format-example">
      <strong>{{ 'COMMON.ADDRESS_FORMAT_MULTI_HOUSE_NUMBERS' | translate }}</strong>
      <code>Muster Straße 12/14 + 16A, 12345 Musterort</code>
    </div>

    <div class="address-format-example">
      <strong>{{ 'COMMON.ADDRESS_FORMAT_MULTI_STREET' | translate }}</strong>
      <code>Musterstraße 12 /  Musterweg 3, 12345 Musterort</code>
    </div>

    <div class="address-format-example">
      <strong>{{ 'COMMON.ADDRESS_FORMAT_MULTI_ENTRIES' | translate }}</strong>
      <code>Musterstraße 12,  Musterweg 3, 12345 Musterort</code>
    </div>

    <div class="address-format-example">
      <strong>{{ 'COMMON.ADDRESS_FORMAT_MULTI_ZIP' | translate }}</strong>
      <code>Muster Straße 63 /  Musterweg 9,  10010 Musterort   / 12345 Musterort</code>
    </div>

    <div class="address-format-example">
      <strong>{{ 'COMMON.ADDRESS_FORMAT_SHARED_CITY' | translate }}</strong>
      <code>Muster Str. 18 /  Musterweg 1-3, 12333 / 12345 Musterort</code>
    </div>

    <div class="address-format-example">
      <strong>{{ 'COMMON.ADDRESS_FORMAT_SPECIAL_CHARS' | translate }}</strong>
      <code>Rue de Mustér 5, 12345 Musterort</code>
    </div>

    <p class="address-format-note">
      {{ 'COMMON.ADDRESS_FORMAT_HELP_NOTE' | translate }}
      <br />
      <em>{{ 'COMMON.ADDRESS_FORMAT_HELP_INVALID_EXAMPLE' | translate }}</em>
    </p>
  </div>
</ng-template>
<!-- Landing Page Configuration Wizard Modal -->
<nz-modal
  [(nzVisible)]="wizardVisible"
  [nzZIndex]="1000"
  nzTitle="{{ 'PROPERTY_LIST.CONFIGURE_LANDING_PAGE' | translate }}"
  (nzOnCancel)="wizardVisible = false"
  [nzWidth]="1200"
  [nzBodyStyle]="{ 'max-height': '80vh', 'overflow': 'auto' }"
  [nzFooter]="wizardFooterTpl"
  [nzMaskClosable]="false"
  [nzKeyboard]="false"
>
  <ng-container *nzModalContent>
    <div class="info-section">
      <nz-alert
        nzType="info"
        nzShowIcon
        nzMessage="{{ 'PROPERTY_LIST.LANDING_PAGE_WIZARD_INFO' | translate }}"
      ></nz-alert>
    </div>

    <div class="wizard-container">
      <!-- Property Managers Section (FULL WIDTH) -->
      <div class="wizard-section wizard-section--full"
           [ngClass]="{ 'wizard-section--error': showPropertyManagersSectionError }"
      >
        <div class="employee-section-header">
          <div class="employee-section-title">
            <h3>{{ 'PROPERTY_LIST.PROPERTY_MANAGERS' | translate }}</h3>
            <p>{{ 'PROPERTY_LIST.EMPLOYEE_TEMPLATE_HELPER' | translate }}</p>
          </div>

          <div class="employee-section-action">
            <ng-container *ngIf="!canAddManager(); else addManagerEnabled">
            <span
              nz-tooltip
              [nzTooltipTitle]="'PROPERTY_LIST.ADD_MANAGER_DISABLED' | translate"
            >
            <button
              type="button"
              nz-button
              nzType="primary"
              disabled
            >
              <span nz-icon nzType="plus"></span>
              {{ 'PROPERTY_LIST.ADD_MANAGER' | translate }}
            </button>
            </span>
            </ng-container>
            <ng-template #addManagerEnabled>
            <button
              type="button"
              nz-button
              nzType="primary"
              (click)="addManager('propertyManagers')"
            >
              <span nz-icon nzType="plus"></span>
              {{ 'PROPERTY_LIST.ADD_MANAGER' | translate }}
            </button>
            </ng-template>
          </div>
        </div>

        <div class="employee-config-section">
          <div class="employee-config-section-inner">

          <form nz-form nzLayout="vertical" [formGroup]="wizardForm">
            <div class="employee-config-table" formArrayName="propertyManagers">
              <div class="employee-config-header-row">
                <div class="employee-config-cell employee-config-cell--position">{{ 'PROPERTY_LIST.POSITION_TYPE' | translate }}</div>
                <div class="employee-config-cell employee-config-cell--email">{{ 'PROPERTY_LIST.EMAIL_COLUMN' | translate }}</div>
                <div class="employee-config-cell employee-config-cell--phone">{{ 'PROPERTY_LIST.PHONE_COLUMN' | translate }}</div>
                <div class="employee-config-cell employee-config-cell--actions"><span class="sr-only">{{ 'COMMON.ACTIONS' | translate }}</span></div>
              </div>

              <div
                *ngFor="let manager of propertyManagers.controls; let i = index"
                [formGroupName]="i"
                class="employee-config-row"
                [class.employee-config-row--error]="manager.hasError('emailOrPhoneRequired') && (manager.touched || manager.dirty)"
              >
                <!-- Position Type -->
                <div class="employee-config-cell employee-config-cell--position">
                  <nz-form-item class="employee-form-item">
                    <nz-form-control [nzValidateStatus]="manager.get('positionType')!">
                      <nz-select
                        formControlName="positionType"
                        nzPlaceHolder="{{ 'PROPERTY_LIST.SELECT_POSITION_TYPE' | translate }}"
                        style="width: 100%;"
                      >
                        <nz-option
                          nzValue="Property Manager"
                          nzLabel="{{ 'PROPERTY_LIST.PROPERTY_MANAGER' | translate }}"
                          [nzDisabled]="isOptionDisabled('Property Manager')"
                        ></nz-option>
                        <nz-option
                          nzValue="Technical Assets Manager"
                          nzLabel="{{ 'PROPERTY_LIST.TECHNICAL_ASSETS_MANAGER' | translate }}"
                          [nzDisabled]="isOptionDisabled('Technical Assets Manager')"
                        ></nz-option>
                        <nz-option
                          nzValue="Condominium Manager"
                          nzLabel="{{ 'PROPERTY_LIST.CONDOMINIUM_MANAGER' | translate }}"
                          [nzDisabled]="isOptionDisabled('Condominium Manager')"
                        ></nz-option>
                        <nz-option
                          nzValue="Accountant"
                          nzLabel="{{ 'PROPERTY_LIST.ACCOUNTANT' | translate }}"
                          [nzDisabled]="isOptionDisabled('Accountant')"
                        ></nz-option>
                      </nz-select>
                      <div
                        *ngIf="manager.get('positionType')?.invalid && (manager.get('positionType')?.touched || manager.get('positionType')?.dirty)"
                        class="employee-field-error"
                      >
                        {{ 'PROPERTY_LIST.POSITION_TYPE_REQUIRED' | translate }}
                      </div>
                    </nz-form-control>
                  </nz-form-item>
                </div>

                <!-- Email Toggle -->
                <div class="employee-config-cell employee-config-cell--email">
                  <nz-form-item class="employee-form-item">
                    <nz-form-control>
                      <nz-switch
                        formControlName="includeEmail"
                        nz-tooltip
                        [nzTooltipTitle]="'PROPERTY_LIST.WIZARD_INCLUDE_EMAIL_TOOLTIP' | translate"
                      ></nz-switch>
                    </nz-form-control>
                  </nz-form-item>
                </div>

                <!-- Phone Toggle -->
                <div class="employee-config-cell employee-config-cell--phone">
                  <nz-form-item class="employee-form-item">
                    <nz-form-control>
                      <nz-switch
                        formControlName="includePhone"
                        nz-tooltip
                        [nzTooltipTitle]="'PROPERTY_LIST.WIZARD_INCLUDE_PHONE_TOOLTIP' | translate"
                      ></nz-switch>
                    </nz-form-control>
                  </nz-form-item>
                </div>

                <!-- Remove button -->
                <div class="employee-config-cell employee-config-cell--actions">
                  <ng-container *ngIf="propertyManagers.length > 1; else removeDisabled">
                    <button
                      type="button"
                      nz-button
                      nzType="text"
                      nzDanger
                      (click)="removeManager(i)"
                      class="employee-remove-btn"
                      [attr.aria-label]="'PROPERTY_LIST.REMOVE_EMPLOYEE_ROW' | translate"
                      nz-tooltip
                      [nzTooltipTitle]="'PROPERTY_LIST.REMOVE_EMPLOYEE_ROW' | translate"
                    >
                      <span nz-icon nzType="delete" nzTheme="outline"></span>
                    </button>
                  </ng-container>
                  <ng-template #removeDisabled>
                      <button
                        type="button"
                        nz-button
                        nzType="text"
                        disabled
                        class="employee-remove-btn"
                        nz-tooltip
                        [nzTooltipTitle]="'PROPERTY_LIST.REMOVE_MANAGER_DISABLED' | translate"
                        nzTooltipPlacement="top"
                      >
                      <span nz-icon nzType="delete" nzTheme="outline"></span>
                    </button>
                  </ng-template>
                </div>

                <!-- Row-level error -->
                <div
                  *ngIf="manager.hasError('emailOrPhoneRequired') && (manager.touched || manager.dirty)"
                  class="employee-row-error"
                >
                  <span nz-icon nzType="exclamation-circle" nzTheme="outline"></span>
                  {{ 'ERROR.PROVIDE_EMAIL_OR_PHONE' | translate }}
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      </div>

      <!-- Technical Services Section (FULL WIDTH BELOW) -->
      <div class="wizard-section wizard-section--full"
           [ngClass]="{ 'wizard-section--error': showTechnicalServicesRequiredError }"
      >
        <h3>{{ 'PROPERTY_LIST.TECHNICAL_SERVICES' | translate }}</h3>

        <div [formGroup]="getFormGroup(technicalServices.at(0))" class="technical-services-row">
          <div class="technical-services-selector-wrapper">
            <app-technical-services-selector
              [selectedHeaderKeys]="technicalServicesControl?.value || []"
              [headerOrder]="technicalServiceHeaderOrder"
              [categoryOrder]="technicalServiceCategoryOrder"
              [landingPageEmergencyServicePlacementEnabled]="landingPageEmergencyServicePlacementEnabled"
              [landingPageEmergencyServiceTypes]="landingPageEmergencyServiceTypes"
              [showSelectionRequiredError]="showTechnicalServicesRequiredError"
              (selectionChange)="onTechnicalServicesSelectionChange($event)"
              (orderChange)="onTechnicalServicesOrderChange($event)"
              (emergencyPlacementChange)="onEmergencyServicePlacementChange($event)"
            ></app-technical-services-selector>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</nz-modal>

<!-- Wizard Footer (3 buttons) -->
<ng-template #wizardFooterTpl>
  <button nz-button nzType="default" (click)="wizardVisible = false">
    {{ 'PROPERTY_LIST.CANCEL' | translate }}
  </button>

  <button nz-button nzType="default" (click)="openDownloadTemplateModal()"
    nz-tooltip
    [nzTooltipTitle]="'PROPERTY_LIST.WIZARD_DOWNLOAD_TEMPLATE_TOOLTIP' | translate"
  >
    {{ 'PROPERTY_LIST.DOWNLOAD_TEMPLATE' | translate }}
  </button>

  <button
    *ngIf="canWriteTemplates"
    nz-button
    nzType="primary"
    (click)="saveLandingPageConfig()"
    [disabled]="!canWriteTemplates"
  >
    {{ 'PROPERTY_LIST.SAVE' | translate }}
  </button>
</ng-template>

<ng-template #servicesMoreTypesTpl>
  <span>{{ 'PROPERTY_LIST.SERVICES_MORE_TYPES_HINT_PREFIX' | translate }} </span>

  <button
    nz-button
    nzType="link"
    style="padding: 0; height: auto;"
    (click)="openLandingPageWizardFromPropertyModal()"
  >
    {{ 'PROPERTY_LIST.SERVICES_MORE_TYPES_HINT_LINK' | translate }}
  </button>

  <span> {{ 'PROPERTY_LIST.SERVICES_MORE_TYPES_HINT_SUFFIX' | translate }}</span>
</ng-template>

<!-- Download Excel Template Modal (Excel-only messages live here) -->
<nz-modal
  [(nzVisible)]="downloadTemplateModalVisible"
  nzTitle="{{ 'PROPERTY_LIST.DOWNLOAD_TEMPLATE_MODAL_TITLE' | translate }}"
  (nzOnCancel)="downloadTemplateModalVisible = false"
  [nzWidth]="700"
  [nzFooter]="downloadFooterTpl"
>
  <ng-container *nzModalContent>
    <div class="info-section">
      <nz-alert
        nzType="info"
        nzShowIcon
        [nzDescription]="tplTemplateInfo"
      ></nz-alert>
    </div>

    <div class="info-section">
      <nz-alert
        nzType="info"
        nzShowIcon
        [nzDescription]="tplCumulativeInfo"
      ></nz-alert>
    </div>

    <div class="info-section">
      <nz-alert
        nzType="warning"
        nzShowIcon
        [nzDescription]="tplImportWarning"
      ></nz-alert>
    </div>

    <!-- Descriptions with bold keywords -->
    <ng-template #tplTemplateInfo>
  <span>
    <strong>{{ 'PROPERTY_LIST.NOTE' | translate }}:</strong>
    {{ 'PROPERTY_LIST.TEMPLATE_INFO_SHORT' | translate }}
  </span>
    </ng-template>

    <ng-template #tplCumulativeInfo>
  <span>
    <strong>{{ 'PROPERTY_LIST.IMPORTANT' | translate }}:</strong>
    {{ 'PROPERTY_LIST.CUMULATIVE_CONFIG_SHORT' | translate }}
  </span>
    </ng-template>

    <ng-template #tplImportWarning>
  <span>
    <strong>{{ 'PROPERTY_LIST.WARNING' | translate }}:</strong>
    {{ 'PROPERTY_LIST.IMPORT_ADDRESS_WARNING_SHORT' | translate }}
  </span>
    </ng-template>
  </ng-container>
</nz-modal>

<!-- Import Confirm Modal -->
<nz-modal
  [(nzVisible)]="importConfirmModalVisible"
  nzTitle="{{ 'PROPERTY_LIST.IMPORT_CONFIRM_TITLE' | translate }}"
  (nzOnCancel)="closeImportConfirmModal()"
  [nzFooter]="importConfirmFooter"
  [nzMaskClosable]="false"
  [nzKeyboard]="false"
  nzWidth="780px"
>
  <ng-container *nzModalContent>
    <p style="margin: 0;">
      {{ 'PROPERTY_LIST.IMPORT_CONFIRM_TEXT' | translate }}
    </p>

    <div style="margin-top: 16px;">
      <div style="margin-bottom: 8px; font-weight: 600;">
        {{ 'PROPERTY_LIST.IMPORT_SOURCE_LABEL' | translate }}
      </div>
      <nz-radio-group [(ngModel)]="selectedImportSource">
        <label nz-radio nzValue="scanafy">
          {{ 'PROPERTY_LIST.IMPORT_SOURCE_SCANAFY' | translate }}
        </label>
        <label nz-radio nzValue="haussoft" style="margin-left: 16px;">
          {{ 'PROPERTY_LIST.IMPORT_SOURCE_HAUSSOFT' | translate }}
        </label>
      </nz-radio-group>
    </div>
  </ng-container>
</nz-modal>

<ng-template #importConfirmFooter>
  <div class="import-confirm-footer">
    <button nz-button (click)="closeImportConfirmModal()">
      {{ 'COMMON.CANCEL' | translate }}
    </button>

    <button
      nz-button
      nzType="default"
      (click)="downloadTemplateFromImportModal()"
      [disabled]="selectedImportSource !== 'scanafy'"
    >
      <span nz-icon nzType="download"></span>
      {{ 'PROPERTY_LIST.DOWNLOAD_TEMPLATE' | translate }}
    </button>

    <button nz-button nzType="primary" (click)="continueToImportFromConfirmModal()" [disabled]="isImportBusy">
      <span nz-icon nzType="upload"></span>
      {{ 'PROPERTY_LIST.CONTINUE_TO_IMPORT' | translate }}
    </button>
  </div>
</ng-template>

<ng-template #downloadFooterTpl>
  <button nz-button nzType="default" (click)="downloadTemplateModalVisible = false">
    {{ 'PROPERTY_LIST.CANCEL' | translate }}
  </button>

  <button nz-button nzType="primary" (click)="confirmDownloadTemplate()">
    {{ 'PROPERTY_LIST.DOWNLOAD' | translate }}
  </button>
</ng-template>

<ng-template #hospitalityForm let-form="form" let-activeSection="activeSection">
  <ng-template
    #hospitalityLinkDocumentTemplate
    let-linkGroup="linkGroup"
    let-removeHandler="removeHandler"
    let-hostForm="form"
    let-hideDocumentUpload="hideDocumentUpload"
  >
    <div
      class="hospitality-link-actions"
      [ngClass]="{ 'hospitality-link-actions--no-upload': hideDocumentUpload }"
    >
      <ng-container *ngIf="!hideDocumentUpload">
        <nz-upload
          nzName="file"
          [nzShowUploadList]="false"
          [nzMultiple]="false"
          [nzCustomRequest]="getHospitalityLinkDocumentUploadHandler(hostForm, linkGroup)"
          [nzDisabled]="!canUploadHospitalityLinkDocument(hostForm) || isHospitalityLinkDocumentUploading(linkGroup)"
        >
          <button
            nz-button
            type="button"
            nz-tooltip
            [disabled]="!canUploadHospitalityLinkDocument(hostForm)"
            [nzTooltipTitle]="
              !canUploadHospitalityLinkDocument(hostForm)
                ? ('HOSPITALITY_FIELDS.DOCUMENT_SAVE_HINT' | translate)
                : null
            "
            [nzLoading]="isHospitalityLinkDocumentUploading(linkGroup)"
          >
            <span nz-icon nzType="upload"></span>
            {{
              linkGroup.get('document')?.value
                ? ('HOSPITALITY_FIELDS.DOCUMENT_REPLACE' | translate)
                : ('HOSPITALITY_FIELDS.DOCUMENT_UPLOAD' | translate)
            }}
          </button>
        </nz-upload>
        <div class="hospitality-link-actions__document" *ngIf="linkGroup.get('document')?.value as document">
          <a
            *ngIf="document.url"
            class="hospitality-link-actions__link"
            [href]="document.url"
            target="_blank"
            rel="noopener"
          >
            <span nz-icon nzType="file"></span>
            {{ document.fileName || ('HOSPITALITY_FIELDS.DOCUMENT_VIEW' | translate) }}
          </a>
          <span
            *ngIf="!document.url"
            class="hospitality-link-actions__link"
          >
            <span nz-icon nzType="file"></span>
            {{ document.fileName || ('HOSPITALITY_FIELDS.DOCUMENT_VIEW' | translate) }}
          </span>
          <span class="hospitality-link-actions__meta" *ngIf="document.fileType">
            {{ document.fileType }}
          </span>
          <button
            nz-button
            nzType="link"
            type="button"
            class="hospitality-link-actions__remove"
            (click)="clearHospitalityLinkDocument(linkGroup)"
          >
            {{ 'HOSPITALITY_FIELDS.DOCUMENT_REMOVE' | translate }}
          </button>
        </div>
      </ng-container>
      <button
        nz-button
        nzType="default"
        nzShape="circle"
        nzDanger
        type="button"
        class="hospitality-link-actions__delete"
        (click)="removeHandler()"
      >
        <span nz-icon nzType="delete"></span>
      </button>
    </div>
  </ng-template>
  <div *ngIf="form.get('hospitalityDetails') as hospitalityGroup" [formGroup]="hospitalityGroup" class="hospitality-form">
    <nz-collapse [nzBordered]="false" nzAccordion>
      <!-- Wi-Fi -->
      <ng-container *ngIf="showSection(activeSection, 'wifi')">
        <nz-collapse-panel [nzHeader]="'HOSPITALITY_FIELDS.WIFI_TITLE' | translate">
          <div formGroupName="wifi" class="hospitality-form-grid">
            <nz-form-item>
              <nz-form-label>{{ 'HOSPITALITY_FIELDS.WIFI_NETWORK' | translate }}</nz-form-label>
              <nz-form-control>
                <input nz-input formControlName="networkName" />
              </nz-form-control>
            </nz-form-item>
            <nz-form-item>
              <nz-form-label>{{ 'HOSPITALITY_FIELDS.WIFI_PASSWORD' | translate }}</nz-form-label>
              <nz-form-control>
                <input nz-input formControlName="password" />
              </nz-form-control>
            </nz-form-item>
            <nz-form-item>
              <nz-form-label>{{ 'HOSPITALITY_FIELDS.WIFI_INSTRUCTIONS' | translate }}</nz-form-label>
              <nz-form-control>
                <textarea nz-input formControlName="instructions"></textarea>
              </nz-form-control>
            </nz-form-item>
            <nz-form-item>
              <nz-form-label>{{ 'HOSPITALITY_FIELDS.WIFI_SUPPORT' | translate }}</nz-form-label>
              <nz-form-control>
                <input nz-input formControlName="supportContact" />
              </nz-form-control>
            </nz-form-item>
          </div>
        </nz-collapse-panel>
      </ng-container>
      <!-- Host Contact -->
      <ng-container *ngIf="showSection(activeSection, 'hostContact')">
        <nz-collapse-panel [nzHeader]="'HOSPITALITY_FIELDS.HOST_CONTACT_TITLE' | translate">
          <div formGroupName="hostContact" class="hospitality-form-grid">
            <nz-form-item>
              <nz-form-label>{{ 'HOSPITALITY_FIELDS.HOST_CONTACT_NAME' | translate }}</nz-form-label>
              <nz-form-control>
                <input nz-input formControlName="name" />
              </nz-form-control>
            </nz-form-item>
            <nz-form-item>
              <nz-form-label>{{ 'HOSPITALITY_FIELDS.HOST_CONTACT_PHONE' | translate }}</nz-form-label>
              <nz-form-control>
                <input nz-input formControlName="phone" />
                <div
                  class="field-error"
                  *ngIf="
                    form.get('hostContact.phone')?.errors?.['invalidPhone'] &&
                    (form.get('hostContact.phone')?.dirty || form.get('hostContact.phone')?.touched)
                  "
                >
                  <span>{{ 'HOSPITALITY_FIELDS.HOST_CONTACT_PHONE_INVALID' | translate }}</span>
                </div>
              </nz-form-control>
            </nz-form-item>
            <nz-form-item>
              <nz-form-label>{{ 'HOSPITALITY_FIELDS.HOST_CONTACT_EMAIL' | translate }}</nz-form-label>
              <nz-form-control>
                <input nz-input formControlName="email" />
              </nz-form-control>
            </nz-form-item>
            <nz-form-item>
              <nz-form-label>{{ 'HOSPITALITY_FIELDS.HOST_CONTACT_WHATSAPP' | translate }}</nz-form-label>
              <nz-form-control>
                <input nz-input formControlName="whatsapp" />
              </nz-form-control>
            </nz-form-item>
            <nz-form-item>
              <nz-form-label>{{ 'HOSPITALITY_FIELDS.HOST_CONTACT_SUPPORT_HOURS' | translate }}</nz-form-label>
              <nz-form-control>
                <div formArrayName="supportHoursSlots" class="hospitality-support-hours">
                  <div
                    class="support-hours-row"
                    *ngFor="let slotGroup of getHostSupportHourSlots(form).controls; let slotIndex = index"
                    [formGroupName]="slotIndex"
                  >
                    <nz-time-picker
                      formControlName="start"
                      nzFormat="HH:mm"
                      nzPlaceHolder="{{ 'COMPANY_PAGE.START_TIME' | translate }}"
                      (ngModelChange)="onHostSupportHourStartChange(form, slotIndex)"
                    ></nz-time-picker>
                    <span class="support-hours-separator">{{ 'COMPANY_PAGE.TO' | translate }}</span>
                    <nz-time-picker
                      formControlName="end"
                      nzFormat="HH:mm"
                      nzPlaceHolder="{{ 'COMPANY_PAGE.END_TIME' | translate }}"
                      [nzDisabledHours]="getDisabledHostSupportHourEndHours(form, slotIndex)"
                      [nzDisabledMinutes]="getDisabledHostSupportHourEndMinutes(form, slotIndex)"
                      [nzDisabledSeconds]="getDisabledHostSupportHourEndSeconds(form, slotIndex)"
                    ></nz-time-picker>
                    <button
                      nz-button
                      nzType="default"
                      nzShape="circle"
                      type="button"
                      (click)="removeHostSupportHourSlot(form, slotIndex)"
                      [disabled]="hostSupportHourSlotsLength(form) === 1"
                      [attr.title]="'COMMON.REMOVE_TIME_RANGE' | translate"
                    >
                      <span nz-icon nzType="delete"></span>
                    </button>
                    <button
                      nz-button
                      nzType="dashed"
                      nzShape="circle"
                      type="button"
                      (click)="addHostSupportHourSlot(form)"
                      [disabled]="hostSupportHourSlotsLength(form) >= 2"
                      [attr.title]="'COMMON.ADD_TIME_RANGE' | translate"
                    >
                      <span nz-icon nzType="plus"></span>
                    </button>
                  </div>
                </div>
              </nz-form-control>
            </nz-form-item>
          </div>
        </nz-collapse-panel>
      </ng-container>
      <!-- Check-in -->
      <ng-container *ngIf="showSection(activeSection, 'checkIn')">
        <nz-collapse-panel [nzHeader]="'HOSPITALITY_FIELDS.CHECK_IN_TITLE' | translate">
          <div formGroupName="checkIn" class="hospitality-source">
            <fieldset class="hospitality-source">
              <legend>{{ 'HOSPITALITY_FIELDS.CHECK_IN_TITLE' | translate }}</legend>

              <div
                class="hospitality-group-label hospitality-group-label--company"
                *ngIf="getCheckInRadioOptions(form).length"
              >
                {{ 'HOSPITALITY_FIELDS.COMPANY_SOURCE_LABEL' | translate }}
              </div>

              <div class="company-options" *ngIf="getCheckInRadioOptions(form).length">
                <div
                  class="source-option"
                  *ngFor="let option of getCheckInRadioOptions(form); trackBy: trackByCheckInOptionId"
                >
                  <div class="radio-row">
                    <label class="radio-field" [class.is-disabled]="isCheckInNewSelected(form)">
                      <input
                        type="radio"
                        formControlName="selectedEntryId"
                        [value]="option.id"
                        [attr.aria-controls]="getCompanyPreviewPanelId(form, 'checkIn', option.id)"
                        [attr.aria-disabled]="isCheckInNewSelected(form) ? 'true' : null"
                        [disabled]="isCheckInNewSelected(form)"
                      />
                      {{ option.title || option.id }}
                    </label>
                    <button
                      type="button"
                      class="preview-toggle"
                      nz-button
                      nzType="link"
                      [attr.aria-expanded]="isCompanyPreviewOpen(form, 'checkIn', option.id)"
                      [attr.aria-controls]="getCompanyPreviewPanelId(form, 'checkIn', option.id)"
                      (click)="toggleCompanyPreview(form, 'checkIn', option.id)"
                    >
                      <span nz-icon [nzType]="isCompanyPreviewOpen(form, 'checkIn', option.id) ? 'eye-invisible' : 'eye'"></span>
                      <span class="sr-only">{{ 'HOSPITALITY_FIELDS.TOGGLE_PREVIEW' | translate }}</span>
                    </button>
                  </div>

                  <div
                    class="company-preview"
                    *ngIf="isCompanyPreviewOpen(form, 'checkIn', option.id)"
                    [attr.id]="getCompanyPreviewPanelId(form, 'checkIn', option.id)"
                  >
                    <p *ngIf="option.instructions">{{ option.instructions }}</p>
                    <p *ngIf="option.schedule?.from || option.schedule?.until">
                      <span *ngIf="option.schedule?.from">
                        {{ 'HOSPITALITY_FIELDS.CHECK_IN_FROM' | translate }}:
                        {{ formatHospitalityPreviewTime(option.schedule?.from) || option.schedule?.from }}
                      </span>
                      <span *ngIf="option.schedule?.until">
                        <ng-container *ngIf="option.schedule?.from"> · </ng-container>
                        {{ 'HOSPITALITY_FIELDS.CHECK_IN_UNTIL' | translate }}:
                        {{ formatHospitalityPreviewTime(option.schedule?.until) || option.schedule?.until }}
                      </span>
                    </p>
                    <p *ngIf="option.keyPickupLocation">
                      {{ 'HOSPITALITY_FIELDS.CHECK_IN_LOCATION' | translate }}: {{ option.keyPickupLocation }}
                    </p>
                    <p *ngIf="option.contact">
                      {{ 'HOSPITALITY_FIELDS.CHECK_IN_CONTACT' | translate }}: {{ option.contact }}
                    </p>
                    <div *ngIf="option.links?.length" class="hospitality-links">
                      <h6>{{ 'HOSPITALITY_FIELDS.CHECK_IN_LINKS' | translate }}</h6>
                      <app-hospitality-link-preview variant="list" [links]="option.links || []"></app-hospitality-link-preview>
                    </div>
                    <div *ngIf="option.digitalKeys?.length" class="hospitality-links">
                      <h6>{{ 'HOSPITALITY_FIELDS.CHECK_IN_DIGITAL_KEYS' | translate }}</h6>
                      <ul>
                        <li *ngFor="let key of option.digitalKeys" class="digital-key-preview">
                          <span class="digital-key-tag">
                            {{ ('HOSPITALITY_FIELDS.DIGITAL_KEY_OPTION_' + (key.accessType | uppercase)) | translate }}
                          </span>
                          <ng-container [ngSwitch]="key.accessType">
                            <span *ngSwitchCase="'pin'">{{ key.code }}</span>
                            <a
                              *ngSwitchCase="'app'"
                              [href]="key.link"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {{ key.link }}
                            </a>
                            <span *ngSwitchCase="'other'">{{ key.notes }}</span>
                          </ng-container>
                          <span *ngIf="key.notes && key.accessType === 'app'" class="muted">
                            — {{ key.notes }}
                          </span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              <div class="hospitality-group-label hospitality-group-label--property">
                {{ 'HOSPITALITY_FIELDS.PROPERTY_SOURCE_LABEL' | translate }}
              </div>

              <div class="source-option">
                <label class="radio-field">
                  <input
                    type="radio"
                    formControlName="selectedEntryId"
                    value="new"
                    [checked]="isCheckInNewSelected(form)"
                  />
                  {{ 'HOSPITALITY_FIELDS.ADD_NEW_RECORD' | translate }}
                </label>
              </div>

              <div
                class="hospitality-entry"
                *ngIf="isCheckInNewSelected(form)"
                formGroupName="ownedEntry"
                [attr.id]="getPropertyPanelId(form, 'checkIn')"
              >
                <div class="hospitality-form-grid">
                  <nz-form-item>
                    <nz-form-label>{{ 'HOSPITALITY_FIELDS.CHECK_IN_ENTRY_TITLE' | translate }}</nz-form-label>
                    <nz-form-control>
                      <input nz-input formControlName="title" />
                    </nz-form-control>
                  </nz-form-item>
                  <nz-form-item class="hospitality-span-all">
                    <nz-form-label>{{ 'HOSPITALITY_FIELDS.CHECK_IN_ENTRY_INSTRUCTIONS' | translate }}</nz-form-label>
                    <nz-form-control>
                      <textarea
                        nz-input
                        formControlName="instructions"
                        [nzAutosize]="{ minRows: 3 }"
                      ></textarea>
                    </nz-form-control>
                  </nz-form-item>
                  <div formGroupName="schedule" class="schedule-grid">
                    <nz-form-item>
                      <nz-form-label>{{ 'HOSPITALITY_FIELDS.CHECK_IN_FROM' | translate }}</nz-form-label>
                      <nz-form-control>
                        <nz-time-picker
                          formControlName="from"
                          nzFormat="HH:mm"
                          nzPlaceHolder="{{ 'COMPANY_PAGE.START_TIME' | translate }}"
                          (ngModelChange)="onCheckInScheduleStartChange(form)"
                        ></nz-time-picker>
                      </nz-form-control>
                    </nz-form-item>
                    <nz-form-item>
                      <nz-form-label>{{ 'HOSPITALITY_FIELDS.CHECK_IN_UNTIL' | translate }}</nz-form-label>
                      <nz-form-control>
                        <nz-time-picker
                          formControlName="until"
                          nzFormat="HH:mm"
                          nzPlaceHolder="{{ 'COMPANY_PAGE.END_TIME' | translate }}"
                          [nzDisabledHours]="getDisabledCheckInUntilHours(form)"
                          [nzDisabledMinutes]="getDisabledCheckInUntilMinutes(form)"
                          [nzDisabledSeconds]="getDisabledCheckInUntilSeconds(form)"
                        ></nz-time-picker>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                  <nz-form-item>
                    <nz-form-label>{{ 'HOSPITALITY_FIELDS.CHECK_IN_LOCATION' | translate }}</nz-form-label>
                    <nz-form-control [nzErrorTip]="checkInLocationErrorTpl">
                      <input nz-input formControlName="keyPickupLocation" />
                    </nz-form-control>
                    <ng-template #checkInLocationErrorTpl let-control>
                      <ng-container *ngIf="control.hasError('mapAddress')">
                        {{ 'HOSPITALITY_FIELDS.CHECK_IN_LOCATION_INVALID' | translate }}
                      </ng-container>
                    </ng-template>
                  </nz-form-item>
                  <nz-form-item>
                    <nz-form-label>{{ 'HOSPITALITY_FIELDS.CHECK_IN_CONTACT' | translate }}</nz-form-label>
                    <nz-form-control>
                      <input nz-input formControlName="contact" />
                    </nz-form-control>
                  </nz-form-item>
                </div>

                <div formArrayName="links" class="hospitality-array">
                  <label>{{ 'HOSPITALITY_FIELDS.CHECK_IN_LINKS' | translate }}</label>
                  <div
                    class="array-item hospitality-link-row"
                    *ngFor="let linkGroup of getCheckInLinks(form).controls; let linkIndex = index"
                    [formGroupName]="linkIndex"
                  >
                    <input
                      nz-input
                      formControlName="label"
                      [placeholder]="'HOSPITALITY_FIELDS.LINK_LABEL' | translate"
                      [attr.maxlength]="HOSPITALITY_LIMITS.linkLabel"
                    />
                    <input
                      nz-input
                      formControlName="url"
                      [placeholder]="'HOSPITALITY_FIELDS.LINK_URL' | translate"
                      [attr.maxlength]="HOSPITALITY_LIMITS.linkUrl"
                    />
                    <ng-container
                      *ngTemplateOutlet="
                        hospitalityLinkDocumentTemplate;
                        context: {
                          form: form,
                          linkGroup: linkGroup,
                          removeHandler: removeCheckInLink.bind(this, form, linkIndex)
                        }
                      "
                    ></ng-container>
                  </div>
                  <button nz-button nzType="dashed" type="button" (click)="addCheckInLink(form)">
                    {{ 'HOSPITALITY_FIELDS.ADD_LINK' | translate }}
                  </button>
                </div>

                <div formArrayName="digitalKeys" class="hospitality-array">
                  <label>{{ 'HOSPITALITY_FIELDS.CHECK_IN_DIGITAL_KEYS' | translate }}</label>
                  <div
                    class="array-item hospitality-digital-key-row"
                    *ngFor="let keyGroup of getCheckInDigitalKeys(form).controls; let keyIndex = index"
                    [formGroupName]="keyIndex"
                  >
                    <nz-select
                      class="digital-key-access-select"
                      formControlName="accessType"
                      nzSize="small"
                      [nzPlaceHolder]="'HOSPITALITY_FIELDS.DIGITAL_KEY_ACCESS_LABEL' | translate"
                    >
                      <nz-option
                        *ngFor="let type of digitalKeyAccessTypes"
                        [nzValue]="type"
                        [nzLabel]="('HOSPITALITY_FIELDS.DIGITAL_KEY_OPTION_' + (type | uppercase)) | translate"
                      ></nz-option>
                    </nz-select>
                    <div class="digital-key-value" [ngSwitch]="keyGroup.get('accessType')?.value">
                      <input
                        *ngSwitchCase="'pin'"
                        nz-input
                        formControlName="code"
                        [placeholder]="'HOSPITALITY_FIELDS.DIGITAL_KEY_CODE_PLACEHOLDER' | translate"
                        [attr.maxlength]="HOSPITALITY_LIMITS.digitalKeyCode"
                      />
                      <input
                        *ngSwitchCase="'app'"
                        nz-input
                        formControlName="link"
                        type="url"
                        [placeholder]="'HOSPITALITY_FIELDS.DIGITAL_KEY_LINK_PLACEHOLDER' | translate"
                        [attr.maxlength]="HOSPITALITY_LIMITS.digitalKeyLink"
                      />
                      <textarea
                        *ngSwitchCase="'other'"
                        nz-input
                        formControlName="notes"
                        rows="2"
                        [placeholder]="'HOSPITALITY_FIELDS.DIGITAL_KEY_NOTES_PLACEHOLDER' | translate"
                        [attr.maxlength]="HOSPITALITY_LIMITS.digitalKeyNotes"
                      ></textarea>
                    </div>
                    <button
                      nz-button
                      nzType="default"
                      nzShape="circle"
                      nzDanger
                      type="button"
                      (click)="removeCheckInDigitalKey(form, keyIndex)"
                    >
                      <span nz-icon nzType="delete"></span>
                    </button>
                    <div class="digital-key-helper">
                      <small>{{ 'HOSPITALITY_FIELDS.DIGITAL_KEY_HELPER' | translate }}</small>
                      <div
                        class="hospitality-error"
                        *ngIf="keyGroup.invalid && (keyGroup.dirty || keyGroup.touched)"
                      >
                        <ng-container *ngIf="keyGroup.hasError('digitalKeyAccessRequired')">
                          {{ 'HOSPITALITY_FIELDS.DIGITAL_KEY_ACCESS_REQUIRED' | translate }}
                        </ng-container>
                        <ng-container *ngIf="keyGroup.errors?.['digitalKeyValueRequired'] === 'code'">
                          {{ 'HOSPITALITY_FIELDS.DIGITAL_KEY_CODE_REQUIRED' | translate }}
                        </ng-container>
                        <ng-container *ngIf="keyGroup.errors?.['digitalKeyValueRequired'] === 'link'">
                          {{ 'HOSPITALITY_FIELDS.DIGITAL_KEY_LINK_REQUIRED' | translate }}
                        </ng-container>
                        <ng-container *ngIf="keyGroup.errors?.['digitalKeyValueRequired'] === 'notes'">
                          {{ 'HOSPITALITY_FIELDS.DIGITAL_KEY_NOTES_REQUIRED' | translate }}
                        </ng-container>
                      </div>
                    </div>
                  </div>
                  <button nz-button nzType="dashed" type="button" (click)="addCheckInDigitalKey(form)">
                    {{ 'HOSPITALITY_FIELDS.ADD_DIGITAL_KEY' | translate }}
                  </button>
                </div>
              </div>
            </fieldset>
            </div>
          </nz-collapse-panel>

      </ng-container>
      <!-- Check-out -->
      <ng-container *ngIf="showSection(activeSection, 'checkOut')">
        <nz-collapse-panel [nzHeader]="'HOSPITALITY_FIELDS.CHECK_OUT_TITLE' | translate">
          <div formGroupName="checkOut">
            <fieldset class="hospitality-source">
              <!-- TODO: Verify aria-controls/id generation stays unique when multiple hospitality editors render concurrently. -->
              <legend>{{ 'HOSPITALITY_FIELDS.CHECK_OUT_TITLE' | translate }}</legend>
              <div
                class="hospitality-group-label hospitality-group-label--company"
                *ngIf="companyCheckOutOptions.length"
              >
                {{ 'HOSPITALITY_FIELDS.COMPANY_SOURCE_LABEL' | translate }}
              </div>

              <div
                class="company-options"
                *ngIf="companyCheckOutOptions.length"
                [attr.id]="getCompanyListPanelId(form, 'checkOut')"
              >
                <div
                  class="source-option"
                  *ngFor="let option of companyCheckOutOptions"
                >
                  <label class="radio-field" [class.is-disabled]="isCheckOutNewSelected(form)">
                    <input
                      type="radio"
                      [name]="getHospitalityRadioName(form, 'checkOut')"
                      [value]="option.id"
                      [formControl]="getCheckOutSelectionControl(form)"
                      (change)="selectCheckOutOption(form, hospitalityGroup, option.id)"
                      [attr.aria-controls]="getCompanyPreviewPanelId(form, 'checkOut', option.id)"
                      [attr.aria-disabled]="isCheckOutNewSelected(form) ? 'true' : null"
                      [disabled]="isCheckOutNewSelected(form)"
                    />
                    {{ option.title || option.label }}
                  </label>
                  <button
                    type="button"
                    class="preview-toggle"
                    nz-button
                    nzType="link"
                    [attr.aria-expanded]="isCompanyPreviewOpen(form, 'checkOut', option.id)"
                    [attr.aria-controls]="getCompanyPreviewPanelId(form, 'checkOut', option.id)"
                    (click)="toggleCompanyPreview(form, 'checkOut', option.id)"
                  >
                    <span nz-icon [nzType]="isCompanyPreviewOpen(form, 'checkOut', option.id) ? 'eye-invisible' : 'eye'"></span>
                    <span class="sr-only">{{ 'HOSPITALITY_FIELDS.TOGGLE_PREVIEW' | translate }}</span>
                  </button>
                  <div
                    class="company-preview"
                    *ngIf="isCompanyPreviewOpen(form, 'checkOut', option.id)"
                    [attr.id]="getCompanyPreviewPanelId(form, 'checkOut', option.id)"
                  >
                    <ng-container *ngIf="getCompanyCheckOutOption(option.id) as optionDetails; else checkOutLabelOnly">
                      <p *ngIf="optionDetails.instructions">{{ optionDetails.instructions }}</p>
                      <p *ngIf="optionDetails.checkOutTime">
                        {{ 'HOSPITALITY_FIELDS.CHECK_OUT_UNTIL' | translate }}:
                        {{ formatHospitalityPreviewTime(optionDetails.checkOutTime) || optionDetails.checkOutTime }}
                      </p>
                      <p *ngIf="optionDetails.dropOffLocation">
                        {{ 'HOSPITALITY_FIELDS.CHECK_OUT_LOCATION' | translate }}: {{ optionDetails.dropOffLocation }}
                      </p>
                      <p *ngIf="optionDetails.contact">
                        {{ 'HOSPITALITY_FIELDS.CHECK_OUT_CONTACT' | translate }}: {{ optionDetails.contact }}
                      </p>
                      <div *ngIf="optionDetails.links?.length" class="hospitality-links">
                        <h6>{{ 'HOSPITALITY_FIELDS.CHECK_OUT_LINKS' | translate }}</h6>
                        <app-hospitality-link-preview variant="list" [links]="optionDetails.links || []"></app-hospitality-link-preview>
                      </div>
                      <div *ngIf="optionDetails.checklist?.items?.length" class="hospitality-links">
                        <h6>{{ optionDetails.checklist?.title || ('HOSPITALITY_FIELDS.CHECK_OUT_TASKS' | translate) }}</h6>
                        <ul>
                          <li *ngFor="let task of optionDetails.checklist?.items">{{ task }}</li>
                        </ul>
                      </div>
                    </ng-container>
                    <ng-template #checkOutLabelOnly>
                      <p>{{ option.title || option.label }}</p>
                    </ng-template>
                  </div>
                </div>
              </div>

            </fieldset>

            <div class="hospitality-property-section">
              <div class="hospitality-group-label hospitality-group-label--property">
                {{ 'HOSPITALITY_FIELDS.PROPERTY_SOURCE_LABEL' | translate }}
              </div>

              <div class="source-option">
                <label class="radio-field">
                  <input
                    type="radio"
                    [name]="getHospitalityRadioName(form, 'checkOut')"
                    value="new"
                    [formControl]="getCheckOutSelectionControl(form)"
                    (change)="selectCheckOutOption(form, hospitalityGroup, 'new')"
                    [attr.aria-controls]="getPropertyPanelId(form, 'checkOut')"
                  />
                  {{ 'HOSPITALITY_FIELDS.ADD_NEW_RECORD' | translate }}
                </label>
              </div>

              <ng-container formArrayName="ownedEntries">
                <div
                  class="hospitality-entry-array"
                  *ngIf="isCheckOutOwnedPreviewOpen(hospitalityGroup)"
                  [attr.id]="getPropertyPanelId(form, 'checkOut')"
                >
                <div
                  class="hospitality-entry"
                  *ngFor="let entryGroup of getCheckOutOwnedEntries(form).controls; let i = index"
                  [formGroupName]="i"
                >
                  <div class="hospitality-form-grid">
                    <nz-form-item>
                      <nz-form-label>{{ 'HOSPITALITY_FIELDS.ENTRY_TITLE' | translate }}</nz-form-label>
                      <nz-form-control>
                        <input nz-input formControlName="title" />
                      </nz-form-control>
                    </nz-form-item>
                    <nz-form-item>
                      <nz-form-label>{{ 'HOSPITALITY_FIELDS.CHECK_OUT_UNTIL' | translate }}</nz-form-label>
                      <nz-form-control>
                        <nz-time-picker
                          formControlName="checkOutTime"
                          nzFormat="HH:mm"
                          nzPlaceHolder="{{ 'COMPANY_PAGE.END_TIME' | translate }}"
                        ></nz-time-picker>
                      </nz-form-control>
                    </nz-form-item>
                    <nz-form-item>
                      <nz-form-label>{{ 'HOSPITALITY_FIELDS.CHECK_OUT_LOCATION' | translate }}</nz-form-label>
                      <nz-form-control [nzErrorTip]="checkOutLocationErrorTpl">
                        <input
                          nz-input
                          formControlName="dropOffLocation"
                          [attr.maxlength]="HOSPITALITY_LIMITS.location"
                        />
                      </nz-form-control>
                      <ng-template #checkOutLocationErrorTpl let-control>
                        <ng-container *ngIf="control.hasError('mapAddress')">
                          {{ 'HOSPITALITY_FIELDS.CHECK_OUT_LOCATION_INVALID' | translate }}
                        </ng-container>
                      </ng-template>
                    </nz-form-item>
                    <nz-form-item>
                      <nz-form-label>{{ 'HOSPITALITY_FIELDS.CHECK_OUT_CONTACT' | translate }}</nz-form-label>
                      <nz-form-control>
                        <input
                          nz-input
                          formControlName="contact"
                          [attr.maxlength]="HOSPITALITY_LIMITS.contact"
                        />
                      </nz-form-control>
                    </nz-form-item>
                    <nz-form-item class="hospitality-span-all">
                      <nz-form-label>{{ 'HOSPITALITY_FIELDS.CHECK_OUT_INSTRUCTIONS' | translate }}</nz-form-label>
                      <nz-form-control>
                        <textarea
                          nz-input
                          formControlName="instructions"
                          [attr.maxlength]="HOSPITALITY_LIMITS.instructions"
                        ></textarea>
                      </nz-form-control>
                    </nz-form-item>
                  </div>

                  <div formArrayName="links" class="hospitality-array">
                    <label>{{ 'HOSPITALITY_FIELDS.CHECK_OUT_LINKS' | translate }}</label>
                  <div
                    class="array-item hospitality-link-row"
                    *ngFor="let linkGroup of getCheckOutOwnedEntryLinks(form, i).controls; let linkIndex = index"
                    [formGroupName]="linkIndex"
                  >
                    <input
                      nz-input
                      formControlName="label"
                      [placeholder]="'HOSPITALITY_FIELDS.LINK_LABEL' | translate"
                      [attr.maxlength]="HOSPITALITY_LIMITS.linkLabel"
                    />
                    <input
                      nz-input
                      formControlName="url"
                      [placeholder]="'HOSPITALITY_FIELDS.LINK_URL' | translate"
                      [attr.maxlength]="HOSPITALITY_LIMITS.linkUrl"
                    />
                    <ng-container
                      *ngTemplateOutlet="
                        hospitalityLinkDocumentTemplate;
                        context: {
                          form: form,
                          linkGroup: linkGroup,
                          removeHandler: removeCheckOutOwnedEntryLink.bind(this, form, i, linkIndex)
                        }
                      "
                    ></ng-container>
                  </div>
                    <button nz-button nzType="dashed" type="button" (click)="addCheckOutOwnedEntryLink(form, i)">
                      {{ 'HOSPITALITY_FIELDS.ADD_LINK' | translate }}
                    </button>
                  </div>

                  <div formGroupName="checklist" class="hospitality-array">
                    <label>{{ 'HOSPITALITY_FIELDS.CHECK_OUT_TASKS' | translate }}</label>
                    <input
                      nz-input
                      formControlName="title"
                      [placeholder]="'HOSPITALITY_FIELDS.CHECK_OUT_CHECKLIST_TITLE' | translate"
                      [attr.maxlength]="HOSPITALITY_LIMITS.checklistTitle"
                    />
                    <div formArrayName="items">
                      <div
                        class="array-item checklist-item-row"
                        *ngFor="let item of getCheckOutOwnedEntryChecklistItems(form, i).controls; let itemIndex = index"
                      >
                        <input
                          nz-input
                          [formControlName]="itemIndex"
                          [attr.maxlength]="HOSPITALITY_LIMITS.checklistItem"
                        />
                        <button
                          nz-button
                          nzType="default"
                          nzShape="circle"
                          nzDanger
                          type="button"
                          (click)="removeCheckOutOwnedEntryChecklistItem(form, i, itemIndex)"
                        >
                          <span nz-icon nzType="delete"></span>
                        </button>
                      </div>
                    </div>
                    <button nz-button nzType="dashed" type="button" (click)="addCheckOutOwnedEntryChecklistItem(form, i)">
                      {{ 'HOSPITALITY_FIELDS.ADD_CHECKLIST_ITEM' | translate }}
                    </button>
                  </div>
                </div>

                </div>
              </ng-container>
            </div>
          </div>
        </nz-collapse-panel>
      </ng-container>
      <!-- House Rules -->
      <ng-container *ngIf="showSection(activeSection, 'houseRules')">
        <nz-collapse-panel [nzHeader]="'HOSPITALITY_FIELDS.HOUSE_RULES_TITLE' | translate">
          <fieldset class="hospitality-source">
            <legend>{{ 'HOSPITALITY_FIELDS.HOUSE_RULES_TITLE' | translate }}</legend>

            <div formGroupName="houseRules">
              <div
                class="hospitality-group-label hospitality-group-label--company"
                *ngIf="companyHouseRuleOptions.length"
              >
                {{ 'HOSPITALITY_FIELDS.COMPANY_SOURCE_LABEL' | translate }}
              </div>

              <div
                class="company-options"
                *ngIf="companyHouseRuleOptions.length"
                [attr.id]="getCompanyListPanelId(form, 'houseRules')"
              >
                <div class="company-option" *ngFor="let option of companyHouseRuleOptions">
                  <label
                    nz-checkbox
                    [nzChecked]="isHouseRuleCompanySelected(form, option.id)"
                    (nzCheckedChange)="setHouseRuleCompanySelection(form, option.id, $event)"
                    [attr.aria-controls]="getCompanyPreviewPanelId(form, 'houseRules', option.id)"
                  >
                    {{ option.label }}
                  </label>
                  <button
                    type="button"
                    class="preview-toggle"
                    nz-button
                    nzType="link"
                    [attr.aria-expanded]="isCompanyPreviewOpen(form, 'houseRules', option.id)"
                    [attr.aria-controls]="getCompanyPreviewPanelId(form, 'houseRules', option.id)"
                    (click)="toggleCompanyPreview(form, 'houseRules', option.id)"
                  >
                    <span nz-icon [nzType]="isCompanyPreviewOpen(form, 'houseRules', option.id) ? 'eye-invisible' : 'eye'"></span>
                    <span class="sr-only">{{ 'HOSPITALITY_FIELDS.TOGGLE_PREVIEW' | translate }}</span>
                  </button>
                  <div
                    class="company-preview"
                    *ngIf="isCompanyPreviewOpen(form, 'houseRules', option.id)"
                    [attr.id]="getCompanyPreviewPanelId(form, 'houseRules', option.id)"
                  >
                    <p>{{ option.label }}</p>
                    <div *ngIf="option.links?.length" class="hospitality-links">
                      <h6>{{ 'HOSPITALITY_FIELDS.HOUSE_RULE_LINKS' | translate }}</h6>
                      <app-hospitality-link-preview variant="list" [links]="option.links || []"></app-hospitality-link-preview>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </fieldset>

          <div class="hospitality-property-section">
            <div class="hospitality-group-label hospitality-group-label--property">
              {{ 'HOSPITALITY_FIELDS.PROPERTY_SOURCE_LABEL' | translate }}
            </div>

            <div class="source-option">
              <button
                type="button"
                class="preview-toggle"
                nz-button
                nzType="link"
                [attr.aria-expanded]="isOwnedEntryPreviewOpen(hospitalityGroup, 'houseRules')"
                [attr.aria-controls]="getPropertyPanelId(form, 'houseRules')"
                (click)="toggleOwnedEntryPreview(hospitalityGroup, 'houseRules')"
              >
                <span nz-icon [nzType]="isOwnedEntryPreviewOpen(hospitalityGroup, 'houseRules') ? 'eye-invisible' : 'eye'"></span>
                <span class="sr-only">{{ 'HOSPITALITY_FIELDS.TOGGLE_PREVIEW' | translate }}</span>
              </button>
            </div>

            <div formGroupName="houseRules">
              <ng-container formArrayName="ownedEntries">
                <div
                  class="hospitality-entry-array"
                  [attr.id]="getPropertyPanelId(form, 'houseRules')"
                  [hidden]="!isOwnedEntryPreviewOpen(hospitalityGroup, 'houseRules')"
                  [attr.aria-hidden]="!isOwnedEntryPreviewOpen(hospitalityGroup, 'houseRules')"
                >
                  <div
                    class="hospitality-entry"
                    *ngFor="let entryGroup of getHouseRuleOwnedEntries(form).controls; let i = index"
                    [formGroupName]="i"
                  >
                    <div class="hospitality-entry__actions">
                      <button
                        nz-button
                        nzType="default"
                        nzShape="circle"
                        nzDanger
                        type="button"
                        (click)="removeHouseRuleOwnedEntry(form, i)"
                      >
                        <span nz-icon nzType="delete"></span>
                      </button>
                    </div>

                    <div class="hospitality-form-grid">
                      <nz-form-item class="hospitality-span-all">
                        <nz-form-label>{{ 'HOSPITALITY_FIELDS.HOUSE_RULES_RULE' | translate }}</nz-form-label>
                        <nz-form-control>
                        <textarea
                          nz-input
                          formControlName="rule"
                          [attr.maxlength]="HOSPITALITY_LIMITS.rule"
                        ></textarea>
                        </nz-form-control>
                      </nz-form-item>
                    </div>

                    <div formArrayName="links" class="hospitality-array">
                      <label>{{ 'HOSPITALITY_FIELDS.HOUSE_RULE_LINKS' | translate }}</label>
                      <div
                        class="array-item hospitality-link-row"
                        *ngFor="let linkGroup of getHouseRuleOwnedEntryLinks(form, i).controls; let linkIndex = index"
                        [formGroupName]="linkIndex"
                      >
                        <input
                          nz-input
                          formControlName="label"
                          [placeholder]="'HOSPITALITY_FIELDS.LINK_LABEL' | translate"
                          [attr.maxlength]="HOSPITALITY_LIMITS.linkLabel"
                        />
                        <input
                          nz-input
                          formControlName="url"
                          [placeholder]="'HOSPITALITY_FIELDS.LINK_URL' | translate"
                          [attr.maxlength]="HOSPITALITY_LIMITS.linkUrl"
                        />
                          <ng-container
                            *ngTemplateOutlet="
                              hospitalityLinkDocumentTemplate;
                            context: {
                              form: form,
                              linkGroup: linkGroup,
                              removeHandler: removeHouseRuleOwnedEntryLink.bind(this, form, i, linkIndex)
                            }
                          "
                        ></ng-container>
                      </div>
                      <button nz-button nzType="dashed" type="button" (click)="addHouseRuleOwnedEntryLink(form, i)">
                        {{ 'HOSPITALITY_FIELDS.ADD_LINK' | translate }}
                      </button>
                    </div>
                  </div>

                  <button nz-button nzType="dashed" type="button" (click)="addHouseRuleOwnedEntry(form)">
                    {{ 'HOSPITALITY_FIELDS.ADD_NEW_RECORD' | translate }}
                  </button>
                </div>
              </ng-container>
            </div>
          </div>
        </nz-collapse-panel>
      </ng-container>
      <!-- Appliance Guides -->
      <ng-container *ngIf="showSection(activeSection, 'applianceGuides')">
        <nz-collapse-panel [nzHeader]="'HOSPITALITY_FIELDS.APPLIANCE_GUIDES_TITLE' | translate">
          <fieldset class="hospitality-source">
            <legend>{{ 'HOSPITALITY_FIELDS.APPLIANCE_GUIDES_TITLE' | translate }}</legend>

            <div formGroupName="applianceGuides">
              <div
                class="hospitality-group-label hospitality-group-label--company"
                *ngIf="companyApplianceGuideOptions.length"
              >
                {{ 'HOSPITALITY_FIELDS.COMPANY_SOURCE_LABEL' | translate }}
              </div>

              <div
                class="company-options"
                *ngIf="companyApplianceGuideOptions.length"
                [attr.id]="getCompanyListPanelId(form, 'applianceGuides')"
              >
                <div class="company-option" *ngFor="let option of companyApplianceGuideOptions">
                  <label
                    nz-checkbox
                    [nzChecked]="isApplianceGuideCompanySelected(form, option.id)"
                    (nzCheckedChange)="setApplianceGuideCompanySelection(form, option.id, $event)"
                    [attr.aria-controls]="getCompanyPreviewPanelId(form, 'applianceGuides', option.id)"
                  >
                    {{ option.appliance || option.summary || option.id }}
                  </label>
                  <button
                    type="button"
                    class="preview-toggle"
                    nz-button
                    nzType="link"
                    [attr.aria-expanded]="isCompanyPreviewOpen(form, 'applianceGuides', option.id)"
                    [attr.aria-controls]="getCompanyPreviewPanelId(form, 'applianceGuides', option.id)"
                    (click)="toggleCompanyPreview(form, 'applianceGuides', option.id)"
                  >
                    <span nz-icon [nzType]="isCompanyPreviewOpen(form, 'applianceGuides', option.id) ? 'eye-invisible' : 'eye'"></span>
                    <span class="sr-only">{{ 'HOSPITALITY_FIELDS.TOGGLE_PREVIEW' | translate }}</span>
                  </button>
                  <div
                    class="company-preview"
                    *ngIf="isCompanyPreviewOpen(form, 'applianceGuides', option.id)"
                    [attr.id]="getCompanyPreviewPanelId(form, 'applianceGuides', option.id)"
                  >
                    <p *ngIf="option.appliance">{{ option.appliance }}</p>
                    <p *ngIf="option.summary">{{ option.summary }}</p>
                    <ul *ngIf="option.steps?.length">
                      <li *ngFor="let step of option.steps; trackBy: trackByString">{{ step }}</li>
                    </ul>
                    <div *ngIf="option.resources?.length" class="hospitality-links">
                      <h6>{{ 'HOSPITALITY_FIELDS.APPLIANCE_GUIDES_RESOURCES' | translate }}</h6>
                      <app-hospitality-link-preview
                        variant="list"
                        [links]="option.resources"
                      ></app-hospitality-link-preview>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </fieldset>

          <div class="hospitality-property-section">
            <div class="hospitality-group-label hospitality-group-label--property">
              {{ 'HOSPITALITY_FIELDS.PROPERTY_SOURCE_LABEL' | translate }}
            </div>

            <div class="source-option">
              <button
                type="button"
                class="preview-toggle"
                nz-button
                nzType="link"
                [attr.aria-expanded]="isOwnedEntryPreviewOpen(hospitalityGroup, 'applianceGuides')"
                [attr.aria-controls]="getPropertyPanelId(form, 'applianceGuides')"
                (click)="toggleApplianceGuidePreview(hospitalityGroup)"
              >
                <span nz-icon [nzType]="isOwnedEntryPreviewOpen(hospitalityGroup, 'applianceGuides') ? 'eye-invisible' : 'eye'"></span>
                <span class="sr-only">{{ 'HOSPITALITY_FIELDS.TOGGLE_PREVIEW' | translate }}</span>
              </button>
            </div>

            <div formGroupName="applianceGuides">
              <ng-container formArrayName="ownedEntries">
                <div
                  class="hospitality-entry-array"
                  *ngIf="isOwnedEntryPreviewOpen(hospitalityGroup, 'applianceGuides')"
                  [attr.id]="getPropertyPanelId(form, 'applianceGuides')"
                >
                  <div
                    class="hospitality-entry"
                    *ngFor="let entryGroup of getApplianceGuideOwnedEntries(form).controls; let i = index"
                    [formGroupName]="i"
                  >
                    <div class="hospitality-entry__actions">
                      <button
                        nz-button
                        nzType="default"
                        nzShape="circle"
                        nzDanger
                        type="button"
                        (click)="removeApplianceGuideOwnedEntry(form, i)"
                      >
                        <span nz-icon nzType="delete"></span>
                      </button>
                    </div>

                    <div class="hospitality-form-grid">
                      <nz-form-item>
                        <nz-form-label>{{ 'HOSPITALITY_FIELDS.APPLIANCE_GUIDES_APPLIANCE' | translate }}</nz-form-label>
                        <nz-form-control>
                          <input
                            nz-input
                            formControlName="appliance"
                            [attr.maxlength]="HOSPITALITY_LIMITS.title"
                          />
                        </nz-form-control>
                      </nz-form-item>
                      <nz-form-item>
                        <nz-form-label>{{ 'HOSPITALITY_FIELDS.APPLIANCE_GUIDES_SUMMARY' | translate }}</nz-form-label>
                        <nz-form-control>
                          <input
                            nz-input
                            formControlName="summary"
                            [attr.maxlength]="HOSPITALITY_LIMITS.summary"
                          />
                        </nz-form-control>
                      </nz-form-item>
                      <div formArrayName="steps" class="hospitality-array hospitality-span-all">
                        <label>{{ 'HOSPITALITY_FIELDS.APPLIANCE_GUIDES_STEPS' | translate }}</label>
                        <div
                          class="array-item step-row"
                          *ngFor="let stepControl of getApplianceGuideOwnedEntrySteps(form, i).controls; let stepIndex = index"
                        >
                          <input
                            nz-input
                            [formControlName]="stepIndex"
                            [attr.maxlength]="HOSPITALITY_LIMITS.details"
                          />
                          <button
                            nz-button
                            nzType="default"
                            nzShape="circle"
                            nzDanger
                            type="button"
                            (click)="removeApplianceGuideOwnedEntryStep(form, i, stepIndex)"
                          >
                            <span nz-icon nzType="delete"></span>
                          </button>
                        </div>
                        <button nz-button nzType="dashed" type="button" (click)="addApplianceGuideOwnedEntryStep(form, i)">
                          {{ 'HOSPITALITY_FIELDS.ADD_STEP' | translate }}
                        </button>
                      </div>
                    </div>

                    <div formArrayName="resources" class="hospitality-array hospitality-span-all">
                      <label>{{ 'HOSPITALITY_FIELDS.APPLIANCE_GUIDES_RESOURCES' | translate }}</label>
                      <div
                        class="array-item hospitality-link-row"
                        *ngFor="let resourceGroup of getApplianceGuideOwnedEntryResources(form, i).controls; let resourceIndex = index"
                        [formGroupName]="resourceIndex"
                      >
                        <input
                          nz-input
                          formControlName="label"
                          [placeholder]="'HOSPITALITY_FIELDS.LINK_LABEL' | translate"
                          [attr.maxlength]="HOSPITALITY_LIMITS.linkLabel"
                        />
                        <input
                          nz-input
                          formControlName="url"
                          [placeholder]="'HOSPITALITY_FIELDS.LINK_URL' | translate"
                          [attr.maxlength]="HOSPITALITY_LIMITS.linkUrl"
                        />
                          <ng-container
                            *ngTemplateOutlet="
                              hospitalityLinkDocumentTemplate;
                            context: {
                              form: form,
                              linkGroup: resourceGroup,
                              removeHandler: removeApplianceGuideOwnedEntryResource.bind(this, form, i, resourceIndex)
                            }
                          "
                        ></ng-container>
                      </div>
                      <button nz-button nzType="dashed" type="button" (click)="addApplianceGuideOwnedEntryResource(form, i)">
                        {{ 'HOSPITALITY_FIELDS.ADD_LINK' | translate }}
                      </button>
                    </div>
                  </div>
                </div>
              </ng-container>

              <button
                nz-button
                nzType="dashed"
                type="button"
                (click)="addApplianceGuideOwnedEntry(form)"
              >
                {{ 'HOSPITALITY_FIELDS.ADD_APPLIANCE_GUIDE' | translate }}
              </button>
            </div>
          </div>
        </nz-collapse-panel>

      </ng-container>
      <!-- Local Tips -->
      <ng-container *ngIf="showSection(activeSection, 'localTips')">
        <nz-collapse-panel [nzHeader]="'HOSPITALITY_FIELDS.LOCAL_TIPS_TITLE' | translate">
          <div formGroupName="localTips" class="hospitality-form-grid">
            <nz-form-item>
              <nz-form-label>{{ 'HOSPITALITY_FIELDS.LOCAL_TIPS_INTRO' | translate }}</nz-form-label>
              <nz-form-control>
                <textarea nz-input formControlName="intro"></textarea>
              </nz-form-control>
            </nz-form-item>
            <nz-form-item>
              <nz-form-label>{{ 'HOSPITALITY_FIELDS.LOCAL_TIPS_MAP' | translate }}</nz-form-label>
              <nz-form-control>
                <nz-form-text>{{ 'HOSPITALITY_FIELDS.LOCAL_TIPS_MAP_AUTOMATIC' | translate }}</nz-form-text>
              </nz-form-control>
            </nz-form-item>
            <div formArrayName="highlights" class="hospitality-array">
              <label>{{ 'HOSPITALITY_FIELDS.LOCAL_TIPS_LINKS' | translate }}</label>
              <div
                class="array-item hospitality-link-row hospitality-link-row--local-tip"
                *ngFor="let highlight of getLocalTipsHighlights(form).controls; let i = index"
                [formGroupName]="i"
              >
                <input
                  nz-input
                  formControlName="label"
                  [placeholder]="'HOSPITALITY_FIELDS.LINK_LABEL' | translate"
                  [attr.maxlength]="HOSPITALITY_LIMITS.linkLabel"
                />
                <input
                  nz-input
                  formControlName="address"
                  [placeholder]="'HOSPITALITY_FIELDS.MAP_ADDRESS' | translate"
                  [attr.maxlength]="HOSPITALITY_LIMITS.location"
                />
                <ng-container
                  *ngTemplateOutlet="
                    hospitalityLinkDocumentTemplate;
                    context: {
                      form: form,
                      linkGroup: highlight,
                      removeHandler: removeLocalTipHighlight.bind(this, form, i),
                      hideDocumentUpload: true
                    }
                  "
                ></ng-container>
              </div>
              <button nz-button nzType="dashed" type="button" (click)="addLocalTipHighlight(form)">
                {{ 'HOSPITALITY_FIELDS.ADD_HIGHLIGHT' | translate }}
              </button>
            </div>
          </div>
        </nz-collapse-panel>
      </ng-container>
      <!-- Info Sections -->
      <ng-container *ngIf="showSection(activeSection, 'infoSections')">
        <nz-collapse-panel [nzHeader]="'HOSPITALITY_FIELDS.INFO_SECTIONS_TITLE' | translate">
          <div formGroupName="additionalInfo">
            <fieldset class="hospitality-source" *ngIf="companyAdditionalInfoOptions.length">
              <legend>{{ 'HOSPITALITY_FIELDS.INFO_SECTIONS_TITLE' | translate }}</legend>
              <div class="hospitality-group-label hospitality-group-label--company">
                {{ 'HOSPITALITY_FIELDS.COMPANY_SOURCE_LABEL' | translate }}
              </div>
              <div
                class="company-options"
                [attr.id]="getCompanyListPanelId(form, 'additionalInfo')"
              >
                <div class="company-option" *ngFor="let option of companyAdditionalInfoOptions">
                  <label
                    nz-checkbox
                    [nzChecked]="isAdditionalInfoCompanySelected(form, option.id)"
                    (nzCheckedChange)="setAdditionalInfoCompanySelection(form, option.id, $event)"
                    [attr.aria-controls]="getCompanyPreviewPanelId(form, 'additionalInfo', option.id)"
                  >
                    {{ option.title || option.id }}
                  </label>
                  <button
                    type="button"
                    class="preview-toggle"
                    nz-button
                    nzType="link"
                    [attr.aria-expanded]="isCompanyPreviewOpen(form, 'additionalInfo', option.id)"
                    [attr.aria-controls]="getCompanyPreviewPanelId(form, 'additionalInfo', option.id)"
                    (click)="toggleCompanyPreview(form, 'additionalInfo', option.id)"
                  >
                    <span nz-icon [nzType]="isCompanyPreviewOpen(form, 'additionalInfo', option.id) ? 'eye-invisible' : 'eye'"></span>
                    <span class="sr-only">{{ 'HOSPITALITY_FIELDS.TOGGLE_PREVIEW' | translate }}</span>
                  </button>
                  <div
                    class="company-preview"
                    *ngIf="isCompanyPreviewOpen(form, 'additionalInfo', option.id)"
                    [attr.id]="getCompanyPreviewPanelId(form, 'additionalInfo', option.id)"
                  >
                    <h5 *ngIf="option.title">{{ option.title }}</h5>
                    <p *ngIf="option.summary && option.summary !== option.title">{{ option.summary }}</p>
                    <p *ngIf="option.body">{{ option.body }}</p>
                    <div *ngIf="option.links?.length" class="hospitality-links-preview">
                      <app-hospitality-link-preview variant="list" [links]="option.links || []"></app-hospitality-link-preview>
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>

            <div class="hospitality-group-label hospitality-group-label--property">
              {{ 'HOSPITALITY_FIELDS.PROPERTY_SOURCE_LABEL' | translate }}
            </div>

            <div formArrayName="infoSections" class="hospitality-array">
              <div class="array-item" *ngFor="let section of getInfoSections(form).controls; let i = index" [formGroupName]="i">
                <input nz-input formControlName="title" [placeholder]="'HOSPITALITY_FIELDS.INFO_SECTIONS_HEADING' | translate" />
                <textarea
                  nz-input
                  formControlName="body"
                  [placeholder]="'HOSPITALITY_FIELDS.INFO_SECTIONS_BODY' | translate"
                  [attr.maxlength]="HOSPITALITY_LIMITS.infoSectionBody"
                  [nzAutosize]="{ minRows: 3 }"
                ></textarea>
                <div
                  class="hospitality-error"
                  *ngIf="section.get('body')?.invalid && (section.get('body')?.dirty || section.get('body')?.touched)"
                >
                  <ng-container *ngIf="section.get('body')?.errors?.['maxlength']">
                    {{ 'HOSPITALITY_FIELDS.INFO_SECTIONS_BODY_MAXLENGTH' | translate:{ max: HOSPITALITY_LIMITS.infoSectionBody } }}
                  </ng-container>
                  <ng-container *ngIf="section.get('body')?.errors?.['required']">
                    {{ 'HOSPITALITY_FIELDS.INFO_SECTIONS_BODY_REQUIRED' | translate }}
                  </ng-container>
                </div>
                <div formArrayName="links" class="nested-array">
                  <label>{{ 'HOSPITALITY_FIELDS.INFO_SECTIONS_LINKS' | translate }}</label>
                  <div
                    class="array-item hospitality-link-row"
                    *ngFor="let link of getInfoSectionLinks(section).controls; let j = index"
                    [formGroupName]="j"
                  >
                    <input nz-input formControlName="label" [placeholder]="'HOSPITALITY_FIELDS.LINK_LABEL' | translate" />
                    <input nz-input formControlName="url" [placeholder]="'HOSPITALITY_FIELDS.LINK_URL' | translate" />
                    <ng-container
                      *ngTemplateOutlet="
                        hospitalityLinkDocumentTemplate;
                        context: {
                          form: form,
                          linkGroup: link,
                          removeHandler: removeInfoSectionLink.bind(this, section, j)
                        }
                      "
                    ></ng-container>
                  </div>
                </div>
                <div class="info-section-actions">
                  <button nz-button nzType="dashed" type="button" (click)="addInfoSectionLink(section)">
                    {{ 'HOSPITALITY_FIELDS.ADD_LINK' | translate }}
                  </button>
                  <button
                    nz-button
                    nzType="default"
                    nzDanger
                    type="button"
                    class="info-section-actions__remove"
                    (click)="removeInfoSection(form, i)"
                  >
                    {{ 'HOSPITALITY_FIELDS.REMOVE_ENTRY' | translate }}
                  </button>
                </div>
              </div>
              <button nz-button nzType="dashed" type="button" (click)="addInfoSection(form)">
                {{ 'HOSPITALITY_FIELDS.ADD_INFO_SECTION' | translate }}
              </button>
            </div>
          </div>
        </nz-collapse-panel>
      </ng-container>
    </nz-collapse>
  </div>
</ng-template>
<!-- Add Property Modal -->
<nz-modal
  [(nzVisible)]="addModalVisible"
  [nzZIndex]="900"
  nzTitle="{{ 'PROPERTY_LIST.ADD_PROPERTY_TITLE' | translate }}"
  (nzOnCancel)="toggleAddModal()"
  (nzOnOk)="saveNewProperty()"
  nzWidth="900px"
  [nzOkText]="'COMMON.SAVE' | translate"
  [nzMaskClosable]="false"
  [nzKeyboard]="false"
>
  <ng-container *nzModalContent>
    <!-- STEPS: dynamic -->
    <nz-steps
      [nzCurrent]="currentAddStep"
      nzType="navigation"
      (nzIndexChange)="onAddStepIndexChange($event)"
      style="margin-bottom: 16px;"
    >
      <nz-step *ngFor="let s of addSteps; trackBy: trackByStep" [nzTitle]="($any(s).titleKey || s.key) | translate"></nz-step>
    </nz-steps>

    <div class="property-add-form">
      <form nz-form nzLayout="vertical" [formGroup]="addPropertyForm" class="add-form-grid">

        <!-- DEFAULT/OPERATIONS (non-hospitality) flow -->
        <ng-container *ngIf="!isHospitalityMode()">
          <!-- Step 0 -->
          <ng-container *ngIf="addSteps[currentAddStep]?.key === 'basics'">
            <div nz-row [nzGutter]="16">
              <div
                nz-col
                [nzXs]="24"
                [nzMd]="multiLandingProfilesEnabled && addPropertyForm.contains('landingProfileId') ? 16 : 24"
              >
                <nz-form-item>
                  <nz-form-label>
                    <span>{{ 'PROPERTY_LIST.ADDRESS' | translate }}</span>
                    <span
                      nz-icon
                      nzType="info-circle"
                      nz-popover
                      [nzPopoverTitle]="'COMMON.ADDRESS_FORMAT_HELP_TITLE' | translate"
                      [nzPopoverContent]="addressFormatPopover"
                      nzPopoverPlacement="rightTop"
                      nzPopoverOverlayClassName="address-format-popover"
                      style="margin-left: 6px; cursor: pointer;"
                    ></span>
                  </nz-form-label>
                  <nz-form-control [nzValidateStatus]="addPropertyForm.get('address')!" nzHasFeedback [nzErrorTip]="addAddressErrTpl">
                    <input nz-input formControlName="address" placeholder="{{ 'PROPERTY_LIST.ADDRESS' | translate }}" />
                    <ng-template #addAddressErrTpl let-control>
                      <ng-container *ngIf="control.hasError('required')">
                        {{ 'PROPERTY_LIST.ADDRESS_REQUIRED' | translate }}
                      </ng-container>
                      <ng-container *ngIf="control.hasError('invalidAddress')">
                        {{ 'FORM_ERRORS.ADDRESS_ERROR' | translate }}
                      </ng-container>
                    </ng-template>
                  </nz-form-control>
                </nz-form-item>
              </div>

              <div nz-col [nzXs]="24" [nzMd]="8" *ngIf="multiLandingProfilesEnabled && addPropertyForm.contains('landingProfileId')">
                <nz-form-item>
                  <nz-form-label>{{ 'PROPERTY_LIST.LANDING_PROFILE' | translate }}</nz-form-label>
                  <nz-form-control>
                    <nz-select formControlName="landingProfileId">
                      <nz-option [nzLabel]="'PROPERTY_LIST.LANDING_PROFILE_USE_COMPANY' | translate" [nzValue]="useCompanyLandingProfileValue"></nz-option>
                      <nz-option
                        *ngFor="let profile of landingProfiles"
                        [nzLabel]="profile.profileName"
                        [nzValue]="profile._id"
                      ></nz-option>
                    </nz-select>
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>
          </ng-container>

          <!-- Step 1 -->
          <ng-container *ngIf="addSteps[currentAddStep]?.key === 'contacts'">
            <div class="manager-fields-group">
              <div class="manager-fields-grid">
            <nz-form-item class="manager-grid-field" *ngIf="savedHeaders?.caretakerHeaders?.includes('CARETAKER_NAME')">
              <nz-form-label>{{ 'PROPERTY_LIST.CARETAKER' | translate }}</nz-form-label>
              <nz-form-control>
                <nz-select
                  #addCaretakerSelect="nzSelect"
                  formControlName="caretaker"
                  nzDropdownClassName="inline-edit-dd"
                  nzShowSearch
                  [nzFilterOption]="filterOptions"
                  nzAllowClear
                  [nzNotFoundContent]="addCaretakerEmptyTpl"
                  [nzDropdownRender]="addCaretakerDropdownTpl"
                >
                  <nz-option
                    *ngFor="let caretaker of caretakers"
                    [nzLabel]="caretaker.contactPerson ? (caretaker.name + ' (' + caretaker.contactPerson + ')') : caretaker.name"
                    [nzValue]="caretaker._id"
                    nzCustomContent
                  >
                    <div class="select-option-row">
                      <button
                        nz-button
                        nzType="text"
                        nzSize="small"
                        class="select-option-edit select-option-edit-left"
                        nz-tooltip
                        [nzTooltipTitle]="'CONTACTS.EDIT' | translate"
                        (mousedown)="$event.preventDefault(); $event.stopPropagation()"
                        (click)="editDropdownOption($event, 'caretaker', caretaker._id, addCaretakerSelect)"
                      >
                        <span nz-icon nzType="edit"></span>
                      </button>
                    <span class="select-option-label">
                      {{ caretaker.contactPerson ? (caretaker.name + ' (' + caretaker.contactPerson + ')') : caretaker.name }}
                    </span>
                    </div>
                  </nz-option>
                </nz-select>
                <ng-template #addCaretakerDropdownTpl let-menu>
                  <ng-container [ngTemplateOutlet]="menu"></ng-container>
                  <div class="inline-add-dropdown-footer">
                    <button nz-button nzType="link" (click)="addInlineCaretaker(addPropertyForm)">
                      <span nz-icon nzType="plus"></span>
                      {{ 'PROPERTY_LIST.ADD_CARETAKER_INLINE' | translate }}
                    </button>
                    <button nz-button nzType="link" (click)="goToContacts()">
                      <span nz-icon nzType="team"></span>
                      {{ 'PROPERTY_LIST.MANAGE_IN_CONTACTS' | translate }}
                    </button>
                  </div>
                </ng-template>
                <ng-template #addCaretakerEmptyTpl>
                  <div class="inline-empty-content">
                    <div class="inline-empty-title">{{ 'PROPERTY_LIST.EMPTY_CONTACTS_TITLE' | translate }}</div>
                    <div class="inline-empty-desc">{{ 'PROPERTY_LIST.EMPTY_CONTACTS_DESC' | translate }}</div>
                  </div>
                </ng-template>
              </nz-form-control>
            </nz-form-item>

            <nz-form-item
              class="manager-grid-field caretaker-contact-person-selection"
              *ngIf="addPropertyForm.contains('caretakerContactPersonIds') && shouldShowCaretakerContactPersonSelection(addPropertyForm)"
            >
              <nz-form-label>{{ 'PROPERTY_LIST.CARETAKER_CONTACT_PERSONS' | translate }}</nz-form-label>
              <nz-form-control>
                <ng-container *ngIf="isCaretakerContactPersonOptionsLoaded(); else addCaretakerContactPersonsUnavailable">
                  <nz-select
                    #addCaretakerCPSelect="nzSelect"
                    formControlName="caretakerContactPersonIds"
                    nzMode="multiple"
                    nzShowSearch
                    nzAllowClear
                    [nzPlaceHolder]="'PROPERTY_LIST.CARETAKER_CONTACT_PERSONS_PLACEHOLDER' | translate"
                  >
                    <nz-option
                      *ngFor="let person of getCaretakerContactPersonsForForm(addPropertyForm)"
                      [nzLabel]="formatCaretakerContactPersonOption(person)"
                      [nzValue]="person._id"
                      nzCustomContent
                    >
                      <div class="select-option-row">
                        <button
                          nz-button
                          nzType="text"
                          nzSize="small"
                          class="select-option-edit select-option-edit-left"
                          nz-tooltip
                          [nzTooltipTitle]="'CONTACTS.EDIT' | translate"
                          (mousedown)="$event.preventDefault(); $event.stopPropagation()"
                          (click)="editCaretakerFromContactPerson($event, addPropertyForm.get('caretaker')?.value, addCaretakerCPSelect)"
                        >
                          <span nz-icon nzType="edit"></span>
                        </button>
                        <span class="select-option-label">
                          {{ formatCaretakerContactPersonOption(person) }}
                        </span>
                      </div>
                    </nz-option>
                  </nz-select>
                </ng-container>
                <ng-template #addCaretakerContactPersonsUnavailable>
                  <div class="caretaker-contact-persons-empty">{{ getCaretakerContactPersonOptionsStatusKey() | translate }}</div>
                </ng-template>
                <div class="caretaker-contact-persons-hint">{{ 'PROPERTY_LIST.CARETAKER_CONTACT_PERSONS_FALLBACK_HINT' | translate }}</div>
              </nz-form-control>
            </nz-form-item>

            <nz-form-item class="manager-grid-field" *ngIf="savedHeaders?.propertyManagerHeaders?.includes('PROPERTY_MANAGER_NAME')">
              <nz-form-label>{{ 'PROPERTY_LIST.PROPERTY_MANAGER' | translate }}</nz-form-label>
              <nz-form-control [nzValidateStatus]="addPropertyForm.get('propertyManagers')!">
                <nz-select
                  #addPmSelect="nzSelect"
                  formControlName="propertyManagers"
                  nzDropdownClassName="inline-edit-dd"
                  nzShowSearch
                  [nzFilterOption]="filterOptions"
                  nzAllowClear
                  [nzNotFoundContent]="addPmEmptyTpl"
                  [nzDropdownRender]="addPmDropdownTpl"
                >
                  <nz-option
                    *ngFor="let manager of propertyManagersModel"
                    [nzLabel]="manager.name"
                    [nzValue]="manager._id"
                    nzCustomContent
                  >
                    <div class="select-option-row">
                      <button
                        nz-button
                        nzType="text"
                        nzSize="small"
                        class="select-option-edit select-option-edit-left"
                        nz-tooltip
                        [nzTooltipTitle]="'CONTACTS.EDIT' | translate"
                        (mousedown)="$event.preventDefault(); $event.stopPropagation()"
                        (click)="editDropdownOption($event, 'propertyManager', manager._id, addPmSelect)"
                      >
                        <span nz-icon nzType="edit"></span>
                      </button>
                      <span class="select-option-label">{{ manager.name }}</span>
                    </div>
                  </nz-option>
                </nz-select>
                <ng-template #addPmDropdownTpl let-menu>
                  <ng-container [ngTemplateOutlet]="menu"></ng-container>
                  <div class="inline-add-dropdown-footer">
                    <button nz-button nzType="link" (click)="addInlinePropertyManager(addPropertyForm)">
                      <span nz-icon nzType="plus"></span>
                      {{ 'PROPERTY_LIST.ADD_PROPERTY_MANAGER_INLINE' | translate }}
                    </button>
                    <button nz-button nzType="link" (click)="goToContacts()">
                      <span nz-icon nzType="team"></span>
                      {{ 'PROPERTY_LIST.MANAGE_IN_CONTACTS' | translate }}
                    </button>
                  </div>
                </ng-template>
                <ng-template #addPmEmptyTpl>
                  <div class="inline-empty-content">
                    <div class="inline-empty-title">{{ 'PROPERTY_LIST.EMPTY_CONTACTS_TITLE' | translate }}</div>
                    <div class="inline-empty-desc">{{ 'PROPERTY_LIST.EMPTY_CONTACTS_DESC' | translate }}</div>
                  </div>
                </ng-template>
              </nz-form-control>
            </nz-form-item>

            <nz-form-item class="manager-grid-field" *ngIf="savedHeaders?.technicalAssetsManagerHeaders?.includes('TECHNICAL_ASSETS_MANAGER_NAME')">
              <nz-form-label>{{ 'PROPERTY_LIST.TECHNICAL_ASSETS_MANAGER' | translate }}</nz-form-label>
              <nz-form-control>
                <nz-select
                  #addTamSelect="nzSelect"
                  formControlName="technicalAssetsManagers"
                  nzDropdownClassName="inline-edit-dd"
                  nzShowSearch
                  [nzFilterOption]="filterOptions"
                  nzAllowClear
                  [nzNotFoundContent]="addTamEmptyTpl"
                  [nzDropdownRender]="addTamDropdownTpl"
                >
                  <nz-option
                    *ngFor="let manager of technicalAssetsManagers"
                    [nzLabel]="manager.name"
                    [nzValue]="manager._id"
                    nzCustomContent
                  >
                    <div class="select-option-row">
                      <button
                        nz-button
                        nzType="text"
                        nzSize="small"
                        class="select-option-edit select-option-edit-left"
                        nz-tooltip
                        [nzTooltipTitle]="'CONTACTS.EDIT' | translate"
                        (mousedown)="$event.preventDefault(); $event.stopPropagation()"
                        (click)="editDropdownOption($event, 'technicalAssetsManager', manager._id, addTamSelect)"
                      >
                        <span nz-icon nzType="edit"></span>
                      </button>
                      <span class="select-option-label">{{ manager.name }}</span>
                    </div>
                  </nz-option>
                </nz-select>
                <ng-template #addTamDropdownTpl let-menu>
                  <ng-container [ngTemplateOutlet]="menu"></ng-container>
                  <div class="inline-add-dropdown-footer">
                    <button nz-button nzType="link" (click)="addInlineTechnicalAssetsManager(addPropertyForm)">
                      <span nz-icon nzType="plus"></span>
                      {{ 'PROPERTY_LIST.ADD_TECHNICAL_ASSETS_MANAGER_INLINE' | translate }}
                    </button>
                    <button nz-button nzType="link" (click)="goToContacts()">
                      <span nz-icon nzType="team"></span>
                      {{ 'PROPERTY_LIST.MANAGE_IN_CONTACTS' | translate }}
                    </button>
                  </div>
                </ng-template>
                <ng-template #addTamEmptyTpl>
                  <div class="inline-empty-content">
                    <div class="inline-empty-title">{{ 'PROPERTY_LIST.EMPTY_CONTACTS_TITLE' | translate }}</div>
                    <div class="inline-empty-desc">{{ 'PROPERTY_LIST.EMPTY_CONTACTS_DESC' | translate }}</div>
                  </div>
                </ng-template>
              </nz-form-control>
            </nz-form-item>

            <nz-form-item class="manager-grid-field" *ngIf="savedHeaders?.sevManagerHeaders?.includes('CONDOMINIUM_MANAGER_NAME')">
              <nz-form-label>{{ 'PROPERTY_LIST.CONDOMINIUM_MANAGER' | translate }}</nz-form-label>
              <nz-form-control>
                <nz-select
                  #addSevSelect="nzSelect"
                  formControlName="sevManagers"
                  nzDropdownClassName="inline-edit-dd"
                  nzShowSearch
                  [nzFilterOption]="filterOptions"
                  nzAllowClear
                  [nzNotFoundContent]="addSevEmptyTpl"
                  [nzDropdownRender]="addSevDropdownTpl"
                >
                  <nz-option
                    *ngFor="let manager of sevManagersModel"
                    [nzLabel]="manager.name"
                    [nzValue]="manager._id"
                    nzCustomContent
                  >
                    <div class="select-option-row">
                      <button
                        nz-button
                        nzType="text"
                        nzSize="small"
                        class="select-option-edit select-option-edit-left"
                        nz-tooltip
                        [nzTooltipTitle]="'CONTACTS.EDIT' | translate"
                        (mousedown)="$event.preventDefault(); $event.stopPropagation()"
                        (click)="editDropdownOption($event, 'sevManager', manager._id, addSevSelect)"
                      >
                        <span nz-icon nzType="edit"></span>
                      </button>
                      <span class="select-option-label">{{ manager.name }}</span>
                    </div>
                  </nz-option>
                </nz-select>
                <ng-template #addSevDropdownTpl let-menu>
                  <ng-container [ngTemplateOutlet]="menu"></ng-container>
                  <div class="inline-add-dropdown-footer">
                    <button nz-button nzType="link" (click)="addInlineSevManager(addPropertyForm)">
                      <span nz-icon nzType="plus"></span>
                      {{ 'PROPERTY_LIST.ADD_CONDOMINIUM_MANAGER_INLINE' | translate }}
                    </button>
                    <button nz-button nzType="link" (click)="goToContacts()">
                      <span nz-icon nzType="team"></span>
                      {{ 'PROPERTY_LIST.MANAGE_IN_CONTACTS' | translate }}
                    </button>
                  </div>
                </ng-template>
                <ng-template #addSevEmptyTpl>
                  <div class="inline-empty-content">
                    <div class="inline-empty-title">{{ 'PROPERTY_LIST.EMPTY_CONTACTS_TITLE' | translate }}</div>
                    <div class="inline-empty-desc">{{ 'PROPERTY_LIST.EMPTY_CONTACTS_DESC' | translate }}</div>
                  </div>
                </ng-template>
              </nz-form-control>
            </nz-form-item>

            <nz-form-item class="manager-grid-field" *ngIf="savedHeaders?.accountantHeaders?.includes('ACCOUNTANT_NAME')">
              <nz-form-label>{{ 'PROPERTY_LIST.ACCOUNTANT' | translate }}</nz-form-label>
              <nz-form-control>
                <nz-select
                  #addAccountantSelect="nzSelect"
                  formControlName="accountants"
                  nzDropdownClassName="inline-edit-dd"
                  nzShowSearch
                  [nzFilterOption]="filterOptions"
                  nzAllowClear
                  [nzNotFoundContent]="addAccountantEmptyTpl"
                  [nzDropdownRender]="addAccountantDropdownTpl"
                >
                  <nz-option
                    *ngFor="let accountant of accountantsModel"
                    [nzLabel]="accountant.name"
                    [nzValue]="accountant._id"
                    nzCustomContent
                  >
                    <div class="select-option-row">
                      <button
                        nz-button
                        nzType="text"
                        nzSize="small"
                        class="select-option-edit select-option-edit-left"
                        nz-tooltip
                        [nzTooltipTitle]="'CONTACTS.EDIT' | translate"
                        (mousedown)="$event.preventDefault(); $event.stopPropagation()"
                        (click)="editDropdownOption($event, 'accountant', accountant._id, addAccountantSelect)"
                      >
                        <span nz-icon nzType="edit"></span>
                      </button>
                      <span class="select-option-label">{{ accountant.name }}</span>
                    </div>
                  </nz-option>
                </nz-select>
                <ng-template #addAccountantDropdownTpl let-menu>
                  <ng-container [ngTemplateOutlet]="menu"></ng-container>
                  <div class="inline-add-dropdown-footer">
                    <button nz-button nzType="link" (click)="addInlineAccountant(addPropertyForm)">
                      <span nz-icon nzType="plus"></span>
                      {{ 'PROPERTY_LIST.ADD_ACCOUNTANT_INLINE' | translate }}
                    </button>
                    <button nz-button nzType="link" (click)="goToContacts()">
                      <span nz-icon nzType="team"></span>
                      {{ 'PROPERTY_LIST.MANAGE_IN_CONTACTS' | translate }}
                    </button>
                  </div>
                </ng-template>
                <ng-template #addAccountantEmptyTpl>
                  <div class="inline-empty-content">
                    <div class="inline-empty-title">{{ 'PROPERTY_LIST.EMPTY_CONTACTS_TITLE' | translate }}</div>
                    <div class="inline-empty-desc">{{ 'PROPERTY_LIST.EMPTY_CONTACTS_DESC' | translate }}</div>
                  </div>
                </ng-template>
              </nz-form-control>
            </nz-form-item>
              </div>

            <div class="manager-group-error" *ngIf="hasManagerSelectionError(addPropertyForm)">
              <span nz-icon nzType="exclamation-circle" nzTheme="outline"></span>
              {{ getManagerRequiredMessage() }}
            </div>
            </div>
          </ng-container>

          <!-- Step 2 -->
          <ng-container *ngIf="addSteps[currentAddStep]?.key === 'services'">
            <ng-container *ngIf="technicalServiceTypes?.length">
              <div class="full-row services-step-panel">
                <div
                  class="services-step-grid"
                  [class.services-step-grid--single]="visibleAddServiceTypes.length === 1"
                >
                  <ng-container *ngFor="let serviceType of visibleAddServiceTypes; trackBy: trackByServiceType">
                    <nz-form-item>
                      <nz-form-label>
                        {{ ('TECHNICAL_SERVICES.' + (serviceTypeTranslationKeys[serviceType] || serviceType)) | translate }}
                      </nz-form-label>
                      <nz-form-control>
                        <nz-select
                          #addServiceSelect="nzSelect"
                          [formControlName]="serviceType"
                          nzDropdownClassName="inline-edit-dd"
                          nzMode="multiple"
                          nzShowSearch
                          [nzFilterOption]="filterOptions"
                          nzAllowClear
                          [nzNotFoundContent]="addServiceEmptyTpl"
                          [nzDropdownRender]="addServiceDropdownTpl"
                        >
                          <nz-option
                            *ngFor="let service of getServicesByType(serviceType); trackBy: trackByServiceId"
                            [nzLabel]="service.serviceName"
                            [nzValue]="getServiceOptionValue(service)"
                            nzCustomContent
                          >
                            <div class="select-option-row">
                              <button
                                nz-button
                                nzType="text"
                                nzSize="small"
                                class="select-option-edit select-option-edit-left"
                              nz-tooltip
                              [nzTooltipTitle]="'CONTACTS.EDIT' | translate"
                              (mousedown)="$event.preventDefault(); $event.stopPropagation()"
                              (click)="editDropdownOption($event, 'service', getServiceOptionValue(service), addServiceSelect)"
                            >
                                <span nz-icon nzType="edit"></span>
                              </button>
                              <span class="select-option-label">{{ service.serviceName }}</span>
                            </div>
                          </nz-option>
                        </nz-select>
                        <ng-template #addServiceDropdownTpl let-menu>
                          <ng-container [ngTemplateOutlet]="menu"></ng-container>
                          <div class="inline-add-dropdown-footer">
                            <button nz-button nzType="link" (click)="addInlineService(addPropertyForm, serviceType)">
                              <span nz-icon nzType="plus"></span>
                              {{ 'PROPERTY_LIST.ADD_SERVICE_INLINE' | translate }}
                            </button>
                            <button nz-button nzType="link" (click)="goToContacts()">
                              <span nz-icon nzType="team"></span>
                              {{ 'PROPERTY_LIST.MANAGE_IN_CONTACTS' | translate }}
                            </button>
                          </div>
                        </ng-template>
                        <ng-template #addServiceEmptyTpl>
                          <div class="inline-empty-content">
                            <div class="inline-empty-title">{{ 'PROPERTY_LIST.EMPTY_SERVICES_TITLE' | translate }}</div>
                            <div class="inline-empty-desc">{{ 'PROPERTY_LIST.EMPTY_SERVICES_DESC' | translate }}</div>
                          </div>
                        </ng-template>
                      </nz-form-control>
                    </nz-form-item>
                  </ng-container>
                </div>
                <div class="services-step-loading" *ngIf="isAddServicesStepRendering">
                  <nz-spin nzSimple></nz-spin>
                </div>
              </div>
              <div class="full-row">
                <nz-alert
                  nzType="info"
                  nzShowIcon
                  [nzDescription]="servicesMoreTypesTpl"
                  style="margin-top: 12px;"
                ></nz-alert>
              </div>
            </ng-container>
          </ng-container>

          <!-- Step 3 -->
          <ng-container *ngIf="addSteps[currentAddStep]?.key === 'hospitality'">
            <ng-container *ngTemplateOutlet="hospitalityForm; context: { form: addPropertyForm }"></ng-container>
          </ng-container>
        </ng-container>

        <!-- HOSPITALITY MODE: Address only on Basics (full width), sections below; other steps = sections only -->
        <ng-container *ngIf="isHospitalityMode()">

          <!-- Basics step -->
          <ng-container *ngIf="addSteps[currentAddStep]?.key === 'basics'; else hospSectionsOnlyAdd">
            <div class="full-row">
              <nz-form-item>
                <nz-form-label>
                  <span>{{ 'PROPERTY_LIST.ADDRESS' | translate }}</span>
                  <span
                    nz-icon
                    nzType="info-circle"
                    nz-popover
                    [nzPopoverTitle]="'COMMON.ADDRESS_FORMAT_HELP_TITLE' | translate"
                    [nzPopoverContent]="addressFormatPopover"
                    nzPopoverPlacement="rightTop"
                    nzPopoverOverlayClassName="address-format-popover"
                    style="margin-left: 6px; cursor: pointer;"
                  ></span>
                </nz-form-label>
                <nz-form-control [nzValidateStatus]="addPropertyForm.get('address')!" nzHasFeedback>
                  <input nz-input formControlName="address" placeholder="{{ 'PROPERTY_LIST.ADDRESS' | translate }}" />
                </nz-form-control>
              </nz-form-item>
            </div>

            <ng-container
              *ngTemplateOutlet="hospitalityForm; context: { form: addPropertyForm, activeSection: activeAddHospSections }">
            </ng-container>
          </ng-container>

          <!-- Other steps -->
          <ng-template #hospSectionsOnlyAdd>
            <ng-container
              *ngTemplateOutlet="hospitalityForm; context: { form: addPropertyForm, activeSection: activeAddHospSections }">
            </ng-container>
          </ng-template>

        </ng-container>

          </form>
        </div>

    <div style="display:flex; justify-content:space-between; margin-top:12px;">
      <button nz-button (click)="prevAddStep()" [disabled]="currentAddStep===0">{{ 'COMMON.BACK' | translate }}</button>
      <div>
        <button
          nz-button
          nzType="default"
          (click)="nextAddStep()"
          [disabled]="isLastAddStep"
        >
          {{ 'COMMON.NEXT' | translate }}
        </button>
      </div>
    </div>
  </ng-container>
</nz-modal>
<nz-modal
  [(nzVisible)]="documentModalVisible"
  [nzTitle]="('DOCUMENT_MODAL.TITLE' | translate) + (selectedProperty?.address ? ' · ' + selectedProperty.address : '')"
  [nzWidth]="'700px'"
  [nzFooter]="documentModalFooter"
  (nzOnCancel)="closeDocumentModal()"
>
  <ng-container *nzModalContent>
    <ng-container *ngIf="showPmsTabs; else scanafyOnlyDocumentModal">
      <nz-tabset [(nzSelectedIndex)]="documentTabIndex">
        <nz-tab [nzTitle]="'DOCUMENT_MODAL.TABS.ALL' | translate">
          <div class="space-y-4">
            <ng-container *ngTemplateOutlet="scanafyUploadsTemplate"></ng-container>
            <ng-container *ngTemplateOutlet="pmsDocumentsTemplate; context: { documents: pmsDocuments }"></ng-container>
            <ng-container *ngTemplateOutlet="missingPmsDocumentsTemplate; context: { documents: missingPmsDocuments }"></ng-container>
          </div>
        </nz-tab>
        <nz-tab [nzTitle]="'DOCUMENT_MODAL.TABS.UPLOADED_IN_SCANAFY' | translate">
          <div class="space-y-4">
            <ng-container *ngTemplateOutlet="scanafyUploadsTemplate"></ng-container>
          </div>
        </nz-tab>
        <nz-tab [nzTitle]="'DOCUMENT_MODAL.TABS.SYNCED_FROM_PMS' | translate">
          <ng-container *ngTemplateOutlet="pmsDocumentsTemplate; context: { documents: pmsDocuments }"></ng-container>
        </nz-tab>
        <nz-tab [nzTitle]="'DOCUMENT_MODAL.TABS.MISSING_FROM_PMS' | translate">
          <ng-container *ngTemplateOutlet="missingPmsDocumentsTemplate; context: { documents: missingPmsDocuments }"></ng-container>
        </nz-tab>
      </nz-tabset>
    </ng-container>

    <ng-template #scanafyOnlyDocumentModal>
      <ng-container *ngTemplateOutlet="scanafyUploadsTemplate"></ng-container>
    </ng-template>

    <ng-template #scanafyUploadsTemplate>
      <div data-tour="property-files-modal">
      <nz-alert
        *ngIf="documentValidationMessageKey"
        [nzType]="'error'"
        [nzMessage]="documentValidationMessageKey | translate"
        nzShowIcon
        class="mb-4"
      />
      <nz-alert
        [nzType]="'info'"
        [nzMessage]="'DOCUMENT_MODAL.SECTION_INFO_TITLE' | translate"
        [nzDescription]="'DOCUMENT_MODAL.SECTION_INFO_DESCRIPTION' | translate"
        nzShowIcon
        class="mb-4"
      />
      <nz-alert
        *ngIf="hasDocumentUploadsInProgress"
        [nzType]="'info'"
        [nzMessage]="'DOCUMENT_MODAL.UPLOADS_IN_PROGRESS' | translate"
        [nzDescription]="'DOCUMENT_MODAL.UPLOADS_IN_PROGRESS_HINT' | translate"
        nzShowIcon
        class="mb-4"
      />
      <div class="distribution-overview-toolbar">
        <button
          nz-button
          nzType="default"
          (click)="openDistributionOverview('document_section')"
        >
          {{ 'PROPERTY_DISTRIBUTION_OVERVIEW.OPEN_BUTTON' | translate }}
        </button>
      </div>
      <nz-collapse [nzBordered]="false" class="rounded-xl shadow-sm bg-white">
        <ng-container *ngFor="let section of documentSections; let i = index; trackBy: trackByDocumentSection">
        <ng-template #documentSectionHeader>
          <span class="document-section-header">
            <span>{{ section.title || ('DOCUMENT_MODAL.UNTITLED_SECTION' | translate) }}</span>
            <nz-tag *ngIf="isDocumentSectionCopy(section); else documentSectionSourceBadge"
                    nzColor="blue"
                    nz-tooltip
                    [nzTooltipTitle]="getCopySourcePropertyTooltip(section.originPropertyId)">
              {{ 'PROPERTY_DISTRIBUTION_OVERVIEW.COPY_BADGE' | translate }}
            </nz-tag>
            <ng-template #documentSectionSourceBadge>
              <nz-tag nzColor="green">{{ 'PROPERTY_DISTRIBUTION_OVERVIEW.SOURCE_BADGE' | translate }}</nz-tag>
            </ng-template>
          </span>
        </ng-template>
        <nz-collapse-panel
          [nzHeader]="documentSectionHeader"
          [nzActive]="true"
          [nzShowArrow]="true"
          class="p-4"
        >
          <div class="space-y-3">
            <label class="document-section-label" [attr.for]="'section-title-' + i">
              {{ 'DOCUMENT_MODAL.SECTION_TITLE_LABEL' | translate }}
            </label>
            <div class="document-section-helper">
              {{ 'DOCUMENT_MODAL.SECTION_TITLE_REQUIRED_HINT' | translate }}
            </div>
            <input
              [id]="'section-title-' + i"
              nz-input
              [(ngModel)]="section.title"
              (ngModelChange)="onSectionTitleChange(i)"
              (blur)="onSectionTitleBlur(i)"
              [placeholder]="'DOCUMENT_MODAL.SECTION_NAME_REQUIRED_PLACEHOLDER' | translate"
              name="sectionTitle-{{ i }}"
              required
              class="w-full mb-1"
              [class.document-field-invalid]="shouldShowSectionTitleError(section)"
            />
            <div *ngIf="shouldShowSectionTitleError(section)" class="document-validation-error">
              {{ 'DOCUMENT_MODAL.SECTION_TITLE_REQUIRED' | translate }}
            </div>

            <div class="document-section-label">
              {{ 'DOCUMENT_MODAL.SECTION_FILES_LABEL' | translate }}
            </div>
            <nz-upload
              class="upload-box w-full block"
              [class.document-field-invalid]="shouldShowSectionFilesError(section)"
              [class.upload-box-loading]="(section.uploadingCount || 0) > 0"
              nzType="drag"
              [nzCustomRequest]="getCustomRequestHandler(i)"
              [nzShowUploadList]="false"
              nzMultiple
              nzListType="text"
            >
              <p class="ant-upload-drag-icon"><i nz-icon nzType="inbox"></i></p>
              <p class="ant-upload-text">{{ 'DOCUMENT_MODAL.UPLOAD_HINT' | translate }}</p>
              <div *ngIf="(section.uploadingCount || 0) > 0" class="document-upload-progress">
                <nz-spin nzSimple></nz-spin>
                <div class="document-upload-progress__text">
                  {{ 'DOCUMENT_MODAL.UPLOADING' | translate:{ count: section.uploadingCount || 0 } }}
                </div>
                <div
                  *ngFor="let uploadingFileName of section.uploadingFileNames"
                  class="document-upload-progress__file"
                >
                  {{ uploadingFileName }}
                </div>
              </div>
            </nz-upload>
            <div *ngIf="shouldShowSectionFilesError(section)" class="document-validation-error">
              {{ 'DOCUMENT_MODAL.SECTION_FILES_REQUIRED' | translate }}
            </div>

            <div *ngIf="section.files.length" class="space-y-3 mt-4">
              <div
                *ngFor="let file of section.files; trackBy: trackByDocumentFile"
                class="file-preview-box bg-gray-50 p-4 rounded-md shadow-sm border space-y-2 mt-2"
              >
                <div class="file-preview-header">
                  <div class="font-medium truncate">{{ file.fileName }}</div>
                  <nz-tag nzColor="blue">{{ 'DOCUMENT_MODAL.BADGES.UPLOADED' | translate }}</nz-tag>
                </div>

                <ng-container [ngSwitch]="file.fileType.toLowerCase()">
                  <ng-container *ngSwitchCase="'pdf'">
                    <div class="pdf-preview-shell">
                      <iframe
                        [src]="file.safeUrl"
                        [title]="'DOCUMENT_MODAL.PREVIEW_ALT' | translate"
                        class="pdf-preview-frame"
                        style="width: 100%; height: 280px; display: block;"
                      ></iframe>
                    </div>
                  </ng-container>

                  <!-- Image preview -->
                  <ng-container *ngSwitchCase="'jpg'">
                    <img
                      [src]="file.url"
                      [alt]="'DOCUMENT_MODAL.PREVIEW_ALT' | translate"
                      class="max-h-32 rounded-md border interactive-image"
                      (click)="openImagePreview(file.url)"
                      style="max-height: 128px; max-width: 100%; object-fit: contain;" />
                  </ng-container>

                  <ng-container *ngSwitchCase="'jpeg'">
                    <img
                      [src]="file.url"
                      [alt]="'DOCUMENT_MODAL.PREVIEW_ALT' | translate"
                      class="max-h-32 rounded-md border interactive-image"
                      (click)="openImagePreview(file.url)"
                      style="max-height: 128px; max-width: 100%; object-fit: contain;" />
                  </ng-container>

                  <ng-container *ngSwitchCase="'png'">
                    <img
                      [src]="file.url"
                      [alt]="'DOCUMENT_MODAL.PREVIEW_ALT' | translate"
                      class="max-h-32 rounded-md border interactive-image"
                      (click)="openImagePreview(file.url)"
                      style="max-height: 128px; max-width: 100%; object-fit: contain;"
                    />
                  </ng-container>

                  <ng-container *ngSwitchDefault>
                    <a [href]="file.url" target="_blank" class="text-blue-600 underline">
                      {{ 'DOCUMENT_MODAL.ACTIONS.VIEW_DOCUMENT' | translate }}
                    </a>
                  </ng-container>
                </ng-container>

                <div class="flex justify-between items-center pt-2">
                  <a [href]="file.url" download class="text-sm text-blue-600 hover:underline">
                    {{ 'DOCUMENT_MODAL.DOWNLOAD' | translate }}
                  </a>
                  <button
                    nz-button
                    nzType="default"
                    nzDanger
                    nzSize="small"
                    [disabled]="(section.uploadingCount || 0) > 0"
                    (click)="removeFile(i, file)"
                  >
                    {{ 'DOCUMENT_MODAL.REMOVE_FILE' | translate }}
                  </button>
                </div>
              </div>
            </div>

            <div class="document-section-actions">
              <button
                *ngIf="canBulkApplyDocumentSections || canBulkDeleteDocumentSections"
                nz-button
                nzType="default"
                nz-dropdown
                [nzDropdownMenu]="documentSectionBulkMenu"
                [disabled]="(section.uploadingCount || 0) > 0"
              >
                <span nz-icon nzType="ellipsis"></span>
                {{ 'PROPERTY_BULK_APPLY.MORE_ACTIONS' | translate }}
              </button>
              <nz-dropdown-menu #documentSectionBulkMenu="nzDropdownMenu">
                <ul nz-menu>
                  <li nz-menu-item *ngIf="canBulkApplyDocumentSections"
                      [class.ant-dropdown-menu-item-disabled]="!canUseDocumentSectionBulkActions(section)"
                      (click)="canUseDocumentSectionBulkActions(section) && openDocumentSectionBulkApply(section, i)">
                    <span *ngIf="!canUseDocumentSectionBulkActions(section)" nz-tooltip [nzTooltipTitle]="getDocumentSectionBulkActionDisabledReason(section) | translate">
                      {{ 'PROPERTY_BULK_APPLY.APPLY_ACTION' | translate }}
                    </span>
                    <ng-container *ngIf="canUseDocumentSectionBulkActions(section)">
                      {{ 'PROPERTY_BULK_APPLY.APPLY_ACTION' | translate }}
                    </ng-container>
                  </li>
                  <li nz-menu-item *ngIf="canBulkApplyDocumentSections"
                      [class.ant-dropdown-menu-item-disabled]="!canUseDocumentSectionBulkActions(section)"
                      (click)="canUseDocumentSectionBulkActions(section) && openDocumentSectionBulkEdit(section, i)">
                    <span *ngIf="!canUseDocumentSectionBulkActions(section)" nz-tooltip [nzTooltipTitle]="getDocumentSectionBulkActionDisabledReason(section) | translate">
                      {{ 'PROPERTY_BULK_APPLY.EDIT_ACTION' | translate }}
                    </span>
                    <ng-container *ngIf="canUseDocumentSectionBulkActions(section)">
                      {{ 'PROPERTY_BULK_APPLY.EDIT_ACTION' | translate }}
                    </ng-container>
                  </li>
                  <li nz-menu-item *ngIf="canBulkDeleteDocumentSections"
                      class="property-bulk-apply__danger-item"
                      [class.ant-dropdown-menu-item-disabled]="!canUseDocumentSectionBulkActions(section)"
                      (click)="canUseDocumentSectionBulkActions(section) && openDocumentSectionBulkDelete(section, i)">
                    <span *ngIf="!canUseDocumentSectionBulkActions(section)" nz-tooltip [nzTooltipTitle]="getDocumentSectionBulkActionDisabledReason(section) | translate">
                      {{ 'PROPERTY_BULK_APPLY.DELETE_ACTION' | translate }}
                    </span>
                    <ng-container *ngIf="canUseDocumentSectionBulkActions(section)">
                      {{ 'PROPERTY_BULK_APPLY.DELETE_ACTION' | translate }}
                    </ng-container>
                  </li>
                </ul>
              </nz-dropdown-menu>
              <button
                nz-button
                nzType="default"
                nzDanger
                [disabled]="(section.uploadingCount || 0) > 0"
                (click)="removeSection(i)"
              >
                {{ 'DOCUMENT_MODAL.REMOVE_SECTION' | translate }}
              </button>
            </div>
          </div>
        </nz-collapse-panel>
        </ng-container>
      </nz-collapse>
      <div *ngIf="!documentSections.length" class="document-empty-state">
        {{ 'DOCUMENT_MODAL.EMPTY_STATE_HELPER' | translate }}
      </div>
      <div class="text-center pt-4">
        <button nz-button nzType="dashed" (click)="addSection()">
          <i nz-icon nzType="plus" class="mr-1"></i>
          {{ 'DOCUMENT_MODAL.ADD_SECTION' | translate }}
        </button>
      </div>
      </div>
    </ng-template>

    <ng-template #pmsDocumentsTemplate let-documents="documents">
      <div class="pms-documents" *ngIf="documents?.length; else noPmsDocuments">
        <div class="pms-doc" *ngFor="let doc of documents">
          <div class="pms-doc-title">{{ getPmsDocumentTitle(doc) }}</div>
          <div class="pms-doc-meta">
            <a *ngIf="doc.url" [href]="doc.url" target="_blank" rel="noopener">
              {{ 'DOCUMENT_MODAL.ACTIONS.OPEN' | translate }}
            </a>
            <nz-tag nzColor="green">{{ getPmsBadgeLabel(doc) }}</nz-tag>
          </div>
        </div>
      </div>
      <ng-template #noPmsDocuments>
        <div class="muted-small">{{ 'DOCUMENT_MODAL.EMPTY.NO_SYNCED' | translate }}</div>
      </ng-template>
    </ng-template>

    <ng-template #missingPmsDocumentsTemplate let-documents="documents">
      <div class="pms-documents" *ngIf="documents?.length; else noMissingPmsDocuments">
        <div class="pms-doc" *ngFor="let doc of documents">
          <div class="pms-doc-title">{{ getPmsDocumentTitle(doc) }}</div>
          <div class="pms-doc-meta">
            <a *ngIf="doc.url" [href]="doc.url" target="_blank" rel="noopener">
              {{ 'DOCUMENT_MODAL.ACTIONS.OPEN' | translate }}
            </a>
            <nz-tag nzColor="red">{{ 'DOCUMENT_MODAL.BADGES.MISSING_FROM_PMS' | translate }}</nz-tag>
          </div>
        </div>
      </div>
      <ng-template #noMissingPmsDocuments>
        <div class="muted-small">{{ 'DOCUMENT_MODAL.EMPTY.NO_MISSING' | translate }}</div>
      </ng-template>
    </ng-template>
  </ng-container>
</nz-modal>

<ng-template #documentModalFooter>
  <button nz-button nzType="default" (click)="closeDocumentModal()">
    {{ 'DOCUMENT_MODAL.CANCEL' | translate }}
  </button>
  <button nz-button nzType="primary" [disabled]="isSaveDisabled()" (click)="saveUploadedFiles()">
    {{ 'DOCUMENT_MODAL.SAVE_BUTTON' | translate }}
  </button>
</ng-template>

<nz-modal
  [(nzVisible)]="instructionsModalVisible"
  [nzTitle]="('PROPERTY_INSTRUCTIONS.MODAL_TITLE' | translate) + (instructionsProperty?.address ? ' · ' + instructionsProperty?.address : '')"
  [nzFooter]="instructionsModalFooter"
  [nzWidth]="1360"
  [nzMaskClosable]="false"
  (nzOnCancel)="closeEmergencyInstructionsModal()"
>
  <ng-container *nzModalContent>
    <div class="instructions-modal">
      <div class="instructions-modal__subtitle">
        {{ 'PROPERTY_INSTRUCTIONS.MODAL_SUBTITLE' | translate }}
      </div>

      <div class="instructions-modal__grid">
        <!-- LEFT: Existing instructions -->
        <div class="instructions-panel">
          <div class="instructions-panel__title">
            <span>
              {{ 'PROPERTY_INSTRUCTIONS.LIST_TITLE' | translate }}
              <span class="instructions-panel__count" *ngIf="emergencyInstructions?.length">
                ({{ emergencyInstructions.length }})
              </span>
            </span>
            <button
              nz-button
              nzType="default"
              nzSize="small"
              (click)="openDistributionOverview('emergency_instruction')"
            >
              {{ 'PROPERTY_DISTRIBUTION_OVERVIEW.OPEN_BUTTON' | translate }}
            </button>
          </div>

          <ng-container *ngIf="!instructionsModalLoading; else instructionsLoadingTpl">
            <ng-container *ngIf="emergencyInstructions?.length; else instructionsEmptyTpl">
              <div
                cdkDropList
                class="instruction-card-list"
                [cdkDropListData]="emergencyInstructions"
                (cdkDropListDropped)="onEmergencyInstructionListDrop($event)"
              >
              <div class="instruction-card" *ngFor="let ins of emergencyInstructions; trackBy: trackByEmergencyInstruction" cdkDrag>
                <div class="instruction-card__head">
                  <div class="instruction-pill">
                    <span class="instruction-card__drag" cdkDragHandle>
                      <i nz-icon nzType="menu"></i>
                    </span>
                    <i
                      nz-icon
                      class="cat-icon"
                      nzTheme="outline"
                      [nzType]="emergencyInstructionIconTypeForInstruction(ins)"
                    ></i>
                    <span>{{ emergencyInstructionUnifiedCategoryLabelKey(getEmergencyInstructionSelectedCategoryKey(ins)) | translate }}</span>
                  </div>

                  <nz-tag *ngIf="isEmergencyInstructionCopy(ins); else emergencyInstructionSourceBadge"
                          nzColor="blue"
                          nz-tooltip
                          [nzTooltipTitle]="getCopySourcePropertyTooltip(ins.originPropertyId)">
                    {{ 'PROPERTY_DISTRIBUTION_OVERVIEW.COPY_BADGE' | translate }}
                  </nz-tag>
                  <ng-template #emergencyInstructionSourceBadge>
                    <nz-tag nzColor="green">{{ 'PROPERTY_DISTRIBUTION_OVERVIEW.SOURCE_BADGE' | translate }}</nz-tag>
                  </ng-template>

                  <div class="instruction-card__actions">
                    <button
                      *ngIf="canBulkApplyEmergencyInstructions || canDeleteEmergencyInstructions"
                      nz-button
                      nzType="text"
                      nz-dropdown
                      [nzDropdownMenu]="instructionBulkMenu"
                      nz-tooltip
                      [nzTooltipTitle]="'PROPERTY_BULK_APPLY.MORE_ACTIONS' | translate"
                    >
                      <span nz-icon nzType="ellipsis"></span>
                    </button>
                    <nz-dropdown-menu #instructionBulkMenu="nzDropdownMenu">
                      <ul nz-menu>
                        <li nz-menu-item *ngIf="canBulkApplyEmergencyInstructions" (click)="openEmergencyInstructionBulkApply(ins)">
                          {{ 'PROPERTY_BULK_APPLY.APPLY_ACTION' | translate }}
                        </li>
                        <li nz-menu-item *ngIf="canBulkApplyEmergencyInstructions" (click)="openEmergencyInstructionBulkEdit(ins)">
                          {{ 'PROPERTY_BULK_APPLY.EDIT_ACTION' | translate }}
                        </li>
                        <li nz-menu-item *ngIf="canDeleteEmergencyInstructions" class="property-bulk-apply__danger-item" (click)="openEmergencyInstructionBulkDelete(ins)">
                          {{ 'PROPERTY_BULK_APPLY.DELETE_ACTION' | translate }}
                        </li>
                      </ul>
                    </nz-dropdown-menu>

                    <button
                      nz-button
                      nzType="text"
                      [disabled]="instructionsSaving"
                      nz-tooltip
                      [nzTooltipTitle]="'PROPERTY_INSTRUCTIONS.EDIT_TOOLTIP' | translate"
                      (click)="editEmergencyInstruction(ins)"
                    >
                      <span nz-icon nzType="edit"></span>
                    </button>

                    <button
                      *ngIf="canDeleteEmergencyInstructions"
                      nz-button
                      nzType="text"
                      [disabled]="instructionsSaving"
                      nzDanger
                      nz-tooltip
                      [nzTooltipTitle]="'PROPERTY_INSTRUCTIONS.DELETE_TOOLTIP' | translate"
                      (click)="confirmDeleteEmergencyInstruction(ins)"
                    >
                      <span nz-icon nzType="delete"></span>
                    </button>
                  </div>
                </div>

                <div class="instruction-card__title">{{ ins.title }}</div>

                <div class="instruction-card__summary" *ngIf="ins.summary && ins.summary !== ins.who">
                  {{ ins.summary }}
                </div>

                <div class="instruction-card__meta">
                  <div *ngIf="isEmergencyInstructionV2(ins)">
                    <strong>{{ 'PROPERTY_INSTRUCTIONS.STEPS_TITLE' | translate }}:</strong>
                    {{ ins.steps?.length || 0 }}
                  </div>

                  <div *ngIf="ins.who">
                    <strong>{{ 'PROPERTY_INSTRUCTIONS.WHO_LABEL' | translate }}:</strong>
                    {{ ins.who }}
                  </div>

                  <div *ngIf="ins.showPhoneNumber && ins.phone">
                    <strong>{{ 'PROPERTY_INSTRUCTIONS.PHONE_LABEL' | translate }}:</strong>
                    {{ formatGermanPhoneNumber(ins.phone) }}
                  </div>
                </div>

                <div class="instruction-card__how" *ngIf="!isEmergencyInstructionV2(ins) && ins.how">{{ ins.how }}</div>
              </div>
              </div>
            </ng-container>
          </ng-container>

          <ng-template #instructionsLoadingTpl>
            <div class="instructions-loading">
              {{ 'PROPERTY_INSTRUCTIONS.LOADING' | translate }}
            </div>
          </ng-template>

          <ng-template #instructionsEmptyTpl>
            <div class="instructions-empty">
              <div class="instructions-empty__title">
                {{ 'PROPERTY_INSTRUCTIONS.EMPTY_TITLE' | translate }}
              </div>
              <div class="instructions-empty__desc">
                {{ 'PROPERTY_INSTRUCTIONS.EMPTY_DESC' | translate }}
              </div>
            </div>
          </ng-template>
        </div>

        <div class="instructions-panel instructions-panel--builder">
          <div class="instructions-panel__title">
            {{
              (editingEmergencyInstructionId
                  ? 'PROPERTY_INSTRUCTIONS.EDIT_FORM_TITLE'
                  : 'PROPERTY_INSTRUCTIONS.FORM_TITLE'
              ) | translate
            }}

            <button
              *ngIf="editingEmergencyInstructionId"
              nz-button
              nzType="link"
              (click)="cancelEditEmergencyInstruction()"
            >
              {{ 'PROPERTY_INSTRUCTIONS.CANCEL_EDIT_BUTTON' | translate }}
            </button>
          </div>

          <div class="instructions-builder" data-tour="property-instructions-content">
            <div class="instructions-builder__toolbar">
              <div class="instructions-builder__toolbar-item instructions-builder__toolbar-item--template">
                <label class="instructions-label">{{ 'PROPERTY_INSTRUCTIONS.CATEGORY_LABEL' | translate }}</label>
                <nz-select
                  class="instructions-template-select"
                  [(ngModel)]="emergencyInstructionBuilder.selectedCategoryKey"
                  [ngModelOptions]="{ standalone: true }"
                  [nzDropdownMatchSelectWidth]="false"
                  nzDropdownClassName="instructions-template-select-dropdown"
                  [nzPlaceHolder]="'PROPERTY_INSTRUCTIONS.CATEGORY_PLACEHOLDER' | translate"
                  (ngModelChange)="onEmergencyInstructionCategoryChange($event)"
                >
                  <nz-option
                    *ngFor="let option of emergencyInstructionUnifiedCategoryOptions; trackBy: trackByEmergencyInstructionCategoryOption"
                    [nzValue]="option.key"
                    [nzLabel]="(option.labelKey | translate)"
                    nzCustomContent
                  >
                    <div class="instructions-template-option">
                      <i nz-icon [nzType]="resolveEmergencyInstructionIconType(option.iconKey)"></i>
                      <span class="instructions-template-option__label">{{ option.labelKey | translate }}</span>
                    </div>
                  </nz-option>
                </nz-select>
                <div class="instructions-field__hint instructions-field__hint--template" [class.instructions-field__hint--visible]="emergencyInstructionTemplateHintVisible">
                  {{ 'PROPERTY_INSTRUCTIONS.TEMPLATE_APPLY_HINT' | translate }}
                </div>
              </div>

              <div class="instructions-builder__toolbar-actions">
                <button nz-button nzType="default" class="instructions-builder__toolbar-button" (click)="applyEmergencyInstructionCategoryPreset(emergencyInstructionBuilder.selectedCategoryKey)">
                  <i nz-icon nzType="copy"></i>
                  {{ 'PROPERTY_INSTRUCTIONS.APPLY_TEMPLATE_BUTTON' | translate }}
                </button>

                <button nz-button nzType="default" class="instructions-builder__toolbar-button" (click)="startEmergencyInstructionFromScratch()">
                  <i nz-icon nzType="plus-circle"></i>
                  {{ 'PROPERTY_INSTRUCTIONS.START_FROM_SCRATCH_BUTTON' | translate }}
                </button>
              </div>
            </div>

            <div class="instructions-form__grid">
              <div class="instructions-field__errors full-row" *ngIf="emergencyInstructionSaveAttempted && emergencyInstructionSaveMessages.length">
                <div class="instructions-field__error" *ngFor="let message of emergencyInstructionSaveMessages">
                  {{ message }}
                </div>
              </div>
              <div class="instructions-field">
                <label class="instructions-label">{{ 'PROPERTY_INSTRUCTIONS.ICON_LABEL' | translate }}</label>
                <button type="button" nz-button nzType="default" class="instructions-icon-trigger" (click)="openEmergencyInstructionIconPickerForGuide()">
                  <i nz-icon [nzType]="resolveEmergencyInstructionIconType(emergencyInstructionBuilder.iconKey)"></i>
                  <span>{{ emergencyInstructionIconLabelKey(emergencyInstructionBuilder.iconKey) | translate }}</span>
                </button>
              </div>

              <div class="instructions-field">
                <label class="instructions-label">{{ 'PROPERTY_INSTRUCTIONS.URGENCY_LABEL' | translate }}</label>
                <nz-select
                  [(ngModel)]="emergencyInstructionBuilder.urgency"
                  [ngModelOptions]="{ standalone: true }"
                >
                  <nz-option nzValue="normal" [nzLabel]="'PROPERTY_INSTRUCTIONS.URGENCY.NORMAL' | translate"></nz-option>
                  <nz-option nzValue="important" [nzLabel]="'PROPERTY_INSTRUCTIONS.URGENCY.IMPORTANT' | translate"></nz-option>
                  <nz-option nzValue="critical" [nzLabel]="'PROPERTY_INSTRUCTIONS.URGENCY.CRITICAL' | translate"></nz-option>
                </nz-select>
              </div>

              <div class="instructions-field full-row">
                <label class="instructions-label instructions-label--required">{{ 'PROPERTY_INSTRUCTIONS.WHAT_WHERE_LABEL' | translate }}</label>
                <input
                  nz-input
                  [class.instructions-control--invalid]="(emergencyInstructionSaveAttempted && !emergencyInstructionBuilder.title?.trim()) || isEmergencyInstructionFieldTooLong(emergencyInstructionBuilder.title, emergencyInstructionMaxLengths.title)"
                  [attr.aria-invalid]="(emergencyInstructionSaveAttempted && !emergencyInstructionBuilder.title?.trim()) || isEmergencyInstructionFieldTooLong(emergencyInstructionBuilder.title, emergencyInstructionMaxLengths.title) ? 'true' : null"
                  [(ngModel)]="emergencyInstructionBuilder.title"
                  [ngModelOptions]="{ standalone: true }"
                  [placeholder]="'PROPERTY_INSTRUCTIONS.WHAT_WHERE_PLACEHOLDER' | translate"
                  [attr.maxlength]="emergencyInstructionMaxLengths.title"
                />
                <div class="instructions-field__error" *ngIf="emergencyInstructionSaveAttempted && !emergencyInstructionBuilder.title?.trim()">
                  {{ 'validation.emergencyInstructions.title.required' | translate }}
                </div>
                <div class="instructions-field__error" *ngIf="isEmergencyInstructionFieldTooLong(emergencyInstructionBuilder.title, emergencyInstructionMaxLengths.title)">
                  {{ 'validation.emergencyInstructions.common.maxlength' | translate:{ max: emergencyInstructionMaxLengths.title } }}
                </div>
                <div class="instructions-field__count">
                  {{ getEmergencyInstructionFieldLength(emergencyInstructionBuilder.title) }} / {{ emergencyInstructionMaxLengths.title }}
                </div>
              </div>

              <div class="instructions-field full-row">
                <label class="instructions-label">{{ 'PROPERTY_INSTRUCTIONS.SUMMARY_LABEL' | translate }}</label>
                <textarea
                  nz-input
                  rows="3"
                  [class.instructions-control--invalid]="isEmergencyInstructionFieldTooLong(emergencyInstructionBuilder.summary, emergencyInstructionMaxLengths.summary)"
                  [attr.aria-invalid]="isEmergencyInstructionFieldTooLong(emergencyInstructionBuilder.summary, emergencyInstructionMaxLengths.summary) ? 'true' : null"
                  [(ngModel)]="emergencyInstructionBuilder.summary"
                  [ngModelOptions]="{ standalone: true }"
                  [placeholder]="'PROPERTY_INSTRUCTIONS.SUMMARY_PLACEHOLDER' | translate"
                  [attr.maxlength]="emergencyInstructionMaxLengths.summary"
                ></textarea>
                <div class="instructions-field__error" *ngIf="isEmergencyInstructionFieldTooLong(emergencyInstructionBuilder.summary, emergencyInstructionMaxLengths.summary)">
                  {{ 'validation.emergencyInstructions.common.maxlength' | translate:{ max: emergencyInstructionMaxLengths.summary } }}
                </div>
                <div class="instructions-field__count">
                  {{ getEmergencyInstructionFieldLength(emergencyInstructionBuilder.summary) }} / {{ emergencyInstructionMaxLengths.summary }}
                </div>
              </div>
            </div>

            <div class="instructions-steps">
              <div class="instructions-steps__header">
                <div class="instructions-panel__title">{{ 'PROPERTY_INSTRUCTIONS.STEPS_TITLE' | translate }}</div>
                <button nz-button nzType="default" (click)="addEmergencyInstructionStep()">
                  <i nz-icon nzType="plus"></i>
                  {{ 'PROPERTY_INSTRUCTIONS.ADD_STEP_BUTTON' | translate }}
                </button>
              </div>

              <div
                cdkDropList
                class="instructions-step-list"
                [cdkDropListData]="emergencyInstructionBuilder.steps || []"
                (cdkDropListDropped)="onEmergencyInstructionStepDrop($event)"
              >
                <div
                  class="instructions-step-card"
                  *ngFor="let step of emergencyInstructionBuilder.steps || []; let stepIndex = index; trackBy: trackByEmergencyInstructionStep"
                  [attr.data-emergency-instruction-step-index]="stepIndex"
                  cdkDrag
                >
                  <div class="instructions-step-card__header">
                    <div class="instructions-step-card__title-row">
                      <span class="instructions-step-card__drag" cdkDragHandle>
                        <i nz-icon nzType="menu"></i>
                      </span>
                      <span class="instructions-step-card__index">{{ stepIndex + 1 }}</span>
                      <span class="instructions-step-card__selected-icon" *ngIf="step.iconKey">
                        <i nz-icon [nzType]="resolveEmergencyInstructionIconType(step.iconKey)"></i>
                      </span>
                      <div class="instructions-step-card__title-text">
                        {{ step.title || ('PROPERTY_INSTRUCTIONS.STEP_UNTITLED' | translate) }}
                      </div>
                      <nz-tag [nzColor]="emergencyInstructionUrgencyTagColor(step.urgency)">
                        {{ emergencyInstructionUrgencyLabelKey(step.urgency) | translate }}
                      </nz-tag>
                    </div>

                    <div class="instruction-card__actions">
                      <button
                        nz-button
                        nzType="text"
                        nz-tooltip
                        [nzTooltipTitle]="'PROPERTY_INSTRUCTIONS.STEP_DUPLICATE_TOOLTIP' | translate"
                        (click)="duplicateEmergencyInstructionStep(stepIndex)"
                      >
                        <span nz-icon nzType="copy"></span>
                      </button>
                      <button
                        nz-button
                        nzType="text"
                        nz-tooltip
                        [nzTooltipTitle]="(step.isExpanded ? 'PROPERTY_INSTRUCTIONS.STEP_COLLAPSE_TOOLTIP' : 'PROPERTY_INSTRUCTIONS.STEP_EXPAND_TOOLTIP') | translate"
                        (click)="toggleEmergencyInstructionStep(stepIndex)"
                      >
                        <span nz-icon [nzType]="step.isExpanded ? 'up' : 'down'"></span>
                      </button>
                      <button
                        nz-button
                        nzType="text"
                        nzDanger
                        nz-tooltip
                        [nzTooltipTitle]="'PROPERTY_INSTRUCTIONS.STEP_DELETE_TOOLTIP' | translate"
                        (click)="removeEmergencyInstructionStep(stepIndex)"
                      >
                        <span nz-icon nzType="delete"></span>
                      </button>
                    </div>
                  </div>

                  <div class="instructions-step-card__body" *ngIf="step.isExpanded">
                    <div class="instructions-form__grid">
                      <div class="instructions-field full-row">
                        <label class="instructions-label instructions-label--required">{{ 'PROPERTY_INSTRUCTIONS.STEP_TITLE_LABEL' | translate }}</label>
                        <input
                          nz-input
                          [class.instructions-control--invalid]="(emergencyInstructionSaveAttempted && !step.title?.trim()) || isEmergencyInstructionFieldTooLong(step.title, emergencyInstructionMaxLengths.stepTitle)"
                          [attr.aria-invalid]="(emergencyInstructionSaveAttempted && !step.title?.trim()) || isEmergencyInstructionFieldTooLong(step.title, emergencyInstructionMaxLengths.stepTitle) ? 'true' : null"
                          [(ngModel)]="step.title"
                          [ngModelOptions]="{ standalone: true }"
                          [placeholder]="'PROPERTY_INSTRUCTIONS.STEP_TITLE_PLACEHOLDER' | translate"
                          [attr.maxlength]="emergencyInstructionMaxLengths.stepTitle"
                        />
                        <div class="instructions-field__error" *ngIf="emergencyInstructionSaveAttempted && !step.title?.trim()">
                          {{ 'validation.emergencyInstructions.steps.title.required' | translate }}
                        </div>
                        <div class="instructions-field__error" *ngIf="isEmergencyInstructionFieldTooLong(step.title, emergencyInstructionMaxLengths.stepTitle)">
                          {{ 'validation.emergencyInstructions.common.maxlength' | translate:{ max: emergencyInstructionMaxLengths.stepTitle } }}
                        </div>
                        <div class="instructions-field__count">
                          {{ getEmergencyInstructionFieldLength(step.title) }} / {{ emergencyInstructionMaxLengths.stepTitle }}
                        </div>
                      </div>

                      <div class="instructions-field full-row">
                        <label class="instructions-label">{{ 'PROPERTY_INSTRUCTIONS.STEP_DESCRIPTION_LABEL' | translate }}</label>
                        <textarea
                          nz-input
                          rows="3"
                          [class.instructions-control--invalid]="isEmergencyInstructionFieldTooLong(step.description, emergencyInstructionMaxLengths.stepDescription)"
                          [attr.aria-invalid]="isEmergencyInstructionFieldTooLong(step.description, emergencyInstructionMaxLengths.stepDescription) ? 'true' : null"
                          [(ngModel)]="step.description"
                          [ngModelOptions]="{ standalone: true }"
                          [placeholder]="'PROPERTY_INSTRUCTIONS.STEP_DESCRIPTION_PLACEHOLDER' | translate"
                          [attr.maxlength]="emergencyInstructionMaxLengths.stepDescription"
                        ></textarea>
                        <div class="instructions-field__error" *ngIf="isEmergencyInstructionFieldTooLong(step.description, emergencyInstructionMaxLengths.stepDescription)">
                          {{ 'validation.emergencyInstructions.common.maxlength' | translate:{ max: emergencyInstructionMaxLengths.stepDescription } }}
                        </div>
                        <div class="instructions-field__count">
                          {{ getEmergencyInstructionFieldLength(step.description) }} / {{ emergencyInstructionMaxLengths.stepDescription }}
                        </div>
                      </div>

                      <div class="instructions-field">
                        <label class="instructions-label">{{ 'PROPERTY_INSTRUCTIONS.ICON_LABEL' | translate }}</label>
                        <button type="button" nz-button nzType="default" class="instructions-icon-trigger" (click)="openEmergencyInstructionIconPickerForStep(step)">
                          <i nz-icon [nzType]="resolveEmergencyInstructionIconType(step.iconKey)"></i>
                          <span>{{ emergencyInstructionIconLabelKey(step.iconKey) | translate }}</span>
                        </button>
                      </div>

                      <div class="instructions-field">
                        <label class="instructions-label">{{ 'PROPERTY_INSTRUCTIONS.URGENCY_LABEL' | translate }}</label>
                        <nz-select
                          [(ngModel)]="step.urgency"
                          [ngModelOptions]="{ standalone: true }"
                        >
                          <nz-option nzValue="normal" [nzLabel]="'PROPERTY_INSTRUCTIONS.URGENCY.NORMAL' | translate"></nz-option>
                          <nz-option nzValue="important" [nzLabel]="'PROPERTY_INSTRUCTIONS.URGENCY.IMPORTANT' | translate"></nz-option>
                          <nz-option nzValue="critical" [nzLabel]="'PROPERTY_INSTRUCTIONS.URGENCY.CRITICAL' | translate"></nz-option>
                        </nz-select>
                      </div>

                      <div class="instructions-field instructions-field--action-row">
                        <label class="instructions-label">{{ 'PROPERTY_INSTRUCTIONS.ACTION_TYPE_LABEL' | translate }}</label>
                        <nz-select
                          [(ngModel)]="step.actionType"
                          [ngModelOptions]="{ standalone: true }"
                          (ngModelChange)="onEmergencyInstructionStepActionTypeChange(step, $event)"
                        >
                          <nz-option nzValue="none" [nzLabel]="'PROPERTY_INSTRUCTIONS.ACTION_TYPE.NONE' | translate"></nz-option>
                          <nz-option nzValue="phone" [nzLabel]="'PROPERTY_INSTRUCTIONS.ACTION_TYPE.PHONE' | translate"></nz-option>
                          <nz-option nzValue="email" [nzLabel]="'PROPERTY_INSTRUCTIONS.ACTION_TYPE.EMAIL' | translate"></nz-option>
                          <nz-option nzValue="link" [nzLabel]="'PROPERTY_INSTRUCTIONS.ACTION_TYPE.LINK' | translate"></nz-option>
                          <nz-option nzValue="document" [nzLabel]="'PROPERTY_INSTRUCTIONS.ACTION_TYPE.DOCUMENT' | translate"></nz-option>
                        </nz-select>
                      </div>

                      <div class="instructions-field instructions-field--action-row" *ngIf="step.actionType !== 'none' && step.action">
                        <label class="instructions-label">{{ 'PROPERTY_INSTRUCTIONS.ACTION_LABEL' | translate }}</label>
                        <input
                          nz-input
                          [class.instructions-control--invalid]="isEmergencyInstructionFieldTooLong(step.action.label, emergencyInstructionMaxLengths.actionLabel)"
                          [attr.aria-invalid]="isEmergencyInstructionFieldTooLong(step.action.label, emergencyInstructionMaxLengths.actionLabel) ? 'true' : null"
                          [(ngModel)]="step.action.label"
                          (ngModelChange)="onEmergencyInstructionActionLabelChange(step, $event)"
                          [ngModelOptions]="{ standalone: true }"
                          [placeholder]="'PROPERTY_INSTRUCTIONS.ACTION_LABEL_PLACEHOLDER' | translate"
                          [attr.maxlength]="emergencyInstructionMaxLengths.actionLabel"
                        />
                        <div class="instructions-field__error" *ngIf="isEmergencyInstructionFieldTooLong(step.action.label, emergencyInstructionMaxLengths.actionLabel)">
                          {{ 'validation.emergencyInstructions.common.maxlength' | translate:{ max: emergencyInstructionMaxLengths.actionLabel } }}
                        </div>
                        <div class="instructions-field__count">
                          {{ getEmergencyInstructionFieldLength(step.action.label) }} / {{ emergencyInstructionMaxLengths.actionLabel }}
                        </div>
                      </div>

                      <div class="instructions-field full-row emergency-action-contact-source" *ngIf="step.actionType === 'phone' && step.action">
                        <label class="instructions-label">{{ 'PROPERTY_INSTRUCTIONS.CONTACT_SOURCE_LABEL' | translate }}</label>
                        <nz-select
                          class="emergency-action-contact-source__select"
                          [ngModel]="step.selectedContactKey || emergencyInstructionManualContactOptionValue"
                          (ngModelChange)="onEmergencyInstructionActionContactRefChange(step, $event)"
                          [ngModelOptions]="{ standalone: true }"
                          nzShowSearch
                          [nzFilterOption]="filterEmergencyInstructionContactOptions"
                          [nzPlaceHolder]="'PROPERTY_INSTRUCTIONS.CONTACT_SOURCE_SEARCH_PLACEHOLDER' | translate"
                          [nzLoading]="instructionsModalLoading || emergencyInstructionContactOptionsLoading"
                          [nzDisabled]="instructionsModalLoading || emergencyInstructionContactOptionsLoading"
                          [nzNotFoundContent]="getEmergencyInstructionContactNotFoundContent('phone')"
                        >
                          <nz-option
                            [nzValue]="emergencyInstructionManualContactOptionValue"
                            [nzLabel]="'PROPERTY_INSTRUCTIONS.CONTACT_SOURCE_MANUAL' | translate"
                          ></nz-option>
                          <nz-option
                            *ngIf="isEmergencyInstructionUnresolvedContactKey(step.selectedContactKey)"
                            [nzValue]="step.selectedContactKey"
                            [nzLabel]="'PROPERTY_INSTRUCTIONS.CONTACT_SOURCE_UNRESOLVED' | translate"
                            [nzDisabled]="true"
                            nzCustomContent
                          >
                            <div class="contact-option contact-option__unresolved">
                              <div class="contact-option__name">{{ 'PROPERTY_INSTRUCTIONS.CONTACT_SOURCE_UNRESOLVED' | translate }}</div>
                            </div>
                          </nz-option>
                          <ng-container *ngFor="let group of emergencyInstructionContactOptionGroups.phone; trackBy: trackByEmergencyInstructionContactGroup">
                            <nz-option-group [nzLabel]="group.label">
                              <nz-option
                                *ngFor="let option of group.options; trackBy: trackByEmergencyInstructionContactOption"
                                [nzValue]="option.key"
                                [nzLabel]="option.displayName"
                                nzCustomContent
                              >
                                <div class="contact-option">
                                  <div class="contact-option__name">{{ option.displayName }}</div>
                                  <div class="contact-option__value">{{ option.secondaryValue }}</div>
                                </div>
                              </nz-option>
                            </nz-option-group>
                          </ng-container>
                        </nz-select>
                        <div class="instructions-field__hint emergency-action-contact-source__preview" *ngIf="!instructionsModalLoading && !emergencyInstructionContactOptionsLoading && !hasEmergencyInstructionContactOptions('phone')">
                          {{ getEmergencyInstructionContactEmptyMessage('phone') }}
                        </div>
                        <div class="instructions-field__hint emergency-action-contact-source__preview" *ngIf="getEmergencyInstructionSelectedContactPreview(step) as contactPreview">
                          {{ 'PROPERTY_INSTRUCTIONS.CONTACT_SOURCE_PREVIEW' | translate }}:
                          {{ contactPreview.label }}
                          <ng-container *ngIf="contactPreview.groupLabel"> · {{ contactPreview.groupLabel }}</ng-container>
                          <ng-container *ngIf="contactPreview.value"> · {{ contactPreview.value }}</ng-container>
                        </div>
                        <label class="instructions-label instructions-label--required emergency-action-value-input">{{ 'PROPERTY_INSTRUCTIONS.PHONE_LABEL' | translate }}</label>
                        <input
                          nz-input
                          [class.instructions-control--invalid]="(emergencyInstructionSaveAttempted && !step.action.phone?.trim()) || isEmergencyInstructionFieldTooLong(step.action.phone, emergencyInstructionMaxLengths.phone)"
                          [attr.aria-invalid]="(emergencyInstructionSaveAttempted && !step.action.phone?.trim()) || isEmergencyInstructionFieldTooLong(step.action.phone, emergencyInstructionMaxLengths.phone) ? 'true' : null"
                          [(ngModel)]="step.action.phone"
                          (ngModelChange)="onEmergencyInstructionActionValueChange(step, 'phone', $event)"
                          [ngModelOptions]="{ standalone: true }"
                          [placeholder]="'PROPERTY_INSTRUCTIONS.PHONE_PLACEHOLDER' | translate"
                          [attr.maxlength]="emergencyInstructionMaxLengths.phone"
                        />
                        <div class="instructions-field__error" *ngIf="emergencyInstructionSaveAttempted && !step.action.phone?.trim()">
                          {{ 'validation.emergencyInstructions.steps.action.phone.required' | translate }}
                        </div>
                        <div class="instructions-field__error" *ngIf="isEmergencyInstructionFieldTooLong(step.action.phone, emergencyInstructionMaxLengths.phone)">
                          {{ 'validation.emergencyInstructions.common.maxlength' | translate:{ max: emergencyInstructionMaxLengths.phone } }}
                        </div>
                        <div class="instructions-field__count">
                          {{ getEmergencyInstructionFieldLength(step.action.phone) }} / {{ emergencyInstructionMaxLengths.phone }}
                        </div>
                      </div>

                      <div class="instructions-field full-row emergency-action-contact-source" *ngIf="step.actionType === 'email' && step.action">
                        <label class="instructions-label">{{ 'PROPERTY_INSTRUCTIONS.CONTACT_SOURCE_LABEL' | translate }}</label>
                        <nz-select
                          class="emergency-action-contact-source__select"
                          [ngModel]="step.selectedContactKey || emergencyInstructionManualContactOptionValue"
                          (ngModelChange)="onEmergencyInstructionActionContactRefChange(step, $event)"
                          [ngModelOptions]="{ standalone: true }"
                          nzShowSearch
                          [nzFilterOption]="filterEmergencyInstructionContactOptions"
                          [nzPlaceHolder]="'PROPERTY_INSTRUCTIONS.CONTACT_SOURCE_SEARCH_PLACEHOLDER' | translate"
                          [nzLoading]="instructionsModalLoading || emergencyInstructionContactOptionsLoading"
                          [nzDisabled]="instructionsModalLoading || emergencyInstructionContactOptionsLoading"
                          [nzNotFoundContent]="getEmergencyInstructionContactNotFoundContent('email')"
                        >
                          <nz-option
                            [nzValue]="emergencyInstructionManualContactOptionValue"
                            [nzLabel]="'PROPERTY_INSTRUCTIONS.CONTACT_SOURCE_MANUAL' | translate"
                          ></nz-option>
                          <nz-option
                            *ngIf="isEmergencyInstructionUnresolvedContactKey(step.selectedContactKey)"
                            [nzValue]="step.selectedContactKey"
                            [nzLabel]="'PROPERTY_INSTRUCTIONS.CONTACT_SOURCE_UNRESOLVED' | translate"
                            [nzDisabled]="true"
                            nzCustomContent
                          >
                            <div class="contact-option contact-option__unresolved">
                              <div class="contact-option__name">{{ 'PROPERTY_INSTRUCTIONS.CONTACT_SOURCE_UNRESOLVED' | translate }}</div>
                            </div>
                          </nz-option>
                          <ng-container *ngFor="let group of emergencyInstructionContactOptionGroups.email; trackBy: trackByEmergencyInstructionContactGroup">
                            <nz-option-group [nzLabel]="group.label">
                              <nz-option
                                *ngFor="let option of group.options; trackBy: trackByEmergencyInstructionContactOption"
                                [nzValue]="option.key"
                                [nzLabel]="option.displayName"
                                nzCustomContent
                              >
                                <div class="contact-option">
                                  <div class="contact-option__name">{{ option.displayName }}</div>
                                  <div class="contact-option__value">{{ option.secondaryValue }}</div>
                                </div>
                              </nz-option>
                            </nz-option-group>
                          </ng-container>
                        </nz-select>
                        <div class="instructions-field__hint emergency-action-contact-source__preview" *ngIf="!instructionsModalLoading && !emergencyInstructionContactOptionsLoading && !hasEmergencyInstructionContactOptions('email')">
                          {{ getEmergencyInstructionContactEmptyMessage('email') }}
                        </div>
                        <div class="instructions-field__hint emergency-action-contact-source__preview" *ngIf="getEmergencyInstructionSelectedContactPreview(step) as contactPreview">
                          {{ 'PROPERTY_INSTRUCTIONS.CONTACT_SOURCE_PREVIEW' | translate }}:
                          {{ contactPreview.label }}
                          <ng-container *ngIf="contactPreview.groupLabel"> · {{ contactPreview.groupLabel }}</ng-container>
                          <ng-container *ngIf="contactPreview.value"> · {{ contactPreview.value }}</ng-container>
                        </div>
                        <label class="instructions-label instructions-label--required emergency-action-value-input">{{ 'PROPERTY_INSTRUCTIONS.EMAIL_LABEL' | translate }}</label>
                        <input
                          nz-input
                          [class.instructions-control--invalid]="(emergencyInstructionSaveAttempted && !step.action.email?.trim()) || (step.action.email?.trim() && !validateEmail(step.action.email || '')) || isEmergencyInstructionFieldTooLong(step.action.email, emergencyInstructionMaxLengths.email)"
                          [attr.aria-invalid]="(emergencyInstructionSaveAttempted && !step.action.email?.trim()) || (step.action.email?.trim() && !validateEmail(step.action.email || '')) || isEmergencyInstructionFieldTooLong(step.action.email, emergencyInstructionMaxLengths.email) ? 'true' : null"
                          [(ngModel)]="step.action.email"
                          (ngModelChange)="onEmergencyInstructionActionValueChange(step, 'email', $event)"
                          [ngModelOptions]="{ standalone: true }"
                          [placeholder]="'PROPERTY_INSTRUCTIONS.EMAIL_PLACEHOLDER' | translate"
                          [attr.maxlength]="emergencyInstructionMaxLengths.email"
                        />
                        <div class="instructions-field__error" *ngIf="emergencyInstructionSaveAttempted && !step.action.email?.trim()">
                          {{ 'validation.emergencyInstructions.steps.action.email.required' | translate }}
                        </div>
                        <div class="instructions-field__error" *ngIf="step.action.email?.trim() && !validateEmail(step.action.email || '')">
                          {{ 'validation.emergencyInstructions.steps.action.email.invalid' | translate }}
                        </div>
                        <div class="instructions-field__error" *ngIf="isEmergencyInstructionFieldTooLong(step.action.email, emergencyInstructionMaxLengths.email)">
                          {{ 'validation.emergencyInstructions.common.maxlength' | translate:{ max: emergencyInstructionMaxLengths.email } }}
                        </div>
                        <div class="instructions-field__count">
                          {{ getEmergencyInstructionFieldLength(step.action.email) }} / {{ emergencyInstructionMaxLengths.email }}
                        </div>
                      </div>

                      <div class="instructions-field full-row" *ngIf="step.actionType === 'link' && step.action">
                        <label class="instructions-label instructions-label--required">{{ 'PROPERTY_INSTRUCTIONS.LINK_LABEL' | translate }}</label>
                        <input
                          nz-input
                          [class.instructions-control--invalid]="(emergencyInstructionSaveAttempted && !step.action.url?.trim()) || (step.action.url?.trim() && isEmergencyInstructionLinkInvalid(step.action.url)) || isEmergencyInstructionFieldTooLong(step.action.url, emergencyInstructionMaxLengths.url)"
                          [attr.aria-invalid]="(emergencyInstructionSaveAttempted && !step.action.url?.trim()) || (step.action.url?.trim() && isEmergencyInstructionLinkInvalid(step.action.url)) || isEmergencyInstructionFieldTooLong(step.action.url, emergencyInstructionMaxLengths.url) ? 'true' : null"
                          [(ngModel)]="step.action.url"
                          (blur)="normalizeEmergencyInstructionLinkField(step)"
                          [ngModelOptions]="{ standalone: true }"
                          [placeholder]="'PROPERTY_INSTRUCTIONS.LINK_PLACEHOLDER' | translate"
                          [attr.maxlength]="emergencyInstructionMaxLengths.url"
                        />
                        <div class="instructions-field__error" *ngIf="emergencyInstructionSaveAttempted && !step.action.url?.trim()">
                          {{ 'validation.emergencyInstructions.steps.action.url.required' | translate }}
                        </div>
                        <div class="instructions-field__error" *ngIf="step.action.url?.trim() && isEmergencyInstructionLinkInvalid(step.action.url)">
                          {{ 'validation.emergencyInstructions.steps.action.url.invalid' | translate }}
                        </div>
                        <div class="instructions-field__error" *ngIf="isEmergencyInstructionFieldTooLong(step.action.url, emergencyInstructionMaxLengths.url)">
                          {{ 'validation.emergencyInstructions.common.maxlength' | translate:{ max: emergencyInstructionMaxLengths.url } }}
                        </div>
                        <div class="instructions-field__count">
                          {{ getEmergencyInstructionFieldLength(step.action.url) }} / {{ emergencyInstructionMaxLengths.url }}
                        </div>
                      </div>

                      <div class="instructions-field full-row" *ngIf="step.actionType === 'document' && step.action">
                        <label class="instructions-label instructions-label--required">{{ 'PROPERTY_INSTRUCTIONS.DOCUMENT_LABEL' | translate }}</label>
                        <nz-select
                          [class.instructions-control--invalid]="emergencyInstructionSaveAttempted && !step.action.document?.fileName"
                          [attr.aria-invalid]="emergencyInstructionSaveAttempted && !step.action.document?.fileName ? 'true' : null"
                          [ngModel]="getEmergencyInstructionDocumentOptionKey(step)"
                          [ngModelOptions]="{ standalone: true }"
                          [nzPlaceHolder]="'PROPERTY_INSTRUCTIONS.DOCUMENT_PLACEHOLDER' | translate"
                          [nzDropdownMatchSelectWidth]="false"
                          nzDropdownClassName="instructions-document-select-dropdown"
                          (ngModelChange)="onEmergencyInstructionDocumentChange(step, $event)"
                        >
                          <nz-option
                            *ngFor="let option of emergencyInstructionDocumentOptions; trackBy: trackByEmergencyInstructionDocumentOption"
                            [nzValue]="option.key"
                            [nzLabel]="option.label"
                            nzCustomContent
                          >
                            <div class="instructions-document-option">
                              <span class="instructions-document-option__label">{{ option.file.fileName || option.label }}</span>
                              <span class="instructions-document-option__meta">{{ option.sectionTitle }}</span>
                            </div>
                          </nz-option>
                        </nz-select>
                        <div class="instructions-field__error" *ngIf="emergencyInstructionSaveAttempted && !step.action.document?.fileName">
                          {{ 'validation.emergencyInstructions.steps.action.document.required' | translate }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="instructions-panel instructions-panel--preview">
          <div class="instructions-panel__title">
            {{ 'PROPERTY_INSTRUCTIONS.PREVIEW_TITLE' | translate }}
          </div>

          <div class="instructions-preview-phone">
            <div class="instructions-preview-phone__status"></div>
            <div class="instructions-preview-phone__body">
              <div class="instructions-preview-card">
                <div class="instructions-preview-card__top">
                  <div class="instruction-pill">
                    <i nz-icon [nzType]="resolveEmergencyInstructionIconType(emergencyInstructionBuilder.iconKey)"></i>
                    <span>{{ emergencyInstructionUnifiedCategoryLabelKey(emergencyInstructionBuilder.selectedCategoryKey) | translate }}</span>
                  </div>
                  <nz-tag [nzColor]="emergencyInstructionUrgencyTagColor(emergencyInstructionBuilder.urgency)">
                    {{ emergencyInstructionUrgencyLabelKey(emergencyInstructionBuilder.urgency) | translate }}
                  </nz-tag>
                </div>

                <div class="instructions-preview-card__title">
                  {{ emergencyInstructionBuilder.title || ('PROPERTY_INSTRUCTIONS.PREVIEW_EMPTY_TITLE' | translate) }}
                </div>

                <div class="instructions-preview-card__summary" *ngIf="emergencyInstructionBuilder.summary">
                  {{ emergencyInstructionBuilder.summary }}
                </div>

                <div class="instructions-preview-steps">
                  <div class="instructions-preview-step" *ngFor="let step of emergencyInstructionBuilder.steps || []; let stepIndex = index; trackBy: trackByEmergencyInstructionStep">
                    <div
                      class="instructions-preview-step__marker"
                      [class.instructions-preview-step__marker--important]="step.urgency === 'important'"
                      [class.instructions-preview-step__marker--critical]="step.urgency === 'critical'"
                    >
                      {{ stepIndex + 1 }}
                    </div>
                    <div class="instructions-preview-step__content">
                      <div class="instructions-preview-step__title">
                        <i nz-icon *ngIf="step.iconKey" [nzType]="resolveEmergencyInstructionIconType(step.iconKey)"></i>
                        <span>{{ step.title || ('PROPERTY_INSTRUCTIONS.STEP_UNTITLED' | translate) }}</span>
                      </div>
                      <div class="instructions-preview-step__description" *ngIf="step.description">
                        {{ step.description }}
                      </div>
                      <ng-container *ngIf="step.action as action">
                        <a
                          *ngIf="action.type === 'phone' && action.phone"
                          class="instructions-preview-step__action"
                          [href]="'tel:' + action.phone"
                        >
                          {{ action.label || ('PROPERTY_INSTRUCTIONS.ACTION_TYPE.PHONE' | translate) }}
                        </a>
                        <a
                          *ngIf="action.type === 'email' && action.email"
                          class="instructions-preview-step__action"
                          [href]="'mailto:' + action.email"
                        >
                          {{ action.label || ('PROPERTY_INSTRUCTIONS.ACTION_TYPE.EMAIL' | translate) }}
                        </a>
                        <a
                          *ngIf="action.type === 'link' && action.url"
                          class="instructions-preview-step__action"
                          [href]="action.url"
                          target="_blank"
                          rel="noreferrer"
                        >
                          {{ action.label || ('PROPERTY_INSTRUCTIONS.ACTION_TYPE.LINK' | translate) }}
                        </a>
                        <a
                          *ngIf="action.type === 'document' && getEmergencyInstructionPreviewDocumentHref(step)"
                          class="instructions-preview-step__action"
                          [href]="getEmergencyInstructionPreviewDocumentHref(step)"
                          rel="noreferrer noopener"
                          (click)="onEmergencyInstructionPreviewDocumentClick($event, step)"
                        >
                          {{ action.label || action.document?.fileName || ('PROPERTY_INSTRUCTIONS.ACTION_TYPE.DOCUMENT' | translate) }}
                        </a>
                      </ng-container>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-template #instructionsModalFooter>
    <button nz-button nzType="default" (click)="closeEmergencyInstructionsModal()">
      {{ 'PROPERTY_INSTRUCTIONS.CANCEL_BUTTON' | translate }}
    </button>

    <button nz-button nzType="primary" [disabled]="instructionsSaving" (click)="addEmergencyInstruction()">
      <i nz-icon [nzType]="editingEmergencyInstructionId ? 'save' : 'plus'"></i>
      {{
        (editingEmergencyInstructionId
            ? 'PROPERTY_INSTRUCTIONS.SAVE_CHANGES_BUTTON'
            : 'PROPERTY_INSTRUCTIONS.ADD_BUTTON'
        ) | translate
      }}
    </button>
  </ng-template>
</nz-modal>

<nz-modal
  [(nzVisible)]="distributionOverviewModalVisible"
  [nzTitle]="distributionOverviewTitleKey | translate"
  [nzWidth]="900"
  [nzFooter]="null"
  (nzOnCancel)="closeDistributionOverview()"
>
  <ng-container *nzModalContent>
    <div class="distribution-overview">
      <div class="distribution-overview__helper">
        {{ 'PROPERTY_DISTRIBUTION_OVERVIEW.HELPER' | translate }}
      </div>

      <div class="distribution-overview__toolbar">
        <input
          nz-input
          [(ngModel)]="distributionOverviewGroupSearchTerm"
          [ngModelOptions]="{ standalone: true }"
          [placeholder]="'PROPERTY_DISTRIBUTION_OVERVIEW.SEARCH_PLACEHOLDER' | translate"
        />
        <div class="distribution-overview__toolbar-row">
          <nz-radio-group
            class="distribution-overview__filters"
            [(ngModel)]="distributionOverviewGroupFilter"
            [ngModelOptions]="{ standalone: true }"
          >
            <label
              nz-radio-button
              *ngFor="let option of distributionOverviewFilterOptions"
              [nzValue]="option.value"
              nz-tooltip
              [nzTooltipTitle]="getDistributionOverviewStatusFilterTooltipKey(option.value) | translate"
            >
              {{ option.labelKey | translate }}
            </label>
          </nz-radio-group>

          <nz-select
            class="distribution-overview__sort"
            [(ngModel)]="distributionOverviewGroupSort"
            [ngModelOptions]="{ standalone: true }"
          >
            <nz-option
              *ngFor="let option of distributionOverviewSortOptions"
              [nzValue]="option.value"
              [nzLabel]="option.labelKey | translate"
            ></nz-option>
          </nz-select>
        </div>
      </div>

      <div *ngIf="distributionOverviewLoading" class="distribution-overview__loading">
        {{ 'PROPERTY_DISTRIBUTION_OVERVIEW.LOADING' | translate }}
      </div>

      <ng-container *ngIf="!distributionOverviewLoading">
        <div *ngIf="!filteredDistributionOverviewGroups.length" class="distribution-overview__empty">
          {{ 'PROPERTY_DISTRIBUTION_OVERVIEW.EMPTY' | translate }}
        </div>

        <div *ngIf="filteredDistributionOverviewGroups.length" class="distribution-overview__cards">
          <div
            class="distribution-overview__card"
            *ngFor="let group of filteredDistributionOverviewGroups; trackBy: trackByDistributionOverviewGroup"
          >
            <div class="distribution-overview__card-head">
              <div class="distribution-overview__card-title">
                {{ group.rootItemTitle || ('PROPERTY_DISTRIBUTION_OVERVIEW.UNTITLED' | translate) }}
              </div>
              <div class="distribution-overview__card-actions">
                <nz-tag nzColor="red" *ngIf="group.sourceDeleted">{{ 'PROPERTY_DISTRIBUTION_OVERVIEW.SOURCE_DELETED' | translate }}</nz-tag>
                <nz-tag nzColor="gold" *ngIf="group.unlinked">{{ 'PROPERTY_DISTRIBUTION_OVERVIEW.UNLINKED_ITEM' | translate }}</nz-tag>
                <button nz-button nzType="default" nzSize="small" (click)="openDistributionOverviewDetails(group)">
                  {{ 'PROPERTY_DISTRIBUTION_OVERVIEW.VIEW_DETAILS' | translate }}
                </button>
              </div>
            </div>

            <div class="distribution-overview__meta">
              <div class="distribution-overview__meta-row">
                <span class="distribution-overview__meta-label">{{ 'PROPERTY_DISTRIBUTION_OVERVIEW.SOURCE_PROPERTY' | translate }}</span>
                <span>{{ getDistributionOverviewSourcePropertyLabel(group) }}</span>
              </div>
              <div class="distribution-overview__meta-row">
                <span class="distribution-overview__meta-label">{{ 'PROPERTY_DISTRIBUTION_OVERVIEW.TYPE_LABEL' | translate }}</span>
                <span>{{ getDistributionOverviewTypeLabelKey() | translate }}</span>
              </div>
              <div class="distribution-overview__meta-row" *ngIf="distributionOverviewEntityType === 'document_section'">
                <span class="distribution-overview__meta-label">{{ 'PROPERTY_DISTRIBUTION_OVERVIEW.FILE_COUNT' | translate }}</span>
                <span>{{ group.fileCount || 0 }}</span>
              </div>
              <div class="distribution-overview__meta-row">
                <span class="distribution-overview__meta-label">{{ 'PROPERTY_DISTRIBUTION_OVERVIEW.USED_ON_PROPERTIES_LABEL' | translate }}</span>
                <span>{{ group.propertyCount }}</span>
              </div>
            </div>

            <div class="distribution-overview__summary-tags">
              <nz-tag nzColor="green">{{ 'PROPERTY_DISTRIBUTION_OVERVIEW.USED_COUNT' | translate:{ count: group.summary.copied + group.summary.modified + group.summary.source } }}</nz-tag>
              <nz-tag nzColor="orange" *ngIf="group.summary.modified">{{ 'PROPERTY_DISTRIBUTION_OVERVIEW.MODIFIED_COUNT' | translate:{ count: group.summary.modified } }}</nz-tag>
              <nz-tag nzColor="red" *ngIf="group.summary.conflict">{{ 'PROPERTY_DISTRIBUTION_OVERVIEW.CONFLICT_COUNT' | translate:{ count: group.summary.conflict } }}</nz-tag>
              <nz-tag *ngIf="group.summary.missing">{{ 'PROPERTY_DISTRIBUTION_OVERVIEW.MISSING_COUNT' | translate:{ count: group.summary.missing } }}</nz-tag>
              <nz-tag nzColor="gold" *ngIf="group.summary.legacyMatch">{{ 'PROPERTY_BULK_APPLY.STATUS_LEGACY_MATCH' | translate }}: {{ group.summary.legacyMatch }}</nz-tag>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </ng-container>
</nz-modal>

<nz-modal
  [(nzVisible)]="distributionOverviewDetailsVisible"
  [nzTitle]="selectedDistributionOverviewGroup?.rootItemTitle || ('PROPERTY_DISTRIBUTION_OVERVIEW.DETAILS_TITLE' | translate)"
  [nzWidth]="860"
  [nzFooter]="null"
  (nzOnCancel)="closeDistributionOverviewDetails()"
>
  <ng-container *nzModalContent>
    <div class="distribution-overview">
      <div class="distribution-overview__helper">
        {{ 'PROPERTY_DISTRIBUTION_OVERVIEW.DETAILS_HELPER' | translate }}
      </div>

      <div class="distribution-overview__toolbar">
        <input
          nz-input
          [(ngModel)]="distributionOverviewDetailsSearchTerm"
          [ngModelOptions]="{ standalone: true }"
          [placeholder]="'PROPERTY_DISTRIBUTION_OVERVIEW.SEARCH_PROPERTIES' | translate"
        />
        <nz-radio-group
          class="distribution-overview__filters"
          [(ngModel)]="distributionOverviewDetailsStatusFilter"
          [ngModelOptions]="{ standalone: true }"
        >
          <label
            nz-radio-button
            *ngFor="let option of distributionOverviewDetailsFilterOptions"
            [nzValue]="option.value"
            nz-tooltip
            [nzTooltipTitle]="option.tooltipKey | translate"
          >
            {{ option.labelKey | translate }}
          </label>
        </nz-radio-group>
      </div>

      <div *ngIf="distributionOverviewDetailsLoading" class="distribution-overview__loading">
        {{ 'PROPERTY_DISTRIBUTION_OVERVIEW.LOADING' | translate }}
      </div>

      <ng-container *ngIf="!distributionOverviewDetailsLoading">
        <div *ngIf="!filteredDistributionOverviewDetailProperties.length" class="distribution-overview__empty">
          {{ 'PROPERTY_DISTRIBUTION_OVERVIEW.NO_PROPERTY_ROWS' | translate }}
        </div>
        <div *ngIf="filteredDistributionOverviewDetailProperties.length" class="distribution-overview__properties">
          <div
            class="distribution-overview__property"
            *ngFor="let property of filteredDistributionOverviewDetailProperties; trackBy: trackByDistributionOverviewProperty"
          >
            <div class="distribution-overview__property-main">
              <div class="distribution-overview__property-address">{{ property.address }}</div>
              <div class="distribution-overview__property-updated" *ngIf="property.updatedAt">
                {{ 'PROPERTY_DISTRIBUTION_OVERVIEW.UPDATED_AT' | translate }} {{ formatDistributionOverviewUpdatedAt(property.updatedAt) }}
              </div>
            </div>
            <nz-tag
              [nzColor]="getBulkDistributionStatusColor(property.status)"
              nz-tooltip
              [nzTooltipTitle]="getDistributionStatusTooltipKey(property.status) | translate"
            >
              {{ getBulkDistributionStatusLabelKey(property.status) | translate }}
            </nz-tag>
          </div>
        </div>
      </ng-container>
    </div>
  </ng-container>
</nz-modal>
<nz-modal
  [(nzVisible)]="emergencyInstructionIconPickerVisible"
  [nzTitle]="'PROPERTY_INSTRUCTIONS.ICON_LABEL' | translate"
  [nzWidth]="640"
  [nzFooter]="null"
  (nzOnCancel)="closeEmergencyInstructionIconPicker()"
>
  <ng-container *nzModalContent>
    <div class="instructions-icon-grid instructions-icon-grid--picker" *ngIf="emergencyInstructionIconPickerVisible">
      <button
        type="button"
        class="instructions-icon-grid__item"
        *ngFor="let icon of emergencyInstructionIconOptions; trackBy: trackByEmergencyInstructionIcon"
        [class.instructions-icon-grid__item--selected]="getSelectedEmergencyInstructionIconKey() === icon.key"
        (click)="selectEmergencyInstructionIcon(icon.key)"
        nz-tooltip
        [nzTooltipTitle]="icon.labelKey | translate"
      >
        <i nz-icon [nzType]="icon.iconType"></i>
        <span>{{ icon.labelKey | translate }}</span>
      </button>
    </div>
  </ng-container>
</nz-modal>

<ng-template #bulkApplyInstructionConfirmContent>
  <div class="property-bulk-apply-confirm">
    <p class="property-bulk-apply-confirm__message">
      {{ bulkApplyInstructionConfirmMessage }}
    </p>
    <p class="property-bulk-apply-confirm__note">
      {{ 'PROPERTY_BULK_APPLY.CONFIRM_INSTRUCTION_DOCUMENTS_NOTE' | translate }}
    </p>
  </div>
</ng-template>

<nz-modal
  [(nzVisible)]="bulkApplyModalVisible"
  [nzTitle]="bulkApplyPickerTitleKey | translate"
  [nzWidth]="760"
  [nzOkText]="bulkApplyConfirmButtonKey | translate"
  [nzCancelText]="'PROPERTY_BULK_APPLY.CANCEL_ACTION' | translate"
  [nzOkDisabled]="bulkApplyConfirmDisabled"
  [nzOkLoading]="bulkApplySubmitting"
  [nzOkDanger]="currentBulkAction === 'delete'"
  (nzOnCancel)="closeBulkApplyModal()"
  (nzAfterClose)="onBulkApplyModalAfterClose()"
  (nzOnOk)="confirmBulkApply()"
>
  <ng-container *nzModalContent>
    <div class="property-bulk-apply">
      <div class="property-bulk-apply__subtitle">
        {{ bulkApplyPickerDescriptionKey | translate }}
      </div>

      <div *ngIf="showBulkCopyBanner" class="property-bulk-apply__banner">
        <nz-alert
          [nzType]="bulkCopyBannerType"
          [nzMessage]="bulkCopyBannerKey ? (bulkCopyBannerKey | translate) : ''"
          nzShowIcon
        ></nz-alert>
        <div class="property-bulk-apply__banner-actions" *ngIf="showOpenSourcePropertyAction || showPromoteSourceAction || bulkApplyBlockedReasonKey">
          <button
            *ngIf="showOpenSourcePropertyAction"
            nz-button
            nzType="default"
            (click)="navigateToBulkSourceProperty($event)"
          >
            {{ 'PROPERTY_BULK_APPLY.OPEN_SOURCE_PROPERTY_ACTION' | translate }}
          </button>
          <button
            *ngIf="showPromoteSourceAction"
            nz-button
            nzType="primary"
            [nzLoading]="bulkPromoteSourceSubmitting"
            (click)="confirmPromoteBulkSource()"
          >
            {{ 'PROPERTY_BULK_APPLY.PROMOTE_SOURCE_ACTION' | translate }}
          </button>
          <div *ngIf="bulkApplyBlockedReasonKey" class="property-bulk-apply__banner-note">
            {{ bulkApplyBlockedReasonKey | translate }}
          </div>
        </div>
      </div>

      <div class="property-bulk-apply__summary">
        <div class="property-bulk-apply__summary-title">
          {{ 'PROPERTY_BULK_APPLY.SOURCE_ITEM' | translate }}
        </div>
        <div class="property-bulk-apply__summary-text property-bulk-apply__summary-text--emphasis">
          {{ bulkApplySourceActionSummary }}
        </div>
        <div class="property-bulk-apply__summary-meta">
          <span class="property-bulk-apply__summary-label">
            {{ 'PROPERTY_BULK_APPLY.SOURCE_PROPERTY' | translate }}
          </span>
          <span>{{ bulkApplySourcePropertyLabel }}</span>
        </div>
        <div class="property-bulk-apply__summary-meta">
          <span class="property-bulk-apply__summary-label">
            {{ 'PROPERTY_BULK_APPLY.ITEM_LABEL' | translate }}
          </span>
          <span>{{ bulkApplySourceTitle }}</span>
        </div>
        <div class="property-bulk-apply__summary-meta">
          <span class="property-bulk-apply__summary-label">
            {{ 'PROPERTY_BULK_APPLY.TYPE_LABEL' | translate }}
          </span>
          <span>{{ bulkApplySourceTypeKey | translate }}</span>
        </div>
        <div class="property-bulk-apply__summary-text">
          {{ bulkApplySourceSummary }}
        </div>
      </div>

      <div class="property-bulk-apply__helper">
        {{ 'PROPERTY_BULK_APPLY.STATUS_LEGEND' | translate }}
      </div>

      <nz-radio-group
        class="property-bulk-apply__scope-group"
        [(ngModel)]="bulkApplyScope"
        [ngModelOptions]="{ standalone: true }"
        (ngModelChange)="onBulkApplyScopeChange($event)"
      >
        <label nz-radio [nzValue]="'selected'">
          {{ 'PROPERTY_BULK_APPLY.SCOPE_SELECTED' | translate }}
        </label>
        <label nz-radio [nzValue]="'all'">
          {{ 'PROPERTY_BULK_APPLY.SCOPE_ALL' | translate }}
        </label>
      </nz-radio-group>

      <div class="property-bulk-apply__helper" *ngIf="bulkApplyScope === 'all'">
        {{
          (currentBulkAction === 'delete'
            ? 'PROPERTY_BULK_APPLY.ALL_DELETE_HELPER'
            : 'PROPERTY_BULK_APPLY.ALL_HELPER'
          ) | translate:{ count: bulkApplySelectedCount }
        }}
      </div>

      <div class="property-bulk-apply__selection" *ngIf="bulkApplyScope === 'selected'">
        <div class="property-bulk-apply__search-row">
          <input
            nz-input
            [(ngModel)]="bulkApplySearchTerm"
            [ngModelOptions]="{ standalone: true }"
            (ngModelChange)="onBulkApplySearchTermChange($event)"
            [placeholder]="'PROPERTY_BULK_APPLY.SEARCH_PLACEHOLDER' | translate"
          />
          <button
            nz-button
            nzType="link"
            [disabled]="!bulkApplySelectedPropertyIds.length"
            (click)="clearBulkApplySelection()"
          >
            {{ 'PROPERTY_BULK_APPLY.CLEAR_SELECTION' | translate }}
          </button>
        </div>

        <div class="property-bulk-apply__status-row">
          <div class="property-bulk-apply__status-loading" *ngIf="bulkDistributionStatusLoading">
            {{ 'PROPERTY_BULK_APPLY.DISTRIBUTION_STATUS_LOADING' | translate }}
          </div>
          <nz-radio-group
            *ngIf="!bulkDistributionStatusLoading"
            class="property-bulk-apply__status-filter"
            [ngModel]="bulkDistributionStatusFilter"
            [ngModelOptions]="{ standalone: true }"
            (ngModelChange)="onBulkDistributionStatusFilterChange($event)"
          >
            <label
              nz-radio-button
              *ngFor="let option of bulkDistributionStatusFilterOptions"
              [nzValue]="option.value"
              nz-tooltip
              [nzTooltipTitle]="option.tooltipKey | translate"
            >
              {{ option.labelKey | translate }}
            </label>
          </nz-radio-group>
        </div>

        <div class="property-bulk-apply__toolbar">
          <label
            nz-checkbox
            [ngModel]="bulkApplyAllFilteredSelected"
            [ngModelOptions]="{ standalone: true }"
            [nzDisabled]="!bulkApplySelectableFilteredPropertyIds.length"
            [nzIndeterminate]="bulkApplyPartiallyFilteredSelected"
            (ngModelChange)="toggleBulkApplyFilteredSelection($event)"
          >
            {{ 'PROPERTY_BULK_APPLY.SELECT_FILTERED' | translate:{ count: bulkApplySelectableFilteredPropertyIds.length } }}
          </label>

          <div class="property-bulk-apply__count">
            {{ 'PROPERTY_BULK_APPLY.SELECTED_COUNT' | translate:{ count: bulkApplySelectedPropertyIds.length } }}
          </div>
        </div>

        <div class="property-bulk-apply__list">
          <label
            *ngFor="let row of bulkApplyVisiblePropertyRows; trackBy: trackByBulkTargetPropertyRow"
            nz-checkbox
            class="property-bulk-apply__option"
            [class.property-bulk-apply__option--disabled]="row.disabled"
            [ngModel]="bulkApplySelectedPropertyIdSet.has(row.propertyId)"
            [ngModelOptions]="{ standalone: true }"
            [nzDisabled]="row.disabled"
            (ngModelChange)="toggleBulkApplyPropertySelection(row.propertyId, $event)"
          >
            <span class="property-bulk-apply__option-label">{{ row.label }}</span>
            <nz-tag
              *ngIf="row.status"
              class="property-bulk-apply__status-tag"
              [nzColor]="row.statusColor"
              nz-tooltip
              [nzTooltipTitle]="row.statusTooltipKey | translate"
            >
              {{ row.statusLabelKey | translate }}
            </nz-tag>
            <span
              *ngIf="row.disabledReasonKey as disabledReasonKey"
              class="property-bulk-apply__disabled-reason"
              nz-tooltip
              [nzTooltipTitle]="disabledReasonKey | translate"
            >
              {{ disabledReasonKey | translate }}
            </span>
            <span
              *ngIf="row.propertyId === bulkApplyCurrentPropertyId"
              class="property-bulk-apply__current"
            >
              {{ 'PROPERTY_BULK_APPLY.CURRENT_BADGE' | translate }}
            </span>
          </label>

          <div *ngIf="!bulkApplyVisiblePropertyRows.length" class="property-bulk-apply__empty">
            {{ 'PROPERTY_BULK_APPLY.NO_PROPERTIES' | translate }}
          </div>
        </div>
      </div>

      <div class="property-bulk-apply__summary">
        <div class="property-bulk-apply__summary-title">
          {{ 'PROPERTY_BULK_APPLY.AFFECTED_PROPERTIES' | translate:{ count: bulkApplySelectedCount } }}
        </div>
        <div class="property-bulk-apply__summary-text" *ngIf="bulkApplySelectionSummary">
          {{ bulkApplySelectionSummary }}
        </div>
        <div class="property-bulk-apply__summary-text" *ngIf="bulkApplyContext?.mode === 'document_section' && currentBulkAction === 'apply'">
          {{ 'PROPERTY_BULK_APPLY.DOCUMENT_RULE' | translate }}
        </div>
        <div class="property-bulk-apply__summary-text" *ngIf="bulkApplyContext?.mode === 'emergency_instruction' && currentBulkAction === 'apply'">
          {{ 'PROPERTY_BULK_APPLY.INSTRUCTION_RULE' | translate }}
        </div>
        <div class="property-bulk-apply__summary-text" *ngIf="currentBulkAction === 'edit'">
          {{ 'PROPERTY_BULK_APPLY.EDIT_RULE' | translate }}
        </div>
        <div class="property-bulk-apply__summary-text property-bulk-apply__summary-text--danger" *ngIf="currentBulkAction === 'delete'">
          {{ 'PROPERTY_BULK_APPLY.DELETE_RULE' | translate }}
        </div>
      </div>
    </div>
  </ng-container>
</nz-modal>
